export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	DateTime: { input: string; output: string };
};

export type ConditionBoolean = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Scalars['Boolean']['input']>>;
};

export type ConditionDateTime = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Scalars['DateTime']['input']>>;
};

export type ConditionFloat = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Scalars['Float']['input']>>;
};

export type ConditionFloatArray = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>>;
};

export type ConditionId = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type ConditionIdArray = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>>;
};

export type ConditionInt = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type ConditionString = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ConditionStringArray = {
	operator?: InputMaybe<ConditionOperators>;
	value: Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>;
};

export type Query = {
	__typename?: 'Query';
	core_label_issues?: Maybe<Array<Maybe<Core_Label_Issues>>>;
	issues?: Maybe<Array<Maybe<Issues>>>;
	mfa_scans_impacted_per_issue_severity?: Maybe<
		Array<Maybe<Mfa_Scans_Impacted_Per_Issue_Severity>>
	>;
	mfa_scans_impacted_per_issue_type?: Maybe<Array<Maybe<Mfa_Scans_Impacted_Per_Issue_Type>>>;
	mfa_session_runs?: Maybe<Array<Maybe<Mfa_Session_Runs>>>;
	mfa_test_by_issue_types?: Maybe<Array<Maybe<Mfa_Test_By_Issue_Types>>>;
	mfa_test_by_severity?: Maybe<Array<Maybe<Mfa_Test_By_Severity>>>;
	mfa_test_top_issue_types?: Maybe<Array<Maybe<Mfa_Test_Top_Issue_Types>>>;
	mfa_worst_performing_scans?: Maybe<Array<Maybe<Mfa_Worst_Performing_Scans>>>;
	msdk_report_runs?: Maybe<Array<Maybe<Msdk_Report_Runs>>>;
	msdk_report_runs_latest?: Maybe<Array<Maybe<Msdk_Report_Runs_Latest>>>;
	msdk_scans_impacted_per_issue_severity?: Maybe<
		Array<Maybe<Msdk_Scans_Impacted_Per_Issue_Severity>>
	>;
	msdk_scans_impacted_per_issue_type?: Maybe<Array<Maybe<Msdk_Scans_Impacted_Per_Issue_Type>>>;
	msdk_test_by_issue_types?: Maybe<Array<Maybe<Msdk_Test_By_Issue_Types>>>;
	msdk_test_by_severity?: Maybe<Array<Maybe<Msdk_Test_By_Severity>>>;
	msdk_test_runs?: Maybe<Array<Maybe<Msdk_Test_Runs>>>;
	msdk_test_runs_latest?: Maybe<Array<Maybe<Msdk_Test_Runs_Latest>>>;
	msdk_test_top_issue_types?: Maybe<Array<Maybe<Msdk_Test_Top_Issue_Types>>>;
	msdk_worst_performing_scans?: Maybe<Array<Maybe<Msdk_Worst_Performing_Scans>>>;
	pages?: Maybe<Array<Maybe<Pages>>>;
	scans?: Maybe<Array<Maybe<Scans>>>;
	score_web_products?: Maybe<Array<Maybe<Score_Web_Products>>>;
	uniqueness_issues?: Maybe<Array<Maybe<Uniqueness_Issues>>>;
	wfa_session_components_runs?: Maybe<Array<Maybe<Wfa_Session_Components_Runs>>>;
	wfa_session_run_labels?: Maybe<Array<Maybe<Wfa_Session_Run_Labels>>>;
	wfa_session_runs?: Maybe<Array<Maybe<Wfa_Session_Runs>>>;
	wfa_session_type_runs?: Maybe<Array<Maybe<Wfa_Session_Type_Runs>>>;
	wfa_top_critical_components?: Maybe<Array<Maybe<Wfa_Top_Critical_Components>>>;
	wsdk_latest_test_runs?: Maybe<Array<Maybe<Wsdk_Latest_Test_Runs>>>;
	wsdk_test_labels?: Maybe<Array<Maybe<Wsdk_Test_Labels>>>;
	wsdk_test_runs?: Maybe<Array<Maybe<Wsdk_Test_Runs>>>;
};

export type QueryCore_Label_IssuesArgs = {
	and?: InputMaybe<Array<Core_Label_IssuesAndFilter>>;
	business_unit_eq?: InputMaybe<ConditionString>;
	business_unit_ge?: InputMaybe<ConditionString>;
	business_unit_gt?: InputMaybe<ConditionString>;
	business_unit_le?: InputMaybe<ConditionString>;
	business_unit_lt?: InputMaybe<ConditionString>;
	business_unit_ne?: InputMaybe<ConditionString>;
	deleted_eq?: InputMaybe<ConditionBoolean>;
	deleted_ge?: InputMaybe<ConditionBoolean>;
	deleted_gt?: InputMaybe<ConditionBoolean>;
	deleted_le?: InputMaybe<ConditionBoolean>;
	deleted_lt?: InputMaybe<ConditionBoolean>;
	deleted_ne?: InputMaybe<ConditionBoolean>;
	environment_eq?: InputMaybe<ConditionString>;
	environment_ge?: InputMaybe<ConditionString>;
	environment_gt?: InputMaybe<ConditionString>;
	environment_le?: InputMaybe<ConditionString>;
	environment_lt?: InputMaybe<ConditionString>;
	environment_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<Core_Label_IssuesGroup>>>;
	issue_id_eq?: InputMaybe<ConditionId>;
	issue_id_ge?: InputMaybe<ConditionId>;
	issue_id_gt?: InputMaybe<ConditionId>;
	issue_id_le?: InputMaybe<ConditionId>;
	issue_id_lt?: InputMaybe<ConditionId>;
	issue_id_ne?: InputMaybe<ConditionId>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Core_Label_IssuesOrFilter>>;
	page_title_eq?: InputMaybe<ConditionString>;
	page_title_ge?: InputMaybe<ConditionString>;
	page_title_gt?: InputMaybe<ConditionString>;
	page_title_le?: InputMaybe<ConditionString>;
	page_title_lt?: InputMaybe<ConditionString>;
	page_title_ne?: InputMaybe<ConditionString>;
	product_name_eq?: InputMaybe<ConditionString>;
	product_name_ge?: InputMaybe<ConditionString>;
	product_name_gt?: InputMaybe<ConditionString>;
	product_name_le?: InputMaybe<ConditionString>;
	product_name_lt?: InputMaybe<ConditionString>;
	product_name_ne?: InputMaybe<ConditionString>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	session_name_eq?: InputMaybe<ConditionString>;
	session_name_ge?: InputMaybe<ConditionString>;
	session_name_gt?: InputMaybe<ConditionString>;
	session_name_le?: InputMaybe<ConditionString>;
	session_name_lt?: InputMaybe<ConditionString>;
	session_name_ne?: InputMaybe<ConditionString>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Core_Label_IssuesSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_equals?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<Core_Label_IssuesSearch>;
	text_starts_with?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
	url_eq?: InputMaybe<ConditionString>;
	url_ge?: InputMaybe<ConditionString>;
	url_gt?: InputMaybe<ConditionString>;
	url_le?: InputMaybe<ConditionString>;
	url_lt?: InputMaybe<ConditionString>;
	url_ne?: InputMaybe<ConditionString>;
	user_name_eq?: InputMaybe<ConditionString>;
	user_name_ge?: InputMaybe<ConditionString>;
	user_name_gt?: InputMaybe<ConditionString>;
	user_name_le?: InputMaybe<ConditionString>;
	user_name_lt?: InputMaybe<ConditionString>;
	user_name_ne?: InputMaybe<ConditionString>;
	validation_status_eq?: InputMaybe<ConditionString>;
	validation_status_ge?: InputMaybe<ConditionString>;
	validation_status_gt?: InputMaybe<ConditionString>;
	validation_status_le?: InputMaybe<ConditionString>;
	validation_status_lt?: InputMaybe<ConditionString>;
	validation_status_ne?: InputMaybe<ConditionString>;
	version_eq?: InputMaybe<ConditionInt>;
	version_ge?: InputMaybe<ConditionInt>;
	version_gt?: InputMaybe<ConditionInt>;
	version_le?: InputMaybe<ConditionInt>;
	version_lt?: InputMaybe<ConditionInt>;
	version_ne?: InputMaybe<ConditionInt>;
};

export type QueryIssuesArgs = {
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	analysis_time_eq?: InputMaybe<ConditionDateTime>;
	analysis_time_ge?: InputMaybe<ConditionDateTime>;
	analysis_time_gt?: InputMaybe<ConditionDateTime>;
	analysis_time_last_n_days?: InputMaybe<ConditionInt>;
	analysis_time_le?: InputMaybe<ConditionDateTime>;
	analysis_time_lt?: InputMaybe<ConditionDateTime>;
	analysis_time_ne?: InputMaybe<ConditionDateTime>;
	and?: InputMaybe<Array<IssuesAndFilter>>;
	app_build_number_eq?: InputMaybe<ConditionString>;
	app_build_number_ge?: InputMaybe<ConditionString>;
	app_build_number_gt?: InputMaybe<ConditionString>;
	app_build_number_le?: InputMaybe<ConditionString>;
	app_build_number_lt?: InputMaybe<ConditionString>;
	app_build_number_ne?: InputMaybe<ConditionString>;
	app_eq?: InputMaybe<ConditionString>;
	app_ge?: InputMaybe<ConditionString>;
	app_gt?: InputMaybe<ConditionString>;
	app_id_eq?: InputMaybe<ConditionString>;
	app_id_ge?: InputMaybe<ConditionString>;
	app_id_gt?: InputMaybe<ConditionString>;
	app_id_le?: InputMaybe<ConditionString>;
	app_id_lt?: InputMaybe<ConditionString>;
	app_id_ne?: InputMaybe<ConditionString>;
	app_le?: InputMaybe<ConditionString>;
	app_lt?: InputMaybe<ConditionString>;
	app_ne?: InputMaybe<ConditionString>;
	app_version_eq?: InputMaybe<ConditionString>;
	app_version_ge?: InputMaybe<ConditionString>;
	app_version_gt?: InputMaybe<ConditionString>;
	app_version_le?: InputMaybe<ConditionString>;
	app_version_lt?: InputMaybe<ConditionString>;
	app_version_ne?: InputMaybe<ConditionString>;
	axe_additional_information_eq?: InputMaybe<ConditionString>;
	axe_additional_information_ge?: InputMaybe<ConditionString>;
	axe_additional_information_gt?: InputMaybe<ConditionString>;
	axe_additional_information_le?: InputMaybe<ConditionString>;
	axe_additional_information_lt?: InputMaybe<ConditionString>;
	axe_additional_information_ne?: InputMaybe<ConditionString>;
	canonical_url_eq?: InputMaybe<ConditionString>;
	canonical_url_ge?: InputMaybe<ConditionString>;
	canonical_url_gt?: InputMaybe<ConditionString>;
	canonical_url_le?: InputMaybe<ConditionString>;
	canonical_url_lt?: InputMaybe<ConditionString>;
	canonical_url_ne?: InputMaybe<ConditionString>;
	client_version_eq?: InputMaybe<ConditionString>;
	client_version_ge?: InputMaybe<ConditionString>;
	client_version_gt?: InputMaybe<ConditionString>;
	client_version_le?: InputMaybe<ConditionString>;
	client_version_lt?: InputMaybe<ConditionString>;
	client_version_ne?: InputMaybe<ConditionString>;
	companion_app_version_eq?: InputMaybe<ConditionString>;
	companion_app_version_ge?: InputMaybe<ConditionString>;
	companion_app_version_gt?: InputMaybe<ConditionString>;
	companion_app_version_le?: InputMaybe<ConditionString>;
	companion_app_version_lt?: InputMaybe<ConditionString>;
	companion_app_version_ne?: InputMaybe<ConditionString>;
	conformance_eq_any_item?: InputMaybe<ConditionString>;
	conformance_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_ge_any_item?: InputMaybe<ConditionString>;
	conformance_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_gt_any_item?: InputMaybe<ConditionString>;
	conformance_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_le_any_item?: InputMaybe<ConditionString>;
	conformance_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_lt_any_item?: InputMaybe<ConditionString>;
	conformance_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_ne_any_item?: InputMaybe<ConditionString>;
	conformance_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	deleted_eq?: InputMaybe<ConditionBoolean>;
	deleted_ge?: InputMaybe<ConditionBoolean>;
	deleted_gt?: InputMaybe<ConditionBoolean>;
	deleted_le?: InputMaybe<ConditionBoolean>;
	deleted_lt?: InputMaybe<ConditionBoolean>;
	deleted_ne?: InputMaybe<ConditionBoolean>;
	description_eq?: InputMaybe<ConditionString>;
	description_ge?: InputMaybe<ConditionString>;
	description_gt?: InputMaybe<ConditionString>;
	description_le?: InputMaybe<ConditionString>;
	description_lt?: InputMaybe<ConditionString>;
	description_ne?: InputMaybe<ConditionString>;
	description_screenshot_ids_eq_any_item?: InputMaybe<ConditionString>;
	description_screenshot_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_ge_any_item?: InputMaybe<ConditionString>;
	description_screenshot_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_gt_any_item?: InputMaybe<ConditionString>;
	description_screenshot_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_le_any_item?: InputMaybe<ConditionString>;
	description_screenshot_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_lt_any_item?: InputMaybe<ConditionString>;
	description_screenshot_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_ne_any_item?: InputMaybe<ConditionString>;
	description_screenshot_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	description_screenshot_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	device_manufacturer_le?: InputMaybe<ConditionString>;
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	device_model_eq?: InputMaybe<ConditionString>;
	device_model_ge?: InputMaybe<ConditionString>;
	device_model_gt?: InputMaybe<ConditionString>;
	device_model_le?: InputMaybe<ConditionString>;
	device_model_lt?: InputMaybe<ConditionString>;
	device_model_ne?: InputMaybe<ConditionString>;
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	device_personalized_name_le?: InputMaybe<ConditionString>;
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	device_type_eq?: InputMaybe<ConditionString>;
	device_type_ge?: InputMaybe<ConditionString>;
	device_type_gt?: InputMaybe<ConditionString>;
	device_type_le?: InputMaybe<ConditionString>;
	device_type_lt?: InputMaybe<ConditionString>;
	device_type_ne?: InputMaybe<ConditionString>;
	domain_eq?: InputMaybe<ConditionString>;
	domain_ge?: InputMaybe<ConditionString>;
	domain_gt?: InputMaybe<ConditionString>;
	domain_le?: InputMaybe<ConditionString>;
	domain_lt?: InputMaybe<ConditionString>;
	domain_ne?: InputMaybe<ConditionString>;
	duplicates_eq?: InputMaybe<ConditionString>;
	duplicates_ge?: InputMaybe<ConditionString>;
	duplicates_gt?: InputMaybe<ConditionString>;
	duplicates_le?: InputMaybe<ConditionString>;
	duplicates_lt?: InputMaybe<ConditionString>;
	duplicates_ne?: InputMaybe<ConditionString>;
	elements__accessibility_identifier_eq_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_identifier_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_ge_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_identifier_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_gt_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_identifier_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_le_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_identifier_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_lt_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_identifier_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_ne_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_identifier_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_identifier_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_eq_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_label_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_ge_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_label_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_gt_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_label_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_le_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_label_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_lt_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_label_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_ne_any_item?: InputMaybe<ConditionString>;
	elements__accessibility_label_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__accessibility_label_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__bounding_box_bottom_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_bottom_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_bottom_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_bottom_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_bottom_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_bottom_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_bottom_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_bottom_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_height_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_height_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_height_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_height_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_height_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_height_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_height_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_left_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_left_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_left_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_left_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_left_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_left_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_left_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_right_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_right_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_right_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_right_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_right_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_right_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_right_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_top_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_top_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_top_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_top_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_top_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_top_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_top_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_width_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_width_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_width_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_width_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_width_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_width_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_width_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_x_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_x_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_x_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_x_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_x_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_x_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_x_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_eq_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_y_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_ge_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_y_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_gt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_y_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_le_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_y_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_lt_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_y_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_ne_any_item?: InputMaybe<ConditionFloat>;
	elements__bounding_box_y_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	elements__bounding_box_y_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	elements__canonical_url_eq_any_item?: InputMaybe<ConditionString>;
	elements__canonical_url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_ge_any_item?: InputMaybe<ConditionString>;
	elements__canonical_url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_gt_any_item?: InputMaybe<ConditionString>;
	elements__canonical_url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_le_any_item?: InputMaybe<ConditionString>;
	elements__canonical_url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_lt_any_item?: InputMaybe<ConditionString>;
	elements__canonical_url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_ne_any_item?: InputMaybe<ConditionString>;
	elements__canonical_url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__canonical_url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__class_name_eq_any_item?: InputMaybe<ConditionString>;
	elements__class_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__class_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__class_name_ge_any_item?: InputMaybe<ConditionString>;
	elements__class_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__class_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__class_name_gt_any_item?: InputMaybe<ConditionString>;
	elements__class_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__class_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__class_name_le_any_item?: InputMaybe<ConditionString>;
	elements__class_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__class_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__class_name_lt_any_item?: InputMaybe<ConditionString>;
	elements__class_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__class_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__class_name_ne_any_item?: InputMaybe<ConditionString>;
	elements__class_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__class_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__component_id_eq_any_item?: InputMaybe<ConditionString>;
	elements__component_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__component_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__component_id_ge_any_item?: InputMaybe<ConditionString>;
	elements__component_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__component_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__component_id_gt_any_item?: InputMaybe<ConditionString>;
	elements__component_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__component_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__component_id_le_any_item?: InputMaybe<ConditionString>;
	elements__component_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__component_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__component_id_lt_any_item?: InputMaybe<ConditionString>;
	elements__component_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__component_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__component_id_ne_any_item?: InputMaybe<ConditionString>;
	elements__component_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__component_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__content_description_eq_any_item?: InputMaybe<ConditionString>;
	elements__content_description_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__content_description_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__content_description_ge_any_item?: InputMaybe<ConditionString>;
	elements__content_description_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__content_description_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__content_description_gt_any_item?: InputMaybe<ConditionString>;
	elements__content_description_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__content_description_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__content_description_le_any_item?: InputMaybe<ConditionString>;
	elements__content_description_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__content_description_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__content_description_lt_any_item?: InputMaybe<ConditionString>;
	elements__content_description_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__content_description_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__content_description_ne_any_item?: InputMaybe<ConditionString>;
	elements__content_description_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__content_description_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_eq_any_item?: InputMaybe<ConditionString>;
	elements__dom_snippet_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_ge_any_item?: InputMaybe<ConditionString>;
	elements__dom_snippet_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_gt_any_item?: InputMaybe<ConditionString>;
	elements__dom_snippet_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_le_any_item?: InputMaybe<ConditionString>;
	elements__dom_snippet_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_lt_any_item?: InputMaybe<ConditionString>;
	elements__dom_snippet_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_ne_any_item?: InputMaybe<ConditionString>;
	elements__dom_snippet_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__dom_snippet_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__element_type_eq_any_item?: InputMaybe<ConditionString>;
	elements__element_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__element_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__element_type_ge_any_item?: InputMaybe<ConditionString>;
	elements__element_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__element_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__element_type_gt_any_item?: InputMaybe<ConditionString>;
	elements__element_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__element_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__element_type_le_any_item?: InputMaybe<ConditionString>;
	elements__element_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__element_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__element_type_lt_any_item?: InputMaybe<ConditionString>;
	elements__element_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__element_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__element_type_ne_any_item?: InputMaybe<ConditionString>;
	elements__element_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__element_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__id_eq_any_item?: InputMaybe<ConditionId>;
	elements__id_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	elements__id_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	elements__id_ge_any_item?: InputMaybe<ConditionId>;
	elements__id_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	elements__id_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	elements__id_gt_any_item?: InputMaybe<ConditionId>;
	elements__id_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	elements__id_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	elements__id_le_any_item?: InputMaybe<ConditionId>;
	elements__id_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	elements__id_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	elements__id_lt_any_item?: InputMaybe<ConditionId>;
	elements__id_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	elements__id_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	elements__id_ne_any_item?: InputMaybe<ConditionId>;
	elements__id_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	elements__id_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	elements__index_eq_any_item?: InputMaybe<ConditionString>;
	elements__index_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__index_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__index_ge_any_item?: InputMaybe<ConditionString>;
	elements__index_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__index_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__index_gt_any_item?: InputMaybe<ConditionString>;
	elements__index_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__index_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__index_le_any_item?: InputMaybe<ConditionString>;
	elements__index_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__index_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__index_lt_any_item?: InputMaybe<ConditionString>;
	elements__index_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__index_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__index_ne_any_item?: InputMaybe<ConditionString>;
	elements__index_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__index_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_title_eq_any_item?: InputMaybe<ConditionString>;
	elements__page_title_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_title_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_title_ge_any_item?: InputMaybe<ConditionString>;
	elements__page_title_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_title_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_title_gt_any_item?: InputMaybe<ConditionString>;
	elements__page_title_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_title_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_title_le_any_item?: InputMaybe<ConditionString>;
	elements__page_title_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_title_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_title_lt_any_item?: InputMaybe<ConditionString>;
	elements__page_title_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_title_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_title_ne_any_item?: InputMaybe<ConditionString>;
	elements__page_title_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_title_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_url_eq_any_item?: InputMaybe<ConditionString>;
	elements__page_url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_url_ge_any_item?: InputMaybe<ConditionString>;
	elements__page_url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_url_gt_any_item?: InputMaybe<ConditionString>;
	elements__page_url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_url_le_any_item?: InputMaybe<ConditionString>;
	elements__page_url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_url_lt_any_item?: InputMaybe<ConditionString>;
	elements__page_url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__page_url_ne_any_item?: InputMaybe<ConditionString>;
	elements__page_url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__page_url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__selector_eq_any_item?: InputMaybe<ConditionString>;
	elements__selector_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__selector_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__selector_ge_any_item?: InputMaybe<ConditionString>;
	elements__selector_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__selector_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__selector_gt_any_item?: InputMaybe<ConditionString>;
	elements__selector_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__selector_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__selector_le_any_item?: InputMaybe<ConditionString>;
	elements__selector_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__selector_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__selector_lt_any_item?: InputMaybe<ConditionString>;
	elements__selector_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__selector_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__selector_ne_any_item?: InputMaybe<ConditionString>;
	elements__selector_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__selector_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_eq_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_ge_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_gt_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_le_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_lt_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_ne_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_eq_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_role_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_ge_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_role_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_gt_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_role_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_le_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_role_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_lt_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_role_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_ne_any_item?: InputMaybe<ConditionString>;
	elements__signature_accessible_role_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_accessible_role_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_eq_any_item?: InputMaybe<ConditionString>;
	elements__signature_semantic_path_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_ge_any_item?: InputMaybe<ConditionString>;
	elements__signature_semantic_path_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_gt_any_item?: InputMaybe<ConditionString>;
	elements__signature_semantic_path_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_le_any_item?: InputMaybe<ConditionString>;
	elements__signature_semantic_path_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_lt_any_item?: InputMaybe<ConditionString>;
	elements__signature_semantic_path_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_ne_any_item?: InputMaybe<ConditionString>;
	elements__signature_semantic_path_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_semantic_path_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_eq_any_item?: InputMaybe<ConditionString>;
	elements__signature_xpath_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_ge_any_item?: InputMaybe<ConditionString>;
	elements__signature_xpath_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_gt_any_item?: InputMaybe<ConditionString>;
	elements__signature_xpath_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_le_any_item?: InputMaybe<ConditionString>;
	elements__signature_xpath_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_lt_any_item?: InputMaybe<ConditionString>;
	elements__signature_xpath_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_ne_any_item?: InputMaybe<ConditionString>;
	elements__signature_xpath_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__signature_xpath_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__view_id_eq_any_item?: InputMaybe<ConditionString>;
	elements__view_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__view_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__view_id_ge_any_item?: InputMaybe<ConditionString>;
	elements__view_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__view_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__view_id_gt_any_item?: InputMaybe<ConditionString>;
	elements__view_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__view_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__view_id_le_any_item?: InputMaybe<ConditionString>;
	elements__view_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__view_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__view_id_lt_any_item?: InputMaybe<ConditionString>;
	elements__view_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__view_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	elements__view_id_ne_any_item?: InputMaybe<ConditionString>;
	elements__view_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	elements__view_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	engines_version_eq?: InputMaybe<ConditionString>;
	engines_version_ge?: InputMaybe<ConditionString>;
	engines_version_gt?: InputMaybe<ConditionString>;
	engines_version_le?: InputMaybe<ConditionString>;
	engines_version_lt?: InputMaybe<ConditionString>;
	engines_version_ne?: InputMaybe<ConditionString>;
	environment_eq?: InputMaybe<ConditionString>;
	environment_ge?: InputMaybe<ConditionString>;
	environment_gt?: InputMaybe<ConditionString>;
	environment_le?: InputMaybe<ConditionString>;
	environment_lt?: InputMaybe<ConditionString>;
	environment_ne?: InputMaybe<ConditionString>;
	flow_eq?: InputMaybe<ConditionString>;
	flow_ge?: InputMaybe<ConditionString>;
	flow_gt?: InputMaybe<ConditionString>;
	flow_le?: InputMaybe<ConditionString>;
	flow_lt?: InputMaybe<ConditionString>;
	flow_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<IssuesGroup>>>;
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	issue_id_eq?: InputMaybe<ConditionId>;
	issue_id_ge?: InputMaybe<ConditionId>;
	issue_id_gt?: InputMaybe<ConditionId>;
	issue_id_le?: InputMaybe<ConditionId>;
	issue_id_lt?: InputMaybe<ConditionId>;
	issue_id_ne?: InputMaybe<ConditionId>;
	issue_index_eq?: InputMaybe<ConditionString>;
	issue_index_ge?: InputMaybe<ConditionString>;
	issue_index_gt?: InputMaybe<ConditionString>;
	issue_index_le?: InputMaybe<ConditionString>;
	issue_index_lt?: InputMaybe<ConditionString>;
	issue_index_ne?: InputMaybe<ConditionString>;
	knowledge_base_link_eq?: InputMaybe<ConditionString>;
	knowledge_base_link_ge?: InputMaybe<ConditionString>;
	knowledge_base_link_gt?: InputMaybe<ConditionString>;
	knowledge_base_link_le?: InputMaybe<ConditionString>;
	knowledge_base_link_lt?: InputMaybe<ConditionString>;
	knowledge_base_link_ne?: InputMaybe<ConditionString>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	metadata_eq?: InputMaybe<ConditionString>;
	metadata_ge?: InputMaybe<ConditionString>;
	metadata_gt?: InputMaybe<ConditionString>;
	metadata_le?: InputMaybe<ConditionString>;
	metadata_lt?: InputMaybe<ConditionString>;
	metadata_ne?: InputMaybe<ConditionString>;
	mobile_kit_eq?: InputMaybe<ConditionBoolean>;
	mobile_kit_ge?: InputMaybe<ConditionBoolean>;
	mobile_kit_gt?: InputMaybe<ConditionBoolean>;
	mobile_kit_le?: InputMaybe<ConditionBoolean>;
	mobile_kit_lt?: InputMaybe<ConditionBoolean>;
	mobile_kit_ne?: InputMaybe<ConditionBoolean>;
	note_creation_time_eq?: InputMaybe<ConditionDateTime>;
	note_creation_time_ge?: InputMaybe<ConditionDateTime>;
	note_creation_time_gt?: InputMaybe<ConditionDateTime>;
	note_creation_time_last_n_days?: InputMaybe<ConditionInt>;
	note_creation_time_le?: InputMaybe<ConditionDateTime>;
	note_creation_time_lt?: InputMaybe<ConditionDateTime>;
	note_creation_time_ne?: InputMaybe<ConditionDateTime>;
	note_eq?: InputMaybe<ConditionString>;
	note_ge?: InputMaybe<ConditionString>;
	note_gt?: InputMaybe<ConditionString>;
	note_le?: InputMaybe<ConditionString>;
	note_lt?: InputMaybe<ConditionString>;
	note_ne?: InputMaybe<ConditionString>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<IssuesOrFilter>>;
	os_eq?: InputMaybe<ConditionString>;
	os_ge?: InputMaybe<ConditionString>;
	os_gt?: InputMaybe<ConditionString>;
	os_le?: InputMaybe<ConditionString>;
	os_lt?: InputMaybe<ConditionString>;
	os_ne?: InputMaybe<ConditionString>;
	os_version_eq?: InputMaybe<ConditionString>;
	os_version_ge?: InputMaybe<ConditionString>;
	os_version_gt?: InputMaybe<ConditionString>;
	os_version_le?: InputMaybe<ConditionString>;
	os_version_lt?: InputMaybe<ConditionString>;
	os_version_ne?: InputMaybe<ConditionString>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	owner_type_eq?: InputMaybe<ConditionString>;
	owner_type_ge?: InputMaybe<ConditionString>;
	owner_type_gt?: InputMaybe<ConditionString>;
	owner_type_le?: InputMaybe<ConditionString>;
	owner_type_lt?: InputMaybe<ConditionString>;
	owner_type_ne?: InputMaybe<ConditionString>;
	page_id_eq?: InputMaybe<ConditionId>;
	page_id_ge?: InputMaybe<ConditionId>;
	page_id_gt?: InputMaybe<ConditionId>;
	page_id_le?: InputMaybe<ConditionId>;
	page_id_lt?: InputMaybe<ConditionId>;
	page_id_ne?: InputMaybe<ConditionId>;
	page_title_eq?: InputMaybe<ConditionString>;
	page_title_ge?: InputMaybe<ConditionString>;
	page_title_gt?: InputMaybe<ConditionString>;
	page_title_le?: InputMaybe<ConditionString>;
	page_title_lt?: InputMaybe<ConditionString>;
	page_title_ne?: InputMaybe<ConditionString>;
	product_id_eq?: InputMaybe<ConditionId>;
	product_id_ge?: InputMaybe<ConditionId>;
	product_id_gt?: InputMaybe<ConditionId>;
	product_id_le?: InputMaybe<ConditionId>;
	product_id_lt?: InputMaybe<ConditionId>;
	product_id_ne?: InputMaybe<ConditionId>;
	product_name_eq?: InputMaybe<ConditionString>;
	product_name_ge?: InputMaybe<ConditionString>;
	product_name_gt?: InputMaybe<ConditionString>;
	product_name_le?: InputMaybe<ConditionString>;
	product_name_lt?: InputMaybe<ConditionString>;
	product_name_ne?: InputMaybe<ConditionString>;
	product_version_eq?: InputMaybe<ConditionString>;
	product_version_ge?: InputMaybe<ConditionString>;
	product_version_gt?: InputMaybe<ConditionString>;
	product_version_le?: InputMaybe<ConditionString>;
	product_version_lt?: InputMaybe<ConditionString>;
	product_version_ne?: InputMaybe<ConditionString>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	regulations__id_eq_any_item?: InputMaybe<ConditionString>;
	regulations__id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__id_ge_any_item?: InputMaybe<ConditionString>;
	regulations__id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__id_gt_any_item?: InputMaybe<ConditionString>;
	regulations__id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__id_le_any_item?: InputMaybe<ConditionString>;
	regulations__id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__id_lt_any_item?: InputMaybe<ConditionString>;
	regulations__id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__id_ne_any_item?: InputMaybe<ConditionString>;
	regulations__id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__name_eq_any_item?: InputMaybe<ConditionString>;
	regulations__name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__name_ge_any_item?: InputMaybe<ConditionString>;
	regulations__name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__name_gt_any_item?: InputMaybe<ConditionString>;
	regulations__name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__name_le_any_item?: InputMaybe<ConditionString>;
	regulations__name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__name_lt_any_item?: InputMaybe<ConditionString>;
	regulations__name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__name_ne_any_item?: InputMaybe<ConditionString>;
	regulations__name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_eq_any_item?: InputMaybe<ConditionString>;
	regulations__success_criteria_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_ge_any_item?: InputMaybe<ConditionString>;
	regulations__success_criteria_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_gt_any_item?: InputMaybe<ConditionString>;
	regulations__success_criteria_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_le_any_item?: InputMaybe<ConditionString>;
	regulations__success_criteria_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_lt_any_item?: InputMaybe<ConditionString>;
	regulations__success_criteria_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_ne_any_item?: InputMaybe<ConditionString>;
	regulations__success_criteria_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__success_criteria_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__type_eq_any_item?: InputMaybe<ConditionString>;
	regulations__type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__type_ge_any_item?: InputMaybe<ConditionString>;
	regulations__type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__type_gt_any_item?: InputMaybe<ConditionString>;
	regulations__type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__type_le_any_item?: InputMaybe<ConditionString>;
	regulations__type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__type_lt_any_item?: InputMaybe<ConditionString>;
	regulations__type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__type_ne_any_item?: InputMaybe<ConditionString>;
	regulations__type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__url_eq_any_item?: InputMaybe<ConditionString>;
	regulations__url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__url_ge_any_item?: InputMaybe<ConditionString>;
	regulations__url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__url_gt_any_item?: InputMaybe<ConditionString>;
	regulations__url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__url_le_any_item?: InputMaybe<ConditionString>;
	regulations__url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__url_lt_any_item?: InputMaybe<ConditionString>;
	regulations__url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	regulations__url_ne_any_item?: InputMaybe<ConditionString>;
	regulations__url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	regulations__url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_metadata_eq?: InputMaybe<ConditionString>;
	run_metadata_ge?: InputMaybe<ConditionString>;
	run_metadata_gt?: InputMaybe<ConditionString>;
	run_metadata_le?: InputMaybe<ConditionString>;
	run_metadata_lt?: InputMaybe<ConditionString>;
	run_metadata_ne?: InputMaybe<ConditionString>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	scan_id_eq?: InputMaybe<ConditionId>;
	scan_id_ge?: InputMaybe<ConditionId>;
	scan_id_gt?: InputMaybe<ConditionId>;
	scan_id_le?: InputMaybe<ConditionId>;
	scan_id_lt?: InputMaybe<ConditionId>;
	scan_id_ne?: InputMaybe<ConditionId>;
	scan_name_eq?: InputMaybe<ConditionString>;
	scan_name_ge?: InputMaybe<ConditionString>;
	scan_name_gt?: InputMaybe<ConditionString>;
	scan_name_le?: InputMaybe<ConditionString>;
	scan_name_lt?: InputMaybe<ConditionString>;
	scan_name_ne?: InputMaybe<ConditionString>;
	screenshot_eq?: InputMaybe<ConditionString>;
	screenshot_ge?: InputMaybe<ConditionString>;
	screenshot_gt?: InputMaybe<ConditionString>;
	screenshot_le?: InputMaybe<ConditionString>;
	screenshot_lt?: InputMaybe<ConditionString>;
	screenshot_metadata_eq?: InputMaybe<ConditionString>;
	screenshot_metadata_ge?: InputMaybe<ConditionString>;
	screenshot_metadata_gt?: InputMaybe<ConditionString>;
	screenshot_metadata_le?: InputMaybe<ConditionString>;
	screenshot_metadata_lt?: InputMaybe<ConditionString>;
	screenshot_metadata_ne?: InputMaybe<ConditionString>;
	screenshot_ne?: InputMaybe<ConditionString>;
	sdk_type_eq?: InputMaybe<ConditionString>;
	sdk_type_ge?: InputMaybe<ConditionString>;
	sdk_type_gt?: InputMaybe<ConditionString>;
	sdk_type_le?: InputMaybe<ConditionString>;
	sdk_type_lt?: InputMaybe<ConditionString>;
	sdk_type_ne?: InputMaybe<ConditionString>;
	session_name_eq?: InputMaybe<ConditionString>;
	session_name_ge?: InputMaybe<ConditionString>;
	session_name_gt?: InputMaybe<ConditionString>;
	session_name_le?: InputMaybe<ConditionString>;
	session_name_lt?: InputMaybe<ConditionString>;
	session_name_ne?: InputMaybe<ConditionString>;
	severity_id_eq?: InputMaybe<ConditionString>;
	severity_id_ge?: InputMaybe<ConditionString>;
	severity_id_gt?: InputMaybe<ConditionString>;
	severity_id_le?: InputMaybe<ConditionString>;
	severity_id_lt?: InputMaybe<ConditionString>;
	severity_id_ne?: InputMaybe<ConditionString>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	signature_eq?: InputMaybe<ConditionString>;
	signature_ge?: InputMaybe<ConditionString>;
	signature_gt?: InputMaybe<ConditionString>;
	signature_le?: InputMaybe<ConditionString>;
	signature_lt?: InputMaybe<ConditionString>;
	signature_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<IssuesSort>;
	summary_eq?: InputMaybe<ConditionString>;
	summary_ge?: InputMaybe<ConditionString>;
	summary_gt?: InputMaybe<ConditionString>;
	summary_le?: InputMaybe<ConditionString>;
	summary_lt?: InputMaybe<ConditionString>;
	summary_ne?: InputMaybe<ConditionString>;
	tags__description_eq_any_item?: InputMaybe<ConditionString>;
	tags__description_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__description_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__description_ge_any_item?: InputMaybe<ConditionString>;
	tags__description_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__description_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__description_gt_any_item?: InputMaybe<ConditionString>;
	tags__description_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__description_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__description_le_any_item?: InputMaybe<ConditionString>;
	tags__description_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__description_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__description_lt_any_item?: InputMaybe<ConditionString>;
	tags__description_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__description_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__description_ne_any_item?: InputMaybe<ConditionString>;
	tags__description_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__description_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__id_eq_any_item?: InputMaybe<ConditionString>;
	tags__id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__id_ge_any_item?: InputMaybe<ConditionString>;
	tags__id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__id_gt_any_item?: InputMaybe<ConditionString>;
	tags__id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__id_le_any_item?: InputMaybe<ConditionString>;
	tags__id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__id_lt_any_item?: InputMaybe<ConditionString>;
	tags__id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__id_ne_any_item?: InputMaybe<ConditionString>;
	tags__id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__link_eq_any_item?: InputMaybe<ConditionString>;
	tags__link_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__link_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__link_ge_any_item?: InputMaybe<ConditionString>;
	tags__link_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__link_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__link_gt_any_item?: InputMaybe<ConditionString>;
	tags__link_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__link_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__link_le_any_item?: InputMaybe<ConditionString>;
	tags__link_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__link_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__link_lt_any_item?: InputMaybe<ConditionString>;
	tags__link_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__link_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__link_ne_any_item?: InputMaybe<ConditionString>;
	tags__link_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__link_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__title_eq_any_item?: InputMaybe<ConditionString>;
	tags__title_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__title_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__title_ge_any_item?: InputMaybe<ConditionString>;
	tags__title_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__title_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__title_gt_any_item?: InputMaybe<ConditionString>;
	tags__title_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__title_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__title_le_any_item?: InputMaybe<ConditionString>;
	tags__title_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__title_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__title_lt_any_item?: InputMaybe<ConditionString>;
	tags__title_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__title_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__title_ne_any_item?: InputMaybe<ConditionString>;
	tags__title_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__title_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__type_eq_any_item?: InputMaybe<ConditionString>;
	tags__type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__type_ge_any_item?: InputMaybe<ConditionString>;
	tags__type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__type_gt_any_item?: InputMaybe<ConditionString>;
	tags__type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__type_le_any_item?: InputMaybe<ConditionString>;
	tags__type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__type_lt_any_item?: InputMaybe<ConditionString>;
	tags__type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tags__type_ne_any_item?: InputMaybe<ConditionString>;
	tags__type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tags__type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_case_eq?: InputMaybe<ConditionString>;
	test_case_ge?: InputMaybe<ConditionString>;
	test_case_gt?: InputMaybe<ConditionString>;
	test_case_le?: InputMaybe<ConditionString>;
	test_case_lt?: InputMaybe<ConditionString>;
	test_case_ne?: InputMaybe<ConditionString>;
	test_id_eq?: InputMaybe<ConditionId>;
	test_id_ge?: InputMaybe<ConditionId>;
	test_id_gt?: InputMaybe<ConditionId>;
	test_id_le?: InputMaybe<ConditionId>;
	test_id_lt?: InputMaybe<ConditionId>;
	test_id_ne?: InputMaybe<ConditionId>;
	test_method_eq?: InputMaybe<ConditionString>;
	test_method_ge?: InputMaybe<ConditionString>;
	test_method_gt?: InputMaybe<ConditionString>;
	test_method_le?: InputMaybe<ConditionString>;
	test_method_lt?: InputMaybe<ConditionString>;
	test_method_ne?: InputMaybe<ConditionString>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	test_path_eq?: InputMaybe<ConditionString>;
	test_path_ge?: InputMaybe<ConditionString>;
	test_path_gt?: InputMaybe<ConditionString>;
	test_path_le?: InputMaybe<ConditionString>;
	test_path_lt?: InputMaybe<ConditionString>;
	test_path_ne?: InputMaybe<ConditionString>;
	test_suite_eq?: InputMaybe<ConditionString>;
	test_suite_ge?: InputMaybe<ConditionString>;
	test_suite_gt?: InputMaybe<ConditionString>;
	test_suite_le?: InputMaybe<ConditionString>;
	test_suite_lt?: InputMaybe<ConditionString>;
	test_suite_ne?: InputMaybe<ConditionString>;
	test_unique_identifier_eq?: InputMaybe<ConditionString>;
	test_unique_identifier_ge?: InputMaybe<ConditionString>;
	test_unique_identifier_gt?: InputMaybe<ConditionString>;
	test_unique_identifier_le?: InputMaybe<ConditionString>;
	test_unique_identifier_lt?: InputMaybe<ConditionString>;
	test_unique_identifier_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<IssuesSearchInsensitive>;
	text_equals?: InputMaybe<IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<IssuesSearch>;
	text_starts_with?: InputMaybe<IssuesSearchInsensitive>;
	tickets__key_eq_any_item?: InputMaybe<ConditionString>;
	tickets__key_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__key_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__key_ge_any_item?: InputMaybe<ConditionString>;
	tickets__key_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__key_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__key_gt_any_item?: InputMaybe<ConditionString>;
	tickets__key_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__key_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__key_le_any_item?: InputMaybe<ConditionString>;
	tickets__key_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__key_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__key_lt_any_item?: InputMaybe<ConditionString>;
	tickets__key_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__key_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__key_ne_any_item?: InputMaybe<ConditionString>;
	tickets__key_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__key_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__link_eq_any_item?: InputMaybe<ConditionString>;
	tickets__link_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__link_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__link_ge_any_item?: InputMaybe<ConditionString>;
	tickets__link_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__link_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__link_gt_any_item?: InputMaybe<ConditionString>;
	tickets__link_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__link_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__link_le_any_item?: InputMaybe<ConditionString>;
	tickets__link_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__link_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__link_lt_any_item?: InputMaybe<ConditionString>;
	tickets__link_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__link_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	tickets__link_ne_any_item?: InputMaybe<ConditionString>;
	tickets__link_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	tickets__link_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_id_eq?: InputMaybe<ConditionString>;
	type_id_ge?: InputMaybe<ConditionString>;
	type_id_gt?: InputMaybe<ConditionString>;
	type_id_le?: InputMaybe<ConditionString>;
	type_id_lt?: InputMaybe<ConditionString>;
	type_id_ne?: InputMaybe<ConditionString>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
	uniqueness_id_eq?: InputMaybe<ConditionId>;
	uniqueness_id_ge?: InputMaybe<ConditionId>;
	uniqueness_id_gt?: InputMaybe<ConditionId>;
	uniqueness_id_le?: InputMaybe<ConditionId>;
	uniqueness_id_lt?: InputMaybe<ConditionId>;
	uniqueness_id_ne?: InputMaybe<ConditionId>;
	update_time_eq?: InputMaybe<ConditionDateTime>;
	update_time_ge?: InputMaybe<ConditionDateTime>;
	update_time_gt?: InputMaybe<ConditionDateTime>;
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	update_time_le?: InputMaybe<ConditionDateTime>;
	update_time_lt?: InputMaybe<ConditionDateTime>;
	update_time_ne?: InputMaybe<ConditionDateTime>;
	url_eq?: InputMaybe<ConditionString>;
	url_ge?: InputMaybe<ConditionString>;
	url_gt?: InputMaybe<ConditionString>;
	url_le?: InputMaybe<ConditionString>;
	url_lt?: InputMaybe<ConditionString>;
	url_ne?: InputMaybe<ConditionString>;
	user_agent_eq?: InputMaybe<ConditionString>;
	user_agent_ge?: InputMaybe<ConditionString>;
	user_agent_gt?: InputMaybe<ConditionString>;
	user_agent_le?: InputMaybe<ConditionString>;
	user_agent_lt?: InputMaybe<ConditionString>;
	user_agent_ne?: InputMaybe<ConditionString>;
	validation_id_eq?: InputMaybe<ConditionId>;
	validation_id_ge?: InputMaybe<ConditionId>;
	validation_id_gt?: InputMaybe<ConditionId>;
	validation_id_le?: InputMaybe<ConditionId>;
	validation_id_lt?: InputMaybe<ConditionId>;
	validation_id_ne?: InputMaybe<ConditionId>;
	validation_status_eq?: InputMaybe<ConditionString>;
	validation_status_ge?: InputMaybe<ConditionString>;
	validation_status_gt?: InputMaybe<ConditionString>;
	validation_status_le?: InputMaybe<ConditionString>;
	validation_status_lt?: InputMaybe<ConditionString>;
	validation_status_ne?: InputMaybe<ConditionString>;
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	viewport_height_le?: InputMaybe<ConditionFloat>;
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	viewport_width_le?: InputMaybe<ConditionFloat>;
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export type QueryMfa_Scans_Impacted_Per_Issue_SeverityArgs = {
	and?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_SeverityAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeverityGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_SeverityOrFilter>>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearch>;
	text_starts_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type QueryMfa_Scans_Impacted_Per_Issue_TypeArgs = {
	and?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_TypeAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_TypeOrFilter>>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sort?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearch>;
	text_starts_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
};

export type QueryMfa_Session_RunsArgs = {
	and?: InputMaybe<Array<Mfa_Session_RunsAndFilter>>;
	app_build_number_eq_any_item?: InputMaybe<ConditionString>;
	app_build_number_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_ge_any_item?: InputMaybe<ConditionString>;
	app_build_number_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_gt_any_item?: InputMaybe<ConditionString>;
	app_build_number_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_le_any_item?: InputMaybe<ConditionString>;
	app_build_number_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_lt_any_item?: InputMaybe<ConditionString>;
	app_build_number_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_ne_any_item?: InputMaybe<ConditionString>;
	app_build_number_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_eq_any_item?: InputMaybe<ConditionString>;
	app_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_ge_any_item?: InputMaybe<ConditionString>;
	app_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_gt_any_item?: InputMaybe<ConditionString>;
	app_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_eq_any_item?: InputMaybe<ConditionString>;
	app_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_ge_any_item?: InputMaybe<ConditionString>;
	app_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_gt_any_item?: InputMaybe<ConditionString>;
	app_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_le_any_item?: InputMaybe<ConditionString>;
	app_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_lt_any_item?: InputMaybe<ConditionString>;
	app_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_ne_any_item?: InputMaybe<ConditionString>;
	app_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_le_any_item?: InputMaybe<ConditionString>;
	app_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_lt_any_item?: InputMaybe<ConditionString>;
	app_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_ne_any_item?: InputMaybe<ConditionString>;
	app_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_version_eq_any_item?: InputMaybe<ConditionString>;
	app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_version_ge_any_item?: InputMaybe<ConditionString>;
	app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_version_gt_any_item?: InputMaybe<ConditionString>;
	app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_version_le_any_item?: InputMaybe<ConditionString>;
	app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_version_lt_any_item?: InputMaybe<ConditionString>;
	app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_version_ne_any_item?: InputMaybe<ConditionString>;
	app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	companion_app_version_eq_any_item?: InputMaybe<ConditionString>;
	companion_app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_ge_any_item?: InputMaybe<ConditionString>;
	companion_app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_gt_any_item?: InputMaybe<ConditionString>;
	companion_app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_le_any_item?: InputMaybe<ConditionString>;
	companion_app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_lt_any_item?: InputMaybe<ConditionString>;
	companion_app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_ne_any_item?: InputMaybe<ConditionString>;
	companion_app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	device_manufacturer_eq_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ge_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_gt_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_le_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_lt_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ne_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_eq_any_item?: InputMaybe<ConditionString>;
	device_model_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_ge_any_item?: InputMaybe<ConditionString>;
	device_model_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_gt_any_item?: InputMaybe<ConditionString>;
	device_model_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_le_any_item?: InputMaybe<ConditionString>;
	device_model_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_lt_any_item?: InputMaybe<ConditionString>;
	device_model_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_ne_any_item?: InputMaybe<ConditionString>;
	device_model_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_eq_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ge_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_gt_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_le_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_lt_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ne_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_eq_any_item?: InputMaybe<ConditionString>;
	device_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_ge_any_item?: InputMaybe<ConditionString>;
	device_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_gt_any_item?: InputMaybe<ConditionString>;
	device_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_le_any_item?: InputMaybe<ConditionString>;
	device_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_lt_any_item?: InputMaybe<ConditionString>;
	device_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_ne_any_item?: InputMaybe<ConditionString>;
	device_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Mfa_Session_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	mobile_kit_eq_any_item?: InputMaybe<ConditionString>;
	mobile_kit_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_ge_any_item?: InputMaybe<ConditionString>;
	mobile_kit_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_gt_any_item?: InputMaybe<ConditionString>;
	mobile_kit_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_le_any_item?: InputMaybe<ConditionString>;
	mobile_kit_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_lt_any_item?: InputMaybe<ConditionString>;
	mobile_kit_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_ne_any_item?: InputMaybe<ConditionString>;
	mobile_kit_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Mfa_Session_RunsOrFilter>>;
	os_eq_any_item?: InputMaybe<ConditionString>;
	os_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_ge_any_item?: InputMaybe<ConditionString>;
	os_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_gt_any_item?: InputMaybe<ConditionString>;
	os_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_le_any_item?: InputMaybe<ConditionString>;
	os_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_lt_any_item?: InputMaybe<ConditionString>;
	os_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_ne_any_item?: InputMaybe<ConditionString>;
	os_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_eq_any_item?: InputMaybe<ConditionString>;
	os_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_ge_any_item?: InputMaybe<ConditionString>;
	os_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_gt_any_item?: InputMaybe<ConditionString>;
	os_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_le_any_item?: InputMaybe<ConditionString>;
	os_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_lt_any_item?: InputMaybe<ConditionString>;
	os_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_ne_any_item?: InputMaybe<ConditionString>;
	os_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	product_version_eq_any_item?: InputMaybe<ConditionString>;
	product_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	product_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	product_version_ge_any_item?: InputMaybe<ConditionString>;
	product_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	product_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	product_version_gt_any_item?: InputMaybe<ConditionString>;
	product_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	product_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	product_version_le_any_item?: InputMaybe<ConditionString>;
	product_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	product_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	product_version_lt_any_item?: InputMaybe<ConditionString>;
	product_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	product_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	product_version_ne_any_item?: InputMaybe<ConditionString>;
	product_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	product_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	run_updated_at_eq?: InputMaybe<ConditionDateTime>;
	run_updated_at_ge?: InputMaybe<ConditionDateTime>;
	run_updated_at_gt?: InputMaybe<ConditionDateTime>;
	run_updated_at_last_n_days?: InputMaybe<ConditionInt>;
	run_updated_at_le?: InputMaybe<ConditionDateTime>;
	run_updated_at_lt?: InputMaybe<ConditionDateTime>;
	run_updated_at_ne?: InputMaybe<ConditionDateTime>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	session_name_eq?: InputMaybe<ConditionString>;
	session_name_ge?: InputMaybe<ConditionString>;
	session_name_gt?: InputMaybe<ConditionString>;
	session_name_le?: InputMaybe<ConditionString>;
	session_name_lt?: InputMaybe<ConditionString>;
	session_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Mfa_Session_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Session_RunsSearch>;
	text_starts_with?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
	user_name_eq?: InputMaybe<ConditionString>;
	user_name_ge?: InputMaybe<ConditionString>;
	user_name_gt?: InputMaybe<ConditionString>;
	user_name_le?: InputMaybe<ConditionString>;
	user_name_lt?: InputMaybe<ConditionString>;
	user_name_ne?: InputMaybe<ConditionString>;
};

export type QueryMfa_Test_By_Issue_TypesArgs = {
	and?: InputMaybe<Array<Mfa_Test_By_Issue_TypesAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Mfa_Test_By_Issue_TypesGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Mfa_Test_By_Issue_TypesOrFilter>>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Mfa_Test_By_Issue_TypesSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_By_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
};

export type QueryMfa_Test_By_SeverityArgs = {
	and?: InputMaybe<Array<Mfa_Test_By_SeverityAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Mfa_Test_By_SeverityGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Mfa_Test_By_SeverityOrFilter>>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	percentage_eq?: InputMaybe<ConditionFloat>;
	percentage_ge?: InputMaybe<ConditionFloat>;
	percentage_gt?: InputMaybe<ConditionFloat>;
	percentage_le?: InputMaybe<ConditionFloat>;
	percentage_lt?: InputMaybe<ConditionFloat>;
	percentage_ne?: InputMaybe<ConditionFloat>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Mfa_Test_By_SeveritySort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_By_SeveritySearch>;
	text_starts_with?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type QueryMfa_Test_Top_Issue_TypesArgs = {
	and?: InputMaybe<Array<Mfa_Test_Top_Issue_TypesAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Mfa_Test_Top_Issue_TypesGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Mfa_Test_Top_Issue_TypesOrFilter>>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sort?: InputMaybe<Mfa_Test_Top_Issue_TypesSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_Top_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
};

export type QueryMfa_Worst_Performing_ScansArgs = {
	and?: InputMaybe<Array<Mfa_Worst_Performing_ScansAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Mfa_Worst_Performing_ScansGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Mfa_Worst_Performing_ScansOrFilter>>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	scan_id_eq?: InputMaybe<ConditionId>;
	scan_id_ge?: InputMaybe<ConditionId>;
	scan_id_gt?: InputMaybe<ConditionId>;
	scan_id_le?: InputMaybe<ConditionId>;
	scan_id_lt?: InputMaybe<ConditionId>;
	scan_id_ne?: InputMaybe<ConditionId>;
	sort?: InputMaybe<Mfa_Worst_Performing_ScansSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Worst_Performing_ScansSearch>;
	text_starts_with?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type QueryMsdk_Report_RunsArgs = {
	and?: InputMaybe<Array<Msdk_Report_RunsAndFilter>>;
	app_build_number_eq?: InputMaybe<ConditionString>;
	app_build_number_ge?: InputMaybe<ConditionString>;
	app_build_number_gt?: InputMaybe<ConditionString>;
	app_build_number_le?: InputMaybe<ConditionString>;
	app_build_number_lt?: InputMaybe<ConditionString>;
	app_build_number_ne?: InputMaybe<ConditionString>;
	app_eq?: InputMaybe<ConditionString>;
	app_ge?: InputMaybe<ConditionString>;
	app_gt?: InputMaybe<ConditionString>;
	app_id_eq?: InputMaybe<ConditionString>;
	app_id_ge?: InputMaybe<ConditionString>;
	app_id_gt?: InputMaybe<ConditionString>;
	app_id_le?: InputMaybe<ConditionString>;
	app_id_lt?: InputMaybe<ConditionString>;
	app_id_ne?: InputMaybe<ConditionString>;
	app_le?: InputMaybe<ConditionString>;
	app_lt?: InputMaybe<ConditionString>;
	app_ne?: InputMaybe<ConditionString>;
	app_version_eq?: InputMaybe<ConditionString>;
	app_version_ge?: InputMaybe<ConditionString>;
	app_version_gt?: InputMaybe<ConditionString>;
	app_version_le?: InputMaybe<ConditionString>;
	app_version_lt?: InputMaybe<ConditionString>;
	app_version_ne?: InputMaybe<ConditionString>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	companion_app_version_eq?: InputMaybe<ConditionString>;
	companion_app_version_ge?: InputMaybe<ConditionString>;
	companion_app_version_gt?: InputMaybe<ConditionString>;
	companion_app_version_le?: InputMaybe<ConditionString>;
	companion_app_version_lt?: InputMaybe<ConditionString>;
	companion_app_version_ne?: InputMaybe<ConditionString>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	device_manufacturer_le?: InputMaybe<ConditionString>;
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	device_model_eq?: InputMaybe<ConditionString>;
	device_model_ge?: InputMaybe<ConditionString>;
	device_model_gt?: InputMaybe<ConditionString>;
	device_model_le?: InputMaybe<ConditionString>;
	device_model_lt?: InputMaybe<ConditionString>;
	device_model_ne?: InputMaybe<ConditionString>;
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	device_personalized_name_le?: InputMaybe<ConditionString>;
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	device_type_eq?: InputMaybe<ConditionString>;
	device_type_ge?: InputMaybe<ConditionString>;
	device_type_gt?: InputMaybe<ConditionString>;
	device_type_le?: InputMaybe<ConditionString>;
	device_type_lt?: InputMaybe<ConditionString>;
	device_type_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Report_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	mobile_kit_eq?: InputMaybe<ConditionString>;
	mobile_kit_ge?: InputMaybe<ConditionString>;
	mobile_kit_gt?: InputMaybe<ConditionString>;
	mobile_kit_le?: InputMaybe<ConditionString>;
	mobile_kit_lt?: InputMaybe<ConditionString>;
	mobile_kit_ne?: InputMaybe<ConditionString>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Report_RunsOrFilter>>;
	os_eq?: InputMaybe<ConditionString>;
	os_ge?: InputMaybe<ConditionString>;
	os_gt?: InputMaybe<ConditionString>;
	os_le?: InputMaybe<ConditionString>;
	os_lt?: InputMaybe<ConditionString>;
	os_ne?: InputMaybe<ConditionString>;
	os_version_eq?: InputMaybe<ConditionString>;
	os_version_ge?: InputMaybe<ConditionString>;
	os_version_gt?: InputMaybe<ConditionString>;
	os_version_le?: InputMaybe<ConditionString>;
	os_version_lt?: InputMaybe<ConditionString>;
	os_version_ne?: InputMaybe<ConditionString>;
	product_version_eq?: InputMaybe<ConditionString>;
	product_version_ge?: InputMaybe<ConditionString>;
	product_version_gt?: InputMaybe<ConditionString>;
	product_version_le?: InputMaybe<ConditionString>;
	product_version_lt?: InputMaybe<ConditionString>;
	product_version_ne?: InputMaybe<ConditionString>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sdk_type_eq?: InputMaybe<ConditionString>;
	sdk_type_ge?: InputMaybe<ConditionString>;
	sdk_type_gt?: InputMaybe<ConditionString>;
	sdk_type_le?: InputMaybe<ConditionString>;
	sdk_type_lt?: InputMaybe<ConditionString>;
	sdk_type_ne?: InputMaybe<ConditionString>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	sort?: InputMaybe<Msdk_Report_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Report_RunsSearch>;
	text_starts_with?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type QueryMsdk_Report_Runs_LatestArgs = {
	and?: InputMaybe<Array<Msdk_Report_Runs_LatestAndFilter>>;
	app_build_number_eq?: InputMaybe<ConditionString>;
	app_build_number_ge?: InputMaybe<ConditionString>;
	app_build_number_gt?: InputMaybe<ConditionString>;
	app_build_number_le?: InputMaybe<ConditionString>;
	app_build_number_lt?: InputMaybe<ConditionString>;
	app_build_number_ne?: InputMaybe<ConditionString>;
	app_eq?: InputMaybe<ConditionString>;
	app_ge?: InputMaybe<ConditionString>;
	app_gt?: InputMaybe<ConditionString>;
	app_id_eq?: InputMaybe<ConditionString>;
	app_id_ge?: InputMaybe<ConditionString>;
	app_id_gt?: InputMaybe<ConditionString>;
	app_id_le?: InputMaybe<ConditionString>;
	app_id_lt?: InputMaybe<ConditionString>;
	app_id_ne?: InputMaybe<ConditionString>;
	app_le?: InputMaybe<ConditionString>;
	app_lt?: InputMaybe<ConditionString>;
	app_ne?: InputMaybe<ConditionString>;
	app_version_eq?: InputMaybe<ConditionString>;
	app_version_ge?: InputMaybe<ConditionString>;
	app_version_gt?: InputMaybe<ConditionString>;
	app_version_le?: InputMaybe<ConditionString>;
	app_version_lt?: InputMaybe<ConditionString>;
	app_version_ne?: InputMaybe<ConditionString>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	companion_app_version_eq?: InputMaybe<ConditionString>;
	companion_app_version_ge?: InputMaybe<ConditionString>;
	companion_app_version_gt?: InputMaybe<ConditionString>;
	companion_app_version_le?: InputMaybe<ConditionString>;
	companion_app_version_lt?: InputMaybe<ConditionString>;
	companion_app_version_ne?: InputMaybe<ConditionString>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	device_manufacturer_le?: InputMaybe<ConditionString>;
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	device_model_eq?: InputMaybe<ConditionString>;
	device_model_ge?: InputMaybe<ConditionString>;
	device_model_gt?: InputMaybe<ConditionString>;
	device_model_le?: InputMaybe<ConditionString>;
	device_model_lt?: InputMaybe<ConditionString>;
	device_model_ne?: InputMaybe<ConditionString>;
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	device_personalized_name_le?: InputMaybe<ConditionString>;
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	device_type_eq?: InputMaybe<ConditionString>;
	device_type_ge?: InputMaybe<ConditionString>;
	device_type_gt?: InputMaybe<ConditionString>;
	device_type_le?: InputMaybe<ConditionString>;
	device_type_lt?: InputMaybe<ConditionString>;
	device_type_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Report_Runs_LatestGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	mobile_kit_eq?: InputMaybe<ConditionString>;
	mobile_kit_ge?: InputMaybe<ConditionString>;
	mobile_kit_gt?: InputMaybe<ConditionString>;
	mobile_kit_le?: InputMaybe<ConditionString>;
	mobile_kit_lt?: InputMaybe<ConditionString>;
	mobile_kit_ne?: InputMaybe<ConditionString>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Report_Runs_LatestOrFilter>>;
	os_eq?: InputMaybe<ConditionString>;
	os_ge?: InputMaybe<ConditionString>;
	os_gt?: InputMaybe<ConditionString>;
	os_le?: InputMaybe<ConditionString>;
	os_lt?: InputMaybe<ConditionString>;
	os_ne?: InputMaybe<ConditionString>;
	os_version_eq?: InputMaybe<ConditionString>;
	os_version_ge?: InputMaybe<ConditionString>;
	os_version_gt?: InputMaybe<ConditionString>;
	os_version_le?: InputMaybe<ConditionString>;
	os_version_lt?: InputMaybe<ConditionString>;
	os_version_ne?: InputMaybe<ConditionString>;
	product_version_eq?: InputMaybe<ConditionString>;
	product_version_ge?: InputMaybe<ConditionString>;
	product_version_gt?: InputMaybe<ConditionString>;
	product_version_le?: InputMaybe<ConditionString>;
	product_version_lt?: InputMaybe<ConditionString>;
	product_version_ne?: InputMaybe<ConditionString>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sdk_type_eq?: InputMaybe<ConditionString>;
	sdk_type_ge?: InputMaybe<ConditionString>;
	sdk_type_gt?: InputMaybe<ConditionString>;
	sdk_type_le?: InputMaybe<ConditionString>;
	sdk_type_lt?: InputMaybe<ConditionString>;
	sdk_type_ne?: InputMaybe<ConditionString>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	sort?: InputMaybe<Msdk_Report_Runs_LatestSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Report_Runs_LatestSearch>;
	text_starts_with?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type QueryMsdk_Scans_Impacted_Per_Issue_SeverityArgs = {
	and?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_SeverityAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeverityGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_SeverityOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearch>;
	text_starts_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type QueryMsdk_Scans_Impacted_Per_Issue_TypeArgs = {
	and?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_TypeAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_TypeOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sort?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearch>;
	text_starts_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
};

export type QueryMsdk_Test_By_Issue_TypesArgs = {
	and?: InputMaybe<Array<Msdk_Test_By_Issue_TypesAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Test_By_Issue_TypesGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Test_By_Issue_TypesOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Msdk_Test_By_Issue_TypesSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_By_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
};

export type QueryMsdk_Test_By_SeverityArgs = {
	and?: InputMaybe<Array<Msdk_Test_By_SeverityAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Test_By_SeverityGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Test_By_SeverityOrFilter>>;
	percentage_eq?: InputMaybe<ConditionFloat>;
	percentage_ge?: InputMaybe<ConditionFloat>;
	percentage_gt?: InputMaybe<ConditionFloat>;
	percentage_le?: InputMaybe<ConditionFloat>;
	percentage_lt?: InputMaybe<ConditionFloat>;
	percentage_ne?: InputMaybe<ConditionFloat>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Msdk_Test_By_SeveritySort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_By_SeveritySearch>;
	text_starts_with?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type QueryMsdk_Test_RunsArgs = {
	and?: InputMaybe<Array<Msdk_Test_RunsAndFilter>>;
	app_build_number_eq?: InputMaybe<ConditionString>;
	app_build_number_ge?: InputMaybe<ConditionString>;
	app_build_number_gt?: InputMaybe<ConditionString>;
	app_build_number_le?: InputMaybe<ConditionString>;
	app_build_number_lt?: InputMaybe<ConditionString>;
	app_build_number_ne?: InputMaybe<ConditionString>;
	app_eq?: InputMaybe<ConditionString>;
	app_ge?: InputMaybe<ConditionString>;
	app_gt?: InputMaybe<ConditionString>;
	app_id_eq?: InputMaybe<ConditionString>;
	app_id_ge?: InputMaybe<ConditionString>;
	app_id_gt?: InputMaybe<ConditionString>;
	app_id_le?: InputMaybe<ConditionString>;
	app_id_lt?: InputMaybe<ConditionString>;
	app_id_ne?: InputMaybe<ConditionString>;
	app_le?: InputMaybe<ConditionString>;
	app_lt?: InputMaybe<ConditionString>;
	app_ne?: InputMaybe<ConditionString>;
	app_version_eq?: InputMaybe<ConditionString>;
	app_version_ge?: InputMaybe<ConditionString>;
	app_version_gt?: InputMaybe<ConditionString>;
	app_version_le?: InputMaybe<ConditionString>;
	app_version_lt?: InputMaybe<ConditionString>;
	app_version_ne?: InputMaybe<ConditionString>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	companion_app_version_eq?: InputMaybe<ConditionString>;
	companion_app_version_ge?: InputMaybe<ConditionString>;
	companion_app_version_gt?: InputMaybe<ConditionString>;
	companion_app_version_le?: InputMaybe<ConditionString>;
	companion_app_version_lt?: InputMaybe<ConditionString>;
	companion_app_version_ne?: InputMaybe<ConditionString>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	device_manufacturer_le?: InputMaybe<ConditionString>;
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	device_model_eq?: InputMaybe<ConditionString>;
	device_model_ge?: InputMaybe<ConditionString>;
	device_model_gt?: InputMaybe<ConditionString>;
	device_model_le?: InputMaybe<ConditionString>;
	device_model_lt?: InputMaybe<ConditionString>;
	device_model_ne?: InputMaybe<ConditionString>;
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	device_personalized_name_le?: InputMaybe<ConditionString>;
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	device_type_eq?: InputMaybe<ConditionString>;
	device_type_ge?: InputMaybe<ConditionString>;
	device_type_gt?: InputMaybe<ConditionString>;
	device_type_le?: InputMaybe<ConditionString>;
	device_type_lt?: InputMaybe<ConditionString>;
	device_type_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Test_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	mobile_kit_eq?: InputMaybe<ConditionString>;
	mobile_kit_ge?: InputMaybe<ConditionString>;
	mobile_kit_gt?: InputMaybe<ConditionString>;
	mobile_kit_le?: InputMaybe<ConditionString>;
	mobile_kit_lt?: InputMaybe<ConditionString>;
	mobile_kit_ne?: InputMaybe<ConditionString>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Test_RunsOrFilter>>;
	os_eq?: InputMaybe<ConditionString>;
	os_ge?: InputMaybe<ConditionString>;
	os_gt?: InputMaybe<ConditionString>;
	os_le?: InputMaybe<ConditionString>;
	os_lt?: InputMaybe<ConditionString>;
	os_ne?: InputMaybe<ConditionString>;
	os_version_eq?: InputMaybe<ConditionString>;
	os_version_ge?: InputMaybe<ConditionString>;
	os_version_gt?: InputMaybe<ConditionString>;
	os_version_le?: InputMaybe<ConditionString>;
	os_version_lt?: InputMaybe<ConditionString>;
	os_version_ne?: InputMaybe<ConditionString>;
	product_version_eq?: InputMaybe<ConditionString>;
	product_version_ge?: InputMaybe<ConditionString>;
	product_version_gt?: InputMaybe<ConditionString>;
	product_version_le?: InputMaybe<ConditionString>;
	product_version_lt?: InputMaybe<ConditionString>;
	product_version_ne?: InputMaybe<ConditionString>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sdk_type_eq?: InputMaybe<ConditionString>;
	sdk_type_ge?: InputMaybe<ConditionString>;
	sdk_type_gt?: InputMaybe<ConditionString>;
	sdk_type_le?: InputMaybe<ConditionString>;
	sdk_type_lt?: InputMaybe<ConditionString>;
	sdk_type_ne?: InputMaybe<ConditionString>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	sort?: InputMaybe<Msdk_Test_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	test_path_eq?: InputMaybe<ConditionString>;
	test_path_ge?: InputMaybe<ConditionString>;
	test_path_gt?: InputMaybe<ConditionString>;
	test_path_le?: InputMaybe<ConditionString>;
	test_path_lt?: InputMaybe<ConditionString>;
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type QueryMsdk_Test_Runs_LatestArgs = {
	and?: InputMaybe<Array<Msdk_Test_Runs_LatestAndFilter>>;
	app_build_number_eq_any_item?: InputMaybe<ConditionString>;
	app_build_number_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_ge_any_item?: InputMaybe<ConditionString>;
	app_build_number_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_gt_any_item?: InputMaybe<ConditionString>;
	app_build_number_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_le_any_item?: InputMaybe<ConditionString>;
	app_build_number_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_lt_any_item?: InputMaybe<ConditionString>;
	app_build_number_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_build_number_ne_any_item?: InputMaybe<ConditionString>;
	app_build_number_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_build_number_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_eq?: InputMaybe<ConditionString>;
	app_ge?: InputMaybe<ConditionString>;
	app_gt?: InputMaybe<ConditionString>;
	app_id_eq_any_item?: InputMaybe<ConditionString>;
	app_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_ge_any_item?: InputMaybe<ConditionString>;
	app_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_gt_any_item?: InputMaybe<ConditionString>;
	app_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_le_any_item?: InputMaybe<ConditionString>;
	app_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_lt_any_item?: InputMaybe<ConditionString>;
	app_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_id_ne_any_item?: InputMaybe<ConditionString>;
	app_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	app_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	app_le?: InputMaybe<ConditionString>;
	app_lt?: InputMaybe<ConditionString>;
	app_ne?: InputMaybe<ConditionString>;
	app_version_eq?: InputMaybe<ConditionString>;
	app_version_ge?: InputMaybe<ConditionString>;
	app_version_gt?: InputMaybe<ConditionString>;
	app_version_le?: InputMaybe<ConditionString>;
	app_version_lt?: InputMaybe<ConditionString>;
	app_version_ne?: InputMaybe<ConditionString>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	companion_app_version_eq_any_item?: InputMaybe<ConditionString>;
	companion_app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_ge_any_item?: InputMaybe<ConditionString>;
	companion_app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_gt_any_item?: InputMaybe<ConditionString>;
	companion_app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_le_any_item?: InputMaybe<ConditionString>;
	companion_app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_lt_any_item?: InputMaybe<ConditionString>;
	companion_app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	companion_app_version_ne_any_item?: InputMaybe<ConditionString>;
	companion_app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	companion_app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	device_manufacturer_eq_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ge_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_gt_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_le_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_lt_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ne_any_item?: InputMaybe<ConditionString>;
	device_manufacturer_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_manufacturer_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_eq_any_item?: InputMaybe<ConditionString>;
	device_model_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_ge_any_item?: InputMaybe<ConditionString>;
	device_model_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_gt_any_item?: InputMaybe<ConditionString>;
	device_model_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_le_any_item?: InputMaybe<ConditionString>;
	device_model_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_lt_any_item?: InputMaybe<ConditionString>;
	device_model_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_model_ne_any_item?: InputMaybe<ConditionString>;
	device_model_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_model_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_eq_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ge_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_gt_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_le_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_lt_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ne_any_item?: InputMaybe<ConditionString>;
	device_personalized_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_personalized_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_eq_any_item?: InputMaybe<ConditionString>;
	device_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_ge_any_item?: InputMaybe<ConditionString>;
	device_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_gt_any_item?: InputMaybe<ConditionString>;
	device_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_le_any_item?: InputMaybe<ConditionString>;
	device_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_lt_any_item?: InputMaybe<ConditionString>;
	device_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	device_type_ne_any_item?: InputMaybe<ConditionString>;
	device_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	device_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Test_Runs_LatestGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	mobile_kit_eq_any_item?: InputMaybe<ConditionString>;
	mobile_kit_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_ge_any_item?: InputMaybe<ConditionString>;
	mobile_kit_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_gt_any_item?: InputMaybe<ConditionString>;
	mobile_kit_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_le_any_item?: InputMaybe<ConditionString>;
	mobile_kit_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_lt_any_item?: InputMaybe<ConditionString>;
	mobile_kit_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	mobile_kit_ne_any_item?: InputMaybe<ConditionString>;
	mobile_kit_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	mobile_kit_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Test_Runs_LatestOrFilter>>;
	os_eq?: InputMaybe<ConditionString>;
	os_ge?: InputMaybe<ConditionString>;
	os_gt?: InputMaybe<ConditionString>;
	os_le?: InputMaybe<ConditionString>;
	os_lt?: InputMaybe<ConditionString>;
	os_ne?: InputMaybe<ConditionString>;
	os_version_eq_any_item?: InputMaybe<ConditionString>;
	os_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_ge_any_item?: InputMaybe<ConditionString>;
	os_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_gt_any_item?: InputMaybe<ConditionString>;
	os_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_le_any_item?: InputMaybe<ConditionString>;
	os_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_lt_any_item?: InputMaybe<ConditionString>;
	os_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	os_version_ne_any_item?: InputMaybe<ConditionString>;
	os_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	os_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	product_version_eq?: InputMaybe<ConditionString>;
	product_version_ge?: InputMaybe<ConditionString>;
	product_version_gt?: InputMaybe<ConditionString>;
	product_version_le?: InputMaybe<ConditionString>;
	product_version_lt?: InputMaybe<ConditionString>;
	product_version_ne?: InputMaybe<ConditionString>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sdk_type_eq?: InputMaybe<ConditionString>;
	sdk_type_ge?: InputMaybe<ConditionString>;
	sdk_type_gt?: InputMaybe<ConditionString>;
	sdk_type_le?: InputMaybe<ConditionString>;
	sdk_type_lt?: InputMaybe<ConditionString>;
	sdk_type_ne?: InputMaybe<ConditionString>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	sort?: InputMaybe<Msdk_Test_Runs_LatestSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	test_path_eq?: InputMaybe<ConditionString>;
	test_path_ge?: InputMaybe<ConditionString>;
	test_path_gt?: InputMaybe<ConditionString>;
	test_path_le?: InputMaybe<ConditionString>;
	test_path_lt?: InputMaybe<ConditionString>;
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_Runs_LatestSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_scans_eq?: InputMaybe<ConditionInt>;
	total_scans_ge?: InputMaybe<ConditionInt>;
	total_scans_gt?: InputMaybe<ConditionInt>;
	total_scans_le?: InputMaybe<ConditionInt>;
	total_scans_lt?: InputMaybe<ConditionInt>;
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type QueryMsdk_Test_Top_Issue_TypesArgs = {
	and?: InputMaybe<Array<Msdk_Test_Top_Issue_TypesAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Test_Top_Issue_TypesGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Test_Top_Issue_TypesOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	sort?: InputMaybe<Msdk_Test_Top_Issue_TypesSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_Top_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
};

export type QueryMsdk_Worst_Performing_ScansArgs = {
	and?: InputMaybe<Array<Msdk_Worst_Performing_ScansAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Msdk_Worst_Performing_ScansGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Msdk_Worst_Performing_ScansOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	scan_id_eq?: InputMaybe<ConditionId>;
	scan_id_ge?: InputMaybe<ConditionId>;
	scan_id_gt?: InputMaybe<ConditionId>;
	scan_id_le?: InputMaybe<ConditionId>;
	scan_id_lt?: InputMaybe<ConditionId>;
	scan_id_ne?: InputMaybe<ConditionId>;
	sort?: InputMaybe<Msdk_Worst_Performing_ScansSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Worst_Performing_ScansSearch>;
	text_starts_with?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type QueryPagesArgs = {
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	and?: InputMaybe<Array<PagesAndFilter>>;
	canonical_url_eq?: InputMaybe<ConditionString>;
	canonical_url_ge?: InputMaybe<ConditionString>;
	canonical_url_gt?: InputMaybe<ConditionString>;
	canonical_url_le?: InputMaybe<ConditionString>;
	canonical_url_lt?: InputMaybe<ConditionString>;
	canonical_url_ne?: InputMaybe<ConditionString>;
	client_version_eq?: InputMaybe<ConditionString>;
	client_version_ge?: InputMaybe<ConditionString>;
	client_version_gt?: InputMaybe<ConditionString>;
	client_version_le?: InputMaybe<ConditionString>;
	client_version_lt?: InputMaybe<ConditionString>;
	client_version_ne?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	deleted_eq?: InputMaybe<ConditionBoolean>;
	deleted_ge?: InputMaybe<ConditionBoolean>;
	deleted_gt?: InputMaybe<ConditionBoolean>;
	deleted_le?: InputMaybe<ConditionBoolean>;
	deleted_lt?: InputMaybe<ConditionBoolean>;
	deleted_ne?: InputMaybe<ConditionBoolean>;
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	domain_eq?: InputMaybe<ConditionString>;
	domain_ge?: InputMaybe<ConditionString>;
	domain_gt?: InputMaybe<ConditionString>;
	domain_le?: InputMaybe<ConditionString>;
	domain_lt?: InputMaybe<ConditionString>;
	domain_ne?: InputMaybe<ConditionString>;
	engines_version_eq?: InputMaybe<ConditionString>;
	engines_version_ge?: InputMaybe<ConditionString>;
	engines_version_gt?: InputMaybe<ConditionString>;
	engines_version_le?: InputMaybe<ConditionString>;
	engines_version_lt?: InputMaybe<ConditionString>;
	engines_version_ne?: InputMaybe<ConditionString>;
	environment_eq?: InputMaybe<ConditionString>;
	environment_ge?: InputMaybe<ConditionString>;
	environment_gt?: InputMaybe<ConditionString>;
	environment_le?: InputMaybe<ConditionString>;
	environment_lt?: InputMaybe<ConditionString>;
	environment_ne?: InputMaybe<ConditionString>;
	flow_eq?: InputMaybe<ConditionString>;
	flow_ge?: InputMaybe<ConditionString>;
	flow_gt?: InputMaybe<ConditionString>;
	flow_le?: InputMaybe<ConditionString>;
	flow_lt?: InputMaybe<ConditionString>;
	flow_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<PagesGroup>>>;
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<PagesOrFilter>>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	owner_type_eq?: InputMaybe<ConditionString>;
	owner_type_ge?: InputMaybe<ConditionString>;
	owner_type_gt?: InputMaybe<ConditionString>;
	owner_type_le?: InputMaybe<ConditionString>;
	owner_type_lt?: InputMaybe<ConditionString>;
	owner_type_ne?: InputMaybe<ConditionString>;
	page_id_eq?: InputMaybe<ConditionId>;
	page_id_ge?: InputMaybe<ConditionId>;
	page_id_gt?: InputMaybe<ConditionId>;
	page_id_le?: InputMaybe<ConditionId>;
	page_id_lt?: InputMaybe<ConditionId>;
	page_id_ne?: InputMaybe<ConditionId>;
	page_title_eq?: InputMaybe<ConditionString>;
	page_title_ge?: InputMaybe<ConditionString>;
	page_title_gt?: InputMaybe<ConditionString>;
	page_title_le?: InputMaybe<ConditionString>;
	page_title_lt?: InputMaybe<ConditionString>;
	page_title_ne?: InputMaybe<ConditionString>;
	product_id_eq?: InputMaybe<ConditionId>;
	product_id_ge?: InputMaybe<ConditionId>;
	product_id_gt?: InputMaybe<ConditionId>;
	product_id_le?: InputMaybe<ConditionId>;
	product_id_lt?: InputMaybe<ConditionId>;
	product_id_ne?: InputMaybe<ConditionId>;
	product_name_eq?: InputMaybe<ConditionString>;
	product_name_ge?: InputMaybe<ConditionString>;
	product_name_gt?: InputMaybe<ConditionString>;
	product_name_le?: InputMaybe<ConditionString>;
	product_name_lt?: InputMaybe<ConditionString>;
	product_name_ne?: InputMaybe<ConditionString>;
	product_version_eq?: InputMaybe<ConditionString>;
	product_version_ge?: InputMaybe<ConditionString>;
	product_version_gt?: InputMaybe<ConditionString>;
	product_version_le?: InputMaybe<ConditionString>;
	product_version_lt?: InputMaybe<ConditionString>;
	product_version_ne?: InputMaybe<ConditionString>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	session_name_eq?: InputMaybe<ConditionString>;
	session_name_ge?: InputMaybe<ConditionString>;
	session_name_gt?: InputMaybe<ConditionString>;
	session_name_le?: InputMaybe<ConditionString>;
	session_name_lt?: InputMaybe<ConditionString>;
	session_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<PagesSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_id_eq?: InputMaybe<ConditionId>;
	test_id_ge?: InputMaybe<ConditionId>;
	test_id_gt?: InputMaybe<ConditionId>;
	test_id_le?: InputMaybe<ConditionId>;
	test_id_lt?: InputMaybe<ConditionId>;
	test_id_ne?: InputMaybe<ConditionId>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	test_path_eq?: InputMaybe<ConditionString>;
	test_path_ge?: InputMaybe<ConditionString>;
	test_path_gt?: InputMaybe<ConditionString>;
	test_path_le?: InputMaybe<ConditionString>;
	test_path_lt?: InputMaybe<ConditionString>;
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<PagesSearchInsensitive>;
	text_ends_with?: InputMaybe<PagesSearchInsensitive>;
	text_equals?: InputMaybe<PagesSearchInsensitive>;
	text_regex_match?: InputMaybe<PagesSearch>;
	text_starts_with?: InputMaybe<PagesSearchInsensitive>;
	update_time_eq?: InputMaybe<ConditionDateTime>;
	update_time_ge?: InputMaybe<ConditionDateTime>;
	update_time_gt?: InputMaybe<ConditionDateTime>;
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	update_time_le?: InputMaybe<ConditionDateTime>;
	update_time_lt?: InputMaybe<ConditionDateTime>;
	update_time_ne?: InputMaybe<ConditionDateTime>;
	url_eq?: InputMaybe<ConditionString>;
	url_ge?: InputMaybe<ConditionString>;
	url_gt?: InputMaybe<ConditionString>;
	url_le?: InputMaybe<ConditionString>;
	url_lt?: InputMaybe<ConditionString>;
	url_ne?: InputMaybe<ConditionString>;
	user_agent_eq?: InputMaybe<ConditionString>;
	user_agent_ge?: InputMaybe<ConditionString>;
	user_agent_gt?: InputMaybe<ConditionString>;
	user_agent_le?: InputMaybe<ConditionString>;
	user_agent_lt?: InputMaybe<ConditionString>;
	user_agent_ne?: InputMaybe<ConditionString>;
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	viewport_height_le?: InputMaybe<ConditionFloat>;
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	viewport_width_le?: InputMaybe<ConditionFloat>;
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export type QueryScansArgs = {
	and?: InputMaybe<Array<ScansAndFilter>>;
	app_build_number_eq?: InputMaybe<ConditionString>;
	app_build_number_ge?: InputMaybe<ConditionString>;
	app_build_number_gt?: InputMaybe<ConditionString>;
	app_build_number_le?: InputMaybe<ConditionString>;
	app_build_number_lt?: InputMaybe<ConditionString>;
	app_build_number_ne?: InputMaybe<ConditionString>;
	app_eq?: InputMaybe<ConditionString>;
	app_ge?: InputMaybe<ConditionString>;
	app_gt?: InputMaybe<ConditionString>;
	app_id_eq?: InputMaybe<ConditionString>;
	app_id_ge?: InputMaybe<ConditionString>;
	app_id_gt?: InputMaybe<ConditionString>;
	app_id_le?: InputMaybe<ConditionString>;
	app_id_lt?: InputMaybe<ConditionString>;
	app_id_ne?: InputMaybe<ConditionString>;
	app_le?: InputMaybe<ConditionString>;
	app_lt?: InputMaybe<ConditionString>;
	app_ne?: InputMaybe<ConditionString>;
	app_version_eq?: InputMaybe<ConditionString>;
	app_version_ge?: InputMaybe<ConditionString>;
	app_version_gt?: InputMaybe<ConditionString>;
	app_version_le?: InputMaybe<ConditionString>;
	app_version_lt?: InputMaybe<ConditionString>;
	app_version_ne?: InputMaybe<ConditionString>;
	companion_app_version_eq?: InputMaybe<ConditionString>;
	companion_app_version_ge?: InputMaybe<ConditionString>;
	companion_app_version_gt?: InputMaybe<ConditionString>;
	companion_app_version_le?: InputMaybe<ConditionString>;
	companion_app_version_lt?: InputMaybe<ConditionString>;
	companion_app_version_ne?: InputMaybe<ConditionString>;
	created_at_eq?: InputMaybe<ConditionDateTime>;
	created_at_ge?: InputMaybe<ConditionDateTime>;
	created_at_gt?: InputMaybe<ConditionDateTime>;
	created_at_last_n_days?: InputMaybe<ConditionInt>;
	created_at_le?: InputMaybe<ConditionDateTime>;
	created_at_lt?: InputMaybe<ConditionDateTime>;
	created_at_ne?: InputMaybe<ConditionDateTime>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	deleted_eq?: InputMaybe<ConditionBoolean>;
	deleted_ge?: InputMaybe<ConditionBoolean>;
	deleted_gt?: InputMaybe<ConditionBoolean>;
	deleted_le?: InputMaybe<ConditionBoolean>;
	deleted_lt?: InputMaybe<ConditionBoolean>;
	deleted_ne?: InputMaybe<ConditionBoolean>;
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	device_manufacturer_le?: InputMaybe<ConditionString>;
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	device_model_eq?: InputMaybe<ConditionString>;
	device_model_ge?: InputMaybe<ConditionString>;
	device_model_gt?: InputMaybe<ConditionString>;
	device_model_le?: InputMaybe<ConditionString>;
	device_model_lt?: InputMaybe<ConditionString>;
	device_model_ne?: InputMaybe<ConditionString>;
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	device_personalized_name_le?: InputMaybe<ConditionString>;
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	device_type_eq?: InputMaybe<ConditionString>;
	device_type_ge?: InputMaybe<ConditionString>;
	device_type_gt?: InputMaybe<ConditionString>;
	device_type_le?: InputMaybe<ConditionString>;
	device_type_lt?: InputMaybe<ConditionString>;
	device_type_ne?: InputMaybe<ConditionString>;
	engines_version_eq?: InputMaybe<ConditionString>;
	engines_version_ge?: InputMaybe<ConditionString>;
	engines_version_gt?: InputMaybe<ConditionString>;
	engines_version_le?: InputMaybe<ConditionString>;
	engines_version_lt?: InputMaybe<ConditionString>;
	engines_version_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<ScansGroup>>>;
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	mobile_kit_eq?: InputMaybe<ConditionBoolean>;
	mobile_kit_ge?: InputMaybe<ConditionBoolean>;
	mobile_kit_gt?: InputMaybe<ConditionBoolean>;
	mobile_kit_le?: InputMaybe<ConditionBoolean>;
	mobile_kit_lt?: InputMaybe<ConditionBoolean>;
	mobile_kit_ne?: InputMaybe<ConditionBoolean>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<ScansOrFilter>>;
	os_eq?: InputMaybe<ConditionString>;
	os_ge?: InputMaybe<ConditionString>;
	os_gt?: InputMaybe<ConditionString>;
	os_le?: InputMaybe<ConditionString>;
	os_lt?: InputMaybe<ConditionString>;
	os_ne?: InputMaybe<ConditionString>;
	os_version_eq?: InputMaybe<ConditionString>;
	os_version_ge?: InputMaybe<ConditionString>;
	os_version_gt?: InputMaybe<ConditionString>;
	os_version_le?: InputMaybe<ConditionString>;
	os_version_lt?: InputMaybe<ConditionString>;
	os_version_ne?: InputMaybe<ConditionString>;
	owner_id_eq?: InputMaybe<ConditionId>;
	owner_id_ge?: InputMaybe<ConditionId>;
	owner_id_gt?: InputMaybe<ConditionId>;
	owner_id_le?: InputMaybe<ConditionId>;
	owner_id_lt?: InputMaybe<ConditionId>;
	owner_id_ne?: InputMaybe<ConditionId>;
	owner_type_eq?: InputMaybe<ConditionString>;
	owner_type_ge?: InputMaybe<ConditionString>;
	owner_type_gt?: InputMaybe<ConditionString>;
	owner_type_le?: InputMaybe<ConditionString>;
	owner_type_lt?: InputMaybe<ConditionString>;
	owner_type_ne?: InputMaybe<ConditionString>;
	product_id_eq?: InputMaybe<ConditionId>;
	product_id_ge?: InputMaybe<ConditionId>;
	product_id_gt?: InputMaybe<ConditionId>;
	product_id_le?: InputMaybe<ConditionId>;
	product_id_lt?: InputMaybe<ConditionId>;
	product_id_ne?: InputMaybe<ConditionId>;
	product_name_eq?: InputMaybe<ConditionString>;
	product_name_ge?: InputMaybe<ConditionString>;
	product_name_gt?: InputMaybe<ConditionString>;
	product_name_le?: InputMaybe<ConditionString>;
	product_name_lt?: InputMaybe<ConditionString>;
	product_name_ne?: InputMaybe<ConditionString>;
	product_version_eq?: InputMaybe<ConditionString>;
	product_version_ge?: InputMaybe<ConditionString>;
	product_version_gt?: InputMaybe<ConditionString>;
	product_version_le?: InputMaybe<ConditionString>;
	product_version_lt?: InputMaybe<ConditionString>;
	product_version_ne?: InputMaybe<ConditionString>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	scan_id_eq?: InputMaybe<ConditionId>;
	scan_id_ge?: InputMaybe<ConditionId>;
	scan_id_gt?: InputMaybe<ConditionId>;
	scan_id_le?: InputMaybe<ConditionId>;
	scan_id_lt?: InputMaybe<ConditionId>;
	scan_id_ne?: InputMaybe<ConditionId>;
	scan_name_eq?: InputMaybe<ConditionString>;
	scan_name_ge?: InputMaybe<ConditionString>;
	scan_name_gt?: InputMaybe<ConditionString>;
	scan_name_le?: InputMaybe<ConditionString>;
	scan_name_lt?: InputMaybe<ConditionString>;
	scan_name_ne?: InputMaybe<ConditionString>;
	sdk_type_eq?: InputMaybe<ConditionString>;
	sdk_type_ge?: InputMaybe<ConditionString>;
	sdk_type_gt?: InputMaybe<ConditionString>;
	sdk_type_le?: InputMaybe<ConditionString>;
	sdk_type_lt?: InputMaybe<ConditionString>;
	sdk_type_ne?: InputMaybe<ConditionString>;
	session_name_eq?: InputMaybe<ConditionString>;
	session_name_ge?: InputMaybe<ConditionString>;
	session_name_gt?: InputMaybe<ConditionString>;
	session_name_le?: InputMaybe<ConditionString>;
	session_name_lt?: InputMaybe<ConditionString>;
	session_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<ScansSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_case_eq?: InputMaybe<ConditionString>;
	test_case_ge?: InputMaybe<ConditionString>;
	test_case_gt?: InputMaybe<ConditionString>;
	test_case_le?: InputMaybe<ConditionString>;
	test_case_lt?: InputMaybe<ConditionString>;
	test_case_ne?: InputMaybe<ConditionString>;
	test_method_eq?: InputMaybe<ConditionString>;
	test_method_ge?: InputMaybe<ConditionString>;
	test_method_gt?: InputMaybe<ConditionString>;
	test_method_le?: InputMaybe<ConditionString>;
	test_method_lt?: InputMaybe<ConditionString>;
	test_method_ne?: InputMaybe<ConditionString>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	test_path_eq?: InputMaybe<ConditionString>;
	test_path_ge?: InputMaybe<ConditionString>;
	test_path_gt?: InputMaybe<ConditionString>;
	test_path_le?: InputMaybe<ConditionString>;
	test_path_lt?: InputMaybe<ConditionString>;
	test_path_ne?: InputMaybe<ConditionString>;
	test_suite_eq?: InputMaybe<ConditionString>;
	test_suite_ge?: InputMaybe<ConditionString>;
	test_suite_gt?: InputMaybe<ConditionString>;
	test_suite_le?: InputMaybe<ConditionString>;
	test_suite_lt?: InputMaybe<ConditionString>;
	test_suite_ne?: InputMaybe<ConditionString>;
	test_unique_identifier_eq?: InputMaybe<ConditionString>;
	test_unique_identifier_ge?: InputMaybe<ConditionString>;
	test_unique_identifier_gt?: InputMaybe<ConditionString>;
	test_unique_identifier_le?: InputMaybe<ConditionString>;
	test_unique_identifier_lt?: InputMaybe<ConditionString>;
	test_unique_identifier_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<ScansSearchInsensitive>;
	text_equals?: InputMaybe<ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<ScansSearch>;
	text_starts_with?: InputMaybe<ScansSearchInsensitive>;
	update_time_eq?: InputMaybe<ConditionDateTime>;
	update_time_ge?: InputMaybe<ConditionDateTime>;
	update_time_gt?: InputMaybe<ConditionDateTime>;
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	update_time_le?: InputMaybe<ConditionDateTime>;
	update_time_lt?: InputMaybe<ConditionDateTime>;
	update_time_ne?: InputMaybe<ConditionDateTime>;
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	viewport_height_le?: InputMaybe<ConditionFloat>;
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	viewport_width_le?: InputMaybe<ConditionFloat>;
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export type QueryScore_Web_ProductsArgs = {
	and?: InputMaybe<Array<Score_Web_ProductsAndFilter>>;
	calculation_date_eq?: InputMaybe<ConditionDateTime>;
	calculation_date_ge?: InputMaybe<ConditionDateTime>;
	calculation_date_gt?: InputMaybe<ConditionDateTime>;
	calculation_date_last_n_days?: InputMaybe<ConditionInt>;
	calculation_date_le?: InputMaybe<ConditionDateTime>;
	calculation_date_lt?: InputMaybe<ConditionDateTime>;
	calculation_date_ne?: InputMaybe<ConditionDateTime>;
	created_at_eq?: InputMaybe<ConditionDateTime>;
	created_at_ge?: InputMaybe<ConditionDateTime>;
	created_at_gt?: InputMaybe<ConditionDateTime>;
	created_at_last_n_days?: InputMaybe<ConditionInt>;
	created_at_le?: InputMaybe<ConditionDateTime>;
	created_at_lt?: InputMaybe<ConditionDateTime>;
	created_at_ne?: InputMaybe<ConditionDateTime>;
	environment_eq?: InputMaybe<ConditionString>;
	environment_ge?: InputMaybe<ConditionString>;
	environment_gt?: InputMaybe<ConditionString>;
	environment_le?: InputMaybe<ConditionString>;
	environment_lt?: InputMaybe<ConditionString>;
	environment_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<Score_Web_ProductsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Score_Web_ProductsOrFilter>>;
	score_eq?: InputMaybe<ConditionFloat>;
	score_ge?: InputMaybe<ConditionFloat>;
	score_gt?: InputMaybe<ConditionFloat>;
	score_le?: InputMaybe<ConditionFloat>;
	score_lt?: InputMaybe<ConditionFloat>;
	score_ne?: InputMaybe<ConditionFloat>;
	sort?: InputMaybe<Score_Web_ProductsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_ends_with?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_equals?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_regex_match?: InputMaybe<Score_Web_ProductsSearch>;
	text_starts_with?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	timeframe_days_eq?: InputMaybe<ConditionInt>;
	timeframe_days_ge?: InputMaybe<ConditionInt>;
	timeframe_days_gt?: InputMaybe<ConditionInt>;
	timeframe_days_le?: InputMaybe<ConditionInt>;
	timeframe_days_lt?: InputMaybe<ConditionInt>;
	timeframe_days_ne?: InputMaybe<ConditionInt>;
	total_issues_critical_eq?: InputMaybe<ConditionInt>;
	total_issues_critical_ge?: InputMaybe<ConditionInt>;
	total_issues_critical_gt?: InputMaybe<ConditionInt>;
	total_issues_critical_le?: InputMaybe<ConditionInt>;
	total_issues_critical_lt?: InputMaybe<ConditionInt>;
	total_issues_critical_ne?: InputMaybe<ConditionInt>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_issues_serious_eq?: InputMaybe<ConditionInt>;
	total_issues_serious_ge?: InputMaybe<ConditionInt>;
	total_issues_serious_gt?: InputMaybe<ConditionInt>;
	total_issues_serious_le?: InputMaybe<ConditionInt>;
	total_issues_serious_lt?: InputMaybe<ConditionInt>;
	total_issues_serious_ne?: InputMaybe<ConditionInt>;
	unique_issues_critical_eq?: InputMaybe<ConditionInt>;
	unique_issues_critical_ge?: InputMaybe<ConditionInt>;
	unique_issues_critical_gt?: InputMaybe<ConditionInt>;
	unique_issues_critical_le?: InputMaybe<ConditionInt>;
	unique_issues_critical_lt?: InputMaybe<ConditionInt>;
	unique_issues_critical_ne?: InputMaybe<ConditionInt>;
	unique_issues_eq?: InputMaybe<ConditionInt>;
	unique_issues_ge?: InputMaybe<ConditionInt>;
	unique_issues_gt?: InputMaybe<ConditionInt>;
	unique_issues_le?: InputMaybe<ConditionInt>;
	unique_issues_lt?: InputMaybe<ConditionInt>;
	unique_issues_ne?: InputMaybe<ConditionInt>;
	unique_issues_serious_eq?: InputMaybe<ConditionInt>;
	unique_issues_serious_ge?: InputMaybe<ConditionInt>;
	unique_issues_serious_gt?: InputMaybe<ConditionInt>;
	unique_issues_serious_le?: InputMaybe<ConditionInt>;
	unique_issues_serious_lt?: InputMaybe<ConditionInt>;
	unique_issues_serious_ne?: InputMaybe<ConditionInt>;
	unit_id_eq?: InputMaybe<ConditionString>;
	unit_id_ge?: InputMaybe<ConditionString>;
	unit_id_gt?: InputMaybe<ConditionString>;
	unit_id_le?: InputMaybe<ConditionString>;
	unit_id_lt?: InputMaybe<ConditionString>;
	unit_id_ne?: InputMaybe<ConditionString>;
};

export type QueryUniqueness_IssuesArgs = {
	and?: InputMaybe<Array<Uniqueness_IssuesAndFilter>>;
	business_unit_eq?: InputMaybe<ConditionString>;
	business_unit_ge?: InputMaybe<ConditionString>;
	business_unit_gt?: InputMaybe<ConditionString>;
	business_unit_le?: InputMaybe<ConditionString>;
	business_unit_lt?: InputMaybe<ConditionString>;
	business_unit_ne?: InputMaybe<ConditionString>;
	environment_eq?: InputMaybe<ConditionString>;
	environment_ge?: InputMaybe<ConditionString>;
	environment_gt?: InputMaybe<ConditionString>;
	environment_le?: InputMaybe<ConditionString>;
	environment_lt?: InputMaybe<ConditionString>;
	environment_ne?: InputMaybe<ConditionString>;
	first_seen_eq?: InputMaybe<ConditionDateTime>;
	first_seen_ge?: InputMaybe<ConditionDateTime>;
	first_seen_gt?: InputMaybe<ConditionDateTime>;
	first_seen_last_n_days?: InputMaybe<ConditionInt>;
	first_seen_le?: InputMaybe<ConditionDateTime>;
	first_seen_lt?: InputMaybe<ConditionDateTime>;
	first_seen_ne?: InputMaybe<ConditionDateTime>;
	group?: InputMaybe<Array<InputMaybe<Uniqueness_IssuesGroup>>>;
	issue_type_eq?: InputMaybe<ConditionString>;
	issue_type_ge?: InputMaybe<ConditionString>;
	issue_type_gt?: InputMaybe<ConditionString>;
	issue_type_le?: InputMaybe<ConditionString>;
	issue_type_lt?: InputMaybe<ConditionString>;
	issue_type_ne?: InputMaybe<ConditionString>;
	last_issue_id_eq?: InputMaybe<ConditionId>;
	last_issue_id_ge?: InputMaybe<ConditionId>;
	last_issue_id_gt?: InputMaybe<ConditionId>;
	last_issue_id_le?: InputMaybe<ConditionId>;
	last_issue_id_lt?: InputMaybe<ConditionId>;
	last_issue_id_ne?: InputMaybe<ConditionId>;
	last_seen_eq?: InputMaybe<ConditionDateTime>;
	last_seen_ge?: InputMaybe<ConditionDateTime>;
	last_seen_gt?: InputMaybe<ConditionDateTime>;
	last_seen_last_n_days?: InputMaybe<ConditionInt>;
	last_seen_le?: InputMaybe<ConditionDateTime>;
	last_seen_lt?: InputMaybe<ConditionDateTime>;
	last_seen_ne?: InputMaybe<ConditionDateTime>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Uniqueness_IssuesOrFilter>>;
	page_title_eq?: InputMaybe<ConditionString>;
	page_title_ge?: InputMaybe<ConditionString>;
	page_title_gt?: InputMaybe<ConditionString>;
	page_title_le?: InputMaybe<ConditionString>;
	page_title_lt?: InputMaybe<ConditionString>;
	page_title_ne?: InputMaybe<ConditionString>;
	page_url_eq?: InputMaybe<ConditionString>;
	page_url_ge?: InputMaybe<ConditionString>;
	page_url_gt?: InputMaybe<ConditionString>;
	page_url_le?: InputMaybe<ConditionString>;
	page_url_lt?: InputMaybe<ConditionString>;
	page_url_ne?: InputMaybe<ConditionString>;
	product_name_eq?: InputMaybe<ConditionString>;
	product_name_ge?: InputMaybe<ConditionString>;
	product_name_gt?: InputMaybe<ConditionString>;
	product_name_le?: InputMaybe<ConditionString>;
	product_name_lt?: InputMaybe<ConditionString>;
	product_name_ne?: InputMaybe<ConditionString>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	severity_eq?: InputMaybe<ConditionString>;
	severity_ge?: InputMaybe<ConditionString>;
	severity_gt?: InputMaybe<ConditionString>;
	severity_le?: InputMaybe<ConditionString>;
	severity_lt?: InputMaybe<ConditionString>;
	severity_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Uniqueness_IssuesSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_equals?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<Uniqueness_IssuesSearch>;
	text_starts_with?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	uniqueness_id_eq?: InputMaybe<ConditionId>;
	uniqueness_id_ge?: InputMaybe<ConditionId>;
	uniqueness_id_gt?: InputMaybe<ConditionId>;
	uniqueness_id_le?: InputMaybe<ConditionId>;
	uniqueness_id_lt?: InputMaybe<ConditionId>;
	uniqueness_id_ne?: InputMaybe<ConditionId>;
};

export type QueryWfa_Session_Components_RunsArgs = {
	and?: InputMaybe<Array<Wfa_Session_Components_RunsAndFilter>>;
	component_id_eq?: InputMaybe<ConditionString>;
	component_id_ge?: InputMaybe<ConditionString>;
	component_id_gt?: InputMaybe<ConditionString>;
	component_id_le?: InputMaybe<ConditionString>;
	component_id_lt?: InputMaybe<ConditionString>;
	component_id_ne?: InputMaybe<ConditionString>;
	conformance_eq_any_item?: InputMaybe<ConditionString>;
	conformance_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_ge_any_item?: InputMaybe<ConditionString>;
	conformance_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_gt_any_item?: InputMaybe<ConditionString>;
	conformance_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_le_any_item?: InputMaybe<ConditionString>;
	conformance_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_lt_any_item?: InputMaybe<ConditionString>;
	conformance_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	conformance_ne_any_item?: InputMaybe<ConditionString>;
	conformance_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	conformance_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Wfa_Session_Components_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wfa_Session_Components_RunsOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_ids_eq_any_item?: InputMaybe<ConditionString>;
	severity_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_ids_ge_any_item?: InputMaybe<ConditionString>;
	severity_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_ids_gt_any_item?: InputMaybe<ConditionString>;
	severity_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_ids_le_any_item?: InputMaybe<ConditionString>;
	severity_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_ids_lt_any_item?: InputMaybe<ConditionString>;
	severity_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_ids_ne_any_item?: InputMaybe<ConditionString>;
	severity_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_names_eq_any_item?: InputMaybe<ConditionString>;
	severity_names_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_names_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_names_ge_any_item?: InputMaybe<ConditionString>;
	severity_names_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_names_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_names_gt_any_item?: InputMaybe<ConditionString>;
	severity_names_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_names_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_names_le_any_item?: InputMaybe<ConditionString>;
	severity_names_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_names_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_names_lt_any_item?: InputMaybe<ConditionString>;
	severity_names_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_names_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	severity_names_ne_any_item?: InputMaybe<ConditionString>;
	severity_names_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	severity_names_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	sort?: InputMaybe<Wfa_Session_Components_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Components_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_pages_eq?: InputMaybe<ConditionInt>;
	total_pages_ge?: InputMaybe<ConditionInt>;
	total_pages_gt?: InputMaybe<ConditionInt>;
	total_pages_le?: InputMaybe<ConditionInt>;
	total_pages_lt?: InputMaybe<ConditionInt>;
	total_pages_ne?: InputMaybe<ConditionInt>;
	type_ids_eq_any_item?: InputMaybe<ConditionString>;
	type_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_ids_ge_any_item?: InputMaybe<ConditionString>;
	type_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_ids_gt_any_item?: InputMaybe<ConditionString>;
	type_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_ids_le_any_item?: InputMaybe<ConditionString>;
	type_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_ids_lt_any_item?: InputMaybe<ConditionString>;
	type_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_ids_ne_any_item?: InputMaybe<ConditionString>;
	type_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_names_eq_any_item?: InputMaybe<ConditionString>;
	type_names_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_names_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_names_ge_any_item?: InputMaybe<ConditionString>;
	type_names_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_names_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_names_gt_any_item?: InputMaybe<ConditionString>;
	type_names_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_names_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_names_le_any_item?: InputMaybe<ConditionString>;
	type_names_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_names_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_names_lt_any_item?: InputMaybe<ConditionString>;
	type_names_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_names_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	type_names_ne_any_item?: InputMaybe<ConditionString>;
	type_names_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	type_names_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	urls_eq_any_item?: InputMaybe<ConditionString>;
	urls_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	urls_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	urls_ge_any_item?: InputMaybe<ConditionString>;
	urls_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	urls_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	urls_gt_any_item?: InputMaybe<ConditionString>;
	urls_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	urls_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	urls_le_any_item?: InputMaybe<ConditionString>;
	urls_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	urls_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	urls_lt_any_item?: InputMaybe<ConditionString>;
	urls_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	urls_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	urls_ne_any_item?: InputMaybe<ConditionString>;
	urls_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	urls_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
};

export type QueryWfa_Session_Run_LabelsArgs = {
	and?: InputMaybe<Array<Wfa_Session_Run_LabelsAndFilter>>;
	custom_field_key_eq?: InputMaybe<ConditionString>;
	custom_field_key_ge?: InputMaybe<ConditionString>;
	custom_field_key_gt?: InputMaybe<ConditionString>;
	custom_field_key_le?: InputMaybe<ConditionString>;
	custom_field_key_lt?: InputMaybe<ConditionString>;
	custom_field_key_ne?: InputMaybe<ConditionString>;
	custom_field_values_eq_any_item?: InputMaybe<ConditionString>;
	custom_field_values_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_field_values_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_field_values_ge_any_item?: InputMaybe<ConditionString>;
	custom_field_values_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_field_values_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_field_values_gt_any_item?: InputMaybe<ConditionString>;
	custom_field_values_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_field_values_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_field_values_le_any_item?: InputMaybe<ConditionString>;
	custom_field_values_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_field_values_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_field_values_lt_any_item?: InputMaybe<ConditionString>;
	custom_field_values_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_field_values_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_field_values_ne_any_item?: InputMaybe<ConditionString>;
	custom_field_values_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_field_values_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Wfa_Session_Run_LabelsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wfa_Session_Run_LabelsOrFilter>>;
	sort?: InputMaybe<Wfa_Session_Run_LabelsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Run_LabelsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
};

export type QueryWfa_Session_RunsArgs = {
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	and?: InputMaybe<Array<Wfa_Session_RunsAndFilter>>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	domain_eq?: InputMaybe<ConditionString>;
	domain_ge?: InputMaybe<ConditionString>;
	domain_gt?: InputMaybe<ConditionString>;
	domain_le?: InputMaybe<ConditionString>;
	domain_lt?: InputMaybe<ConditionString>;
	domain_ne?: InputMaybe<ConditionString>;
	environments_eq_any_item?: InputMaybe<ConditionString>;
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item?: InputMaybe<ConditionString>;
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item?: InputMaybe<ConditionString>;
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_le_any_item?: InputMaybe<ConditionString>;
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item?: InputMaybe<ConditionString>;
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item?: InputMaybe<ConditionString>;
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item?: InputMaybe<ConditionString>;
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item?: InputMaybe<ConditionString>;
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item?: InputMaybe<ConditionString>;
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_le_any_item?: InputMaybe<ConditionString>;
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item?: InputMaybe<ConditionString>;
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item?: InputMaybe<ConditionString>;
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Wfa_Session_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wfa_Session_RunsOrFilter>>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	session_name_eq?: InputMaybe<ConditionString>;
	session_name_ge?: InputMaybe<ConditionString>;
	session_name_gt?: InputMaybe<ConditionString>;
	session_name_le?: InputMaybe<ConditionString>;
	session_name_lt?: InputMaybe<ConditionString>;
	session_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Wfa_Session_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_pages_eq?: InputMaybe<ConditionInt>;
	total_pages_ge?: InputMaybe<ConditionInt>;
	total_pages_gt?: InputMaybe<ConditionInt>;
	total_pages_le?: InputMaybe<ConditionInt>;
	total_pages_lt?: InputMaybe<ConditionInt>;
	total_pages_ne?: InputMaybe<ConditionInt>;
	update_time_eq?: InputMaybe<ConditionDateTime>;
	update_time_ge?: InputMaybe<ConditionDateTime>;
	update_time_gt?: InputMaybe<ConditionDateTime>;
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	update_time_le?: InputMaybe<ConditionDateTime>;
	update_time_lt?: InputMaybe<ConditionDateTime>;
	update_time_ne?: InputMaybe<ConditionDateTime>;
	user_name_eq?: InputMaybe<ConditionString>;
	user_name_ge?: InputMaybe<ConditionString>;
	user_name_gt?: InputMaybe<ConditionString>;
	user_name_le?: InputMaybe<ConditionString>;
	user_name_lt?: InputMaybe<ConditionString>;
	user_name_ne?: InputMaybe<ConditionString>;
};

export type QueryWfa_Session_Type_RunsArgs = {
	and?: InputMaybe<Array<Wfa_Session_Type_RunsAndFilter>>;
	group?: InputMaybe<Array<InputMaybe<Wfa_Session_Type_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wfa_Session_Type_RunsOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	severity_id_eq?: InputMaybe<ConditionString>;
	severity_id_ge?: InputMaybe<ConditionString>;
	severity_id_gt?: InputMaybe<ConditionString>;
	severity_id_le?: InputMaybe<ConditionString>;
	severity_id_lt?: InputMaybe<ConditionString>;
	severity_id_ne?: InputMaybe<ConditionString>;
	severity_name_eq?: InputMaybe<ConditionString>;
	severity_name_ge?: InputMaybe<ConditionString>;
	severity_name_gt?: InputMaybe<ConditionString>;
	severity_name_le?: InputMaybe<ConditionString>;
	severity_name_lt?: InputMaybe<ConditionString>;
	severity_name_ne?: InputMaybe<ConditionString>;
	sort?: InputMaybe<Wfa_Session_Type_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Type_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	type_id_eq?: InputMaybe<ConditionString>;
	type_id_ge?: InputMaybe<ConditionString>;
	type_id_gt?: InputMaybe<ConditionString>;
	type_id_le?: InputMaybe<ConditionString>;
	type_id_lt?: InputMaybe<ConditionString>;
	type_id_ne?: InputMaybe<ConditionString>;
	type_name_eq?: InputMaybe<ConditionString>;
	type_name_ge?: InputMaybe<ConditionString>;
	type_name_gt?: InputMaybe<ConditionString>;
	type_name_le?: InputMaybe<ConditionString>;
	type_name_lt?: InputMaybe<ConditionString>;
	type_name_ne?: InputMaybe<ConditionString>;
};

export type QueryWfa_Top_Critical_ComponentsArgs = {
	and?: InputMaybe<Array<Wfa_Top_Critical_ComponentsAndFilter>>;
	critical_issues_count_eq?: InputMaybe<ConditionInt>;
	critical_issues_count_ge?: InputMaybe<ConditionInt>;
	critical_issues_count_gt?: InputMaybe<ConditionInt>;
	critical_issues_count_le?: InputMaybe<ConditionInt>;
	critical_issues_count_lt?: InputMaybe<ConditionInt>;
	critical_issues_count_ne?: InputMaybe<ConditionInt>;
	critical_percentage_eq?: InputMaybe<ConditionFloat>;
	critical_percentage_ge?: InputMaybe<ConditionFloat>;
	critical_percentage_gt?: InputMaybe<ConditionFloat>;
	critical_percentage_le?: InputMaybe<ConditionFloat>;
	critical_percentage_lt?: InputMaybe<ConditionFloat>;
	critical_percentage_ne?: InputMaybe<ConditionFloat>;
	elements__component_id_eq?: InputMaybe<ConditionString>;
	elements__component_id_ge?: InputMaybe<ConditionString>;
	elements__component_id_gt?: InputMaybe<ConditionString>;
	elements__component_id_le?: InputMaybe<ConditionString>;
	elements__component_id_lt?: InputMaybe<ConditionString>;
	elements__component_id_ne?: InputMaybe<ConditionString>;
	group?: InputMaybe<Array<InputMaybe<Wfa_Top_Critical_ComponentsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wfa_Top_Critical_ComponentsOrFilter>>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	sort?: InputMaybe<Wfa_Top_Critical_ComponentsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Top_Critical_ComponentsSearch>;
	text_starts_with?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
};

export type QueryWsdk_Latest_Test_RunsArgs = {
	and?: InputMaybe<Array<Wsdk_Latest_Test_RunsAndFilter>>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	environments_eq_any_item?: InputMaybe<ConditionString>;
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item?: InputMaybe<ConditionString>;
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item?: InputMaybe<ConditionString>;
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_le_any_item?: InputMaybe<ConditionString>;
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item?: InputMaybe<ConditionString>;
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item?: InputMaybe<ConditionString>;
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item?: InputMaybe<ConditionString>;
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item?: InputMaybe<ConditionString>;
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item?: InputMaybe<ConditionString>;
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_le_any_item?: InputMaybe<ConditionString>;
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item?: InputMaybe<ConditionString>;
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item?: InputMaybe<ConditionString>;
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Wsdk_Latest_Test_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wsdk_Latest_Test_RunsOrFilter>>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	sort?: InputMaybe<Wsdk_Latest_Test_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	test_path_eq?: InputMaybe<ConditionString>;
	test_path_ge?: InputMaybe<ConditionString>;
	test_path_gt?: InputMaybe<ConditionString>;
	test_path_le?: InputMaybe<ConditionString>;
	test_path_lt?: InputMaybe<ConditionString>;
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Latest_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_pages_eq?: InputMaybe<ConditionInt>;
	total_pages_ge?: InputMaybe<ConditionInt>;
	total_pages_gt?: InputMaybe<ConditionInt>;
	total_pages_le?: InputMaybe<ConditionInt>;
	total_pages_lt?: InputMaybe<ConditionInt>;
	total_pages_ne?: InputMaybe<ConditionInt>;
};

export type QueryWsdk_Test_LabelsArgs = {
	and?: InputMaybe<Array<Wsdk_Test_LabelsAndFilter>>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	environments_eq_any_item?: InputMaybe<ConditionString>;
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item?: InputMaybe<ConditionString>;
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item?: InputMaybe<ConditionString>;
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_le_any_item?: InputMaybe<ConditionString>;
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item?: InputMaybe<ConditionString>;
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item?: InputMaybe<ConditionString>;
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item?: InputMaybe<ConditionString>;
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item?: InputMaybe<ConditionString>;
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item?: InputMaybe<ConditionString>;
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_le_any_item?: InputMaybe<ConditionString>;
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item?: InputMaybe<ConditionString>;
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item?: InputMaybe<ConditionString>;
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Wsdk_Test_LabelsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wsdk_Test_LabelsOrFilter>>;
	sort?: InputMaybe<Wsdk_Test_LabelsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Test_LabelsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
};

export type QueryWsdk_Test_RunsArgs = {
	and?: InputMaybe<Array<Wsdk_Test_RunsAndFilter>>;
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	critical_issues_eq?: InputMaybe<ConditionInt>;
	critical_issues_ge?: InputMaybe<ConditionInt>;
	critical_issues_gt?: InputMaybe<ConditionInt>;
	critical_issues_le?: InputMaybe<ConditionInt>;
	critical_issues_lt?: InputMaybe<ConditionInt>;
	critical_issues_ne?: InputMaybe<ConditionInt>;
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	environments_eq_any_item?: InputMaybe<ConditionString>;
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item?: InputMaybe<ConditionString>;
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item?: InputMaybe<ConditionString>;
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_le_any_item?: InputMaybe<ConditionString>;
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item?: InputMaybe<ConditionString>;
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item?: InputMaybe<ConditionString>;
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item?: InputMaybe<ConditionString>;
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item?: InputMaybe<ConditionString>;
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item?: InputMaybe<ConditionString>;
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_le_any_item?: InputMaybe<ConditionString>;
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item?: InputMaybe<ConditionString>;
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item?: InputMaybe<ConditionString>;
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	group?: InputMaybe<Array<InputMaybe<Wsdk_Test_RunsGroup>>>;
	limit?: InputMaybe<Scalars['Int']['input']>;
	minor_issues_eq?: InputMaybe<ConditionInt>;
	minor_issues_ge?: InputMaybe<ConditionInt>;
	minor_issues_gt?: InputMaybe<ConditionInt>;
	minor_issues_le?: InputMaybe<ConditionInt>;
	minor_issues_lt?: InputMaybe<ConditionInt>;
	minor_issues_ne?: InputMaybe<ConditionInt>;
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	moderate_issues_le?: InputMaybe<ConditionInt>;
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	offset?: InputMaybe<Scalars['Int']['input']>;
	or?: InputMaybe<Array<Wsdk_Test_RunsOrFilter>>;
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	run_id_eq?: InputMaybe<ConditionId>;
	run_id_ge?: InputMaybe<ConditionId>;
	run_id_gt?: InputMaybe<ConditionId>;
	run_id_le?: InputMaybe<ConditionId>;
	run_id_lt?: InputMaybe<ConditionId>;
	run_id_ne?: InputMaybe<ConditionId>;
	run_time_eq?: InputMaybe<ConditionDateTime>;
	run_time_ge?: InputMaybe<ConditionDateTime>;
	run_time_gt?: InputMaybe<ConditionDateTime>;
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	run_time_le?: InputMaybe<ConditionDateTime>;
	run_time_lt?: InputMaybe<ConditionDateTime>;
	run_time_ne?: InputMaybe<ConditionDateTime>;
	serious_issues_eq?: InputMaybe<ConditionInt>;
	serious_issues_ge?: InputMaybe<ConditionInt>;
	serious_issues_gt?: InputMaybe<ConditionInt>;
	serious_issues_le?: InputMaybe<ConditionInt>;
	serious_issues_lt?: InputMaybe<ConditionInt>;
	serious_issues_ne?: InputMaybe<ConditionInt>;
	sort?: InputMaybe<Wsdk_Test_RunsSort>;
	tenant_id_eq?: InputMaybe<ConditionId>;
	tenant_id_ge?: InputMaybe<ConditionId>;
	tenant_id_gt?: InputMaybe<ConditionId>;
	tenant_id_le?: InputMaybe<ConditionId>;
	tenant_id_lt?: InputMaybe<ConditionId>;
	tenant_id_ne?: InputMaybe<ConditionId>;
	test_name_eq?: InputMaybe<ConditionString>;
	test_name_ge?: InputMaybe<ConditionString>;
	test_name_gt?: InputMaybe<ConditionString>;
	test_name_le?: InputMaybe<ConditionString>;
	test_name_lt?: InputMaybe<ConditionString>;
	test_name_ne?: InputMaybe<ConditionString>;
	test_path_eq?: InputMaybe<ConditionString>;
	test_path_ge?: InputMaybe<ConditionString>;
	test_path_gt?: InputMaybe<ConditionString>;
	test_path_le?: InputMaybe<ConditionString>;
	test_path_lt?: InputMaybe<ConditionString>;
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	total_issues_eq?: InputMaybe<ConditionInt>;
	total_issues_ge?: InputMaybe<ConditionInt>;
	total_issues_gt?: InputMaybe<ConditionInt>;
	total_issues_le?: InputMaybe<ConditionInt>;
	total_issues_lt?: InputMaybe<ConditionInt>;
	total_issues_ne?: InputMaybe<ConditionInt>;
	total_pages_eq?: InputMaybe<ConditionInt>;
	total_pages_ge?: InputMaybe<ConditionInt>;
	total_pages_gt?: InputMaybe<ConditionInt>;
	total_pages_le?: InputMaybe<ConditionInt>;
	total_pages_lt?: InputMaybe<ConditionInt>;
	total_pages_ne?: InputMaybe<ConditionInt>;
};

export type SingleConditionString = {
	value: Scalars['String']['input'];
};

/** Used to combine the clauses in condition */
export enum ConditionOperators {
	All = 'All',
	Any = 'Any'
}

export type Core_Label_Issues = {
	__typename?: 'core_label_issues';
	business_unit: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	business_unit_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	business_unit_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	business_unit_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	business_unit_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	business_unit_min: Scalars['String']['output'];
	deleted: Scalars['Boolean']['output'];
	environment: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	environment_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	environment_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_min: Scalars['String']['output'];
	issue_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	issue_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	page_title: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	page_title_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	page_title_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_min: Scalars['String']['output'];
	product_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_min: Scalars['String']['output'];
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	session_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	session_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	session_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_min: Scalars['String']['output'];
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
	url: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	url_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	url_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_min: Scalars['String']['output'];
	user_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	user_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	user_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_min: Scalars['String']['output'];
	validation_status: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_status_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_status_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	validation_status_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	validation_status_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_status_min: Scalars['String']['output'];
	version: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	version_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	version_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	version_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	version_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	version_sum: Scalars['Int']['output'];
};

export type Core_Label_IssuesBusiness_Unit_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesBusiness_Unit_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesEnvironment_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesEnvironment_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesIssue_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Core_Label_IssuesIssue_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesPage_Title_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesPage_Title_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesProduct_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesProduct_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Core_Label_IssuesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Core_Label_IssuesRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesSession_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesSession_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesSeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesSeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Core_Label_IssuesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesUrl_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesUrl_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesUser_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesUser_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesValidation_Status_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Core_Label_IssuesValidation_Status_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesVersion_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Core_Label_IssuesVersion_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for core_label_issues queries. */
export type Core_Label_IssuesAndFilter = {
	/** Equals (FieldName: business_unit) */
	business_unit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: business_unit) */
	business_unit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: business_unit) */
	business_unit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: business_unit) */
	business_unit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: business_unit) */
	business_unit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: business_unit) */
	business_unit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: issue_id) */
	issue_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: issue_id) */
	issue_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: issue_id) */
	issue_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: issue_id) */
	issue_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: issue_id) */
	issue_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: issue_id) */
	issue_id_ne?: InputMaybe<ConditionId>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Core_Label_IssuesOrFilter>>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_equals?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<Core_Label_IssuesSearch>;
	text_starts_with?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: url) */
	url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: url) */
	url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: url) */
	url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: url) */
	url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: url) */
	url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: url) */
	url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: user_name) */
	user_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_name) */
	user_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_name) */
	user_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_name) */
	user_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_name) */
	user_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_name) */
	user_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: validation_status) */
	validation_status_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: validation_status) */
	validation_status_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: validation_status) */
	validation_status_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: validation_status) */
	validation_status_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: validation_status) */
	validation_status_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: validation_status) */
	validation_status_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: version) */
	version_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: version) */
	version_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: version) */
	version_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: version) */
	version_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: version) */
	version_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: version) */
	version_ne?: InputMaybe<ConditionInt>;
};

export enum Core_Label_IssuesGroup {
	BusinessUnit = 'business_unit',
	BusinessUnitAny = 'business_unit_any',
	BusinessUnitCount = 'business_unit_count',
	BusinessUnitGroupUniqArray = 'business_unit_group_uniq_array',
	BusinessUnitMax = 'business_unit_max',
	BusinessUnitMin = 'business_unit_min',
	Deleted = 'deleted',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	IssueId = 'issue_id',
	IssueIdAny = 'issue_id_any',
	IssueIdCount = 'issue_id_count',
	IssueIdGroupUniqArray = 'issue_id_group_uniq_array',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min',
	Url = 'url',
	UrlAny = 'url_any',
	UrlCount = 'url_count',
	UrlGroupUniqArray = 'url_group_uniq_array',
	UrlMax = 'url_max',
	UrlMin = 'url_min',
	UserName = 'user_name',
	UserNameAny = 'user_name_any',
	UserNameCount = 'user_name_count',
	UserNameGroupUniqArray = 'user_name_group_uniq_array',
	UserNameMax = 'user_name_max',
	UserNameMin = 'user_name_min',
	ValidationStatus = 'validation_status',
	ValidationStatusAny = 'validation_status_any',
	ValidationStatusCount = 'validation_status_count',
	ValidationStatusGroupUniqArray = 'validation_status_group_uniq_array',
	ValidationStatusMax = 'validation_status_max',
	ValidationStatusMin = 'validation_status_min',
	Version = 'version',
	VersionAny = 'version_any',
	VersionCount = 'version_count',
	VersionGroupUniqArray = 'version_group_uniq_array',
	VersionMax = 'version_max',
	VersionMin = 'version_min',
	VersionSum = 'version_sum'
}

/** Logical OR filter group for core_label_issues queries. */
export type Core_Label_IssuesOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Core_Label_IssuesAndFilter>>;
	/** Equals (FieldName: business_unit) */
	business_unit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: business_unit) */
	business_unit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: business_unit) */
	business_unit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: business_unit) */
	business_unit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: business_unit) */
	business_unit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: business_unit) */
	business_unit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: issue_id) */
	issue_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: issue_id) */
	issue_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: issue_id) */
	issue_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: issue_id) */
	issue_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: issue_id) */
	issue_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: issue_id) */
	issue_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_equals?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<Core_Label_IssuesSearch>;
	text_starts_with?: InputMaybe<Core_Label_IssuesSearchInsensitive>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: url) */
	url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: url) */
	url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: url) */
	url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: url) */
	url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: url) */
	url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: url) */
	url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: user_name) */
	user_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_name) */
	user_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_name) */
	user_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_name) */
	user_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_name) */
	user_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_name) */
	user_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: validation_status) */
	validation_status_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: validation_status) */
	validation_status_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: validation_status) */
	validation_status_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: validation_status) */
	validation_status_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: validation_status) */
	validation_status_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: validation_status) */
	validation_status_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: version) */
	version_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: version) */
	version_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: version) */
	version_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: version) */
	version_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: version) */
	version_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: version) */
	version_ne?: InputMaybe<ConditionInt>;
};

export type Core_Label_IssuesSearch = {
	searchFields: Array<Core_Label_IssuesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Core_Label_IssuesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Core_Label_IssuesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Core_Label_IssuesSort = {
	fields: Array<Core_Label_IssuesSortFields>;
	order?: InputMaybe<Core_Label_IssuesSortOrder>;
};

export enum Core_Label_IssuesSortFields {
	BusinessUnit = 'business_unit',
	BusinessUnitAny = 'business_unit_any',
	BusinessUnitCount = 'business_unit_count',
	BusinessUnitGroupUniqArray = 'business_unit_group_uniq_array',
	BusinessUnitMax = 'business_unit_max',
	BusinessUnitMin = 'business_unit_min',
	Deleted = 'deleted',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	IssueId = 'issue_id',
	IssueIdAny = 'issue_id_any',
	IssueIdCount = 'issue_id_count',
	IssueIdGroupUniqArray = 'issue_id_group_uniq_array',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min',
	Url = 'url',
	UrlAny = 'url_any',
	UrlCount = 'url_count',
	UrlGroupUniqArray = 'url_group_uniq_array',
	UrlMax = 'url_max',
	UrlMin = 'url_min',
	UserName = 'user_name',
	UserNameAny = 'user_name_any',
	UserNameCount = 'user_name_count',
	UserNameGroupUniqArray = 'user_name_group_uniq_array',
	UserNameMax = 'user_name_max',
	UserNameMin = 'user_name_min',
	ValidationStatus = 'validation_status',
	ValidationStatusAny = 'validation_status_any',
	ValidationStatusCount = 'validation_status_count',
	ValidationStatusGroupUniqArray = 'validation_status_group_uniq_array',
	ValidationStatusMax = 'validation_status_max',
	ValidationStatusMin = 'validation_status_min',
	Version = 'version',
	VersionAny = 'version_any',
	VersionCount = 'version_count',
	VersionGroupUniqArray = 'version_group_uniq_array',
	VersionMax = 'version_max',
	VersionMin = 'version_min',
	VersionSum = 'version_sum'
}

/** An example enum type */
export enum Core_Label_IssuesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Core_Label_IssuesTextSearchFields {
	BusinessUnit = 'business_unit',
	Deleted = 'deleted',
	Environment = 'environment',
	IssueId = 'issue_id',
	PageTitle = 'page_title',
	ProductName = 'product_name',
	RunId = 'run_id',
	RunTime = 'run_time',
	SessionName = 'session_name',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TypeName = 'type_name',
	Url = 'url',
	UserName = 'user_name',
	ValidationStatus = 'validation_status',
	Version = 'version'
}

export type Issues = {
	__typename?: 'issues';
	/** selector of DOM */
	analysis_root_selector: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	analysis_root_selector_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_min: Scalars['String']['output'];
	/** time of the issue detection on client side */
	analysis_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	analysis_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	analysis_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	analysis_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	analysis_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** app name */
	app: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_any: Scalars['String']['output'];
	/** app build number */
	app_build_number: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_build_number_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_build_number_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** app identifier */
	app_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_min: Scalars['String']['output'];
	/** app version */
	app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_min: Scalars['String']['output'];
	/** axe results - additional information */
	axe_additional_information: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	axe_additional_information_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	axe_additional_information_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	axe_additional_information_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	axe_additional_information_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	axe_additional_information_min: Scalars['String']['output'];
	/** canonical url - extracted from the page */
	canonical_url: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	canonical_url_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	canonical_url_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	canonical_url_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	canonical_url_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	canonical_url_min: Scalars['String']['output'];
	/** client version - as populated by the sdk */
	client_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	client_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	client_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	client_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	client_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	client_version_min: Scalars['String']['output'];
	/** companion app version */
	companion_app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	companion_app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	companion_app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_min: Scalars['String']['output'];
	/** conformance level of the issue */
	conformance: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	conformance_any: Array<Scalars['String']['output']>;
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** indicates that record has been mark for delete - soft delete */
	deleted: Scalars['Boolean']['output'];
	/** issue description - generated by the semantic engines */
	description: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	description_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	description_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	description_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	description_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	description_min: Scalars['String']['output'];
	/** Description Screenshot IDs for an issue */
	description_screenshot_ids: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	description_screenshot_ids_any: Array<Scalars['String']['output']>;
	/** type of detection used for the issues */
	detection_types: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	detection_types_any: Array<Scalars['String']['output']>;
	/** device manufacturer */
	device_manufacturer: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_manufacturer_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_min: Scalars['String']['output'];
	/** device model */
	device_model: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_model_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_model_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_min: Scalars['String']['output'];
	/** device personalized name */
	device_personalized_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_personalized_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_min: Scalars['String']['output'];
	/** device type */
	device_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_min: Scalars['String']['output'];
	/** domain of the page */
	domain: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	domain_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	domain_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_min: Scalars['String']['output'];
	/** ids of the issues that are considered duplicates - by the semantic engines */
	duplicates: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	duplicates_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	duplicates_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	duplicates_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	duplicates_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	duplicates_min: Scalars['String']['output'];
	/** accessibility identifier for the element */
	elements__accessibility_identifier: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__accessibility_identifier_any: Array<Scalars['String']['output']>;
	/** accessibility label for the element (iOS only) */
	elements__accessibility_label: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__accessibility_label_any: Array<Scalars['String']['output']>;
	/** bounding box bottom - extracted from the element */
	elements__bounding_box_bottom: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_bottom_any: Array<Scalars['Float']['output']>;
	/** bounding box height - extracted from the element */
	elements__bounding_box_height: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_height_any: Array<Scalars['Float']['output']>;
	/** bounding box left - extracted from the element */
	elements__bounding_box_left: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_left_any: Array<Scalars['Float']['output']>;
	/** bounding box right - extracted from the element */
	elements__bounding_box_right: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_right_any: Array<Scalars['Float']['output']>;
	/** bounding box top - extracted from the element */
	elements__bounding_box_top: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_top_any: Array<Scalars['Float']['output']>;
	/** bounding box width - extracted from the element */
	elements__bounding_box_width: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_width_any: Array<Scalars['Float']['output']>;
	/** bounding box x - extracted from the element */
	elements__bounding_box_x: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_x_any: Array<Scalars['Float']['output']>;
	/** bounding box y - extracted from the element */
	elements__bounding_box_y: Array<Scalars['Float']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__bounding_box_y_any: Array<Scalars['Float']['output']>;
	/** canonical url - extracted from the page */
	elements__canonical_url: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__canonical_url_any: Array<Scalars['String']['output']>;
	/** Class name of the element (Android only) */
	elements__class_name: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__class_name_any: Array<Scalars['String']['output']>;
	/** component id - generated from the element by the semantic engines */
	elements__component_id: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__component_id_any: Array<Scalars['String']['output']>;
	/** Content description of the element (Android only) */
	elements__content_description: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__content_description_any: Array<Scalars['String']['output']>;
	/** dom snippet - extracted from the element html */
	elements__dom_snippet: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__dom_snippet_any: Array<Scalars['String']['output']>;
	/** type of the element (iOS only) */
	elements__element_type: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__element_type_any: Array<Scalars['String']['output']>;
	/** element id - generated by the semantic engines */
	elements__id: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__id_any: Array<Scalars['ID']['output']>;
	/** element index - extracted by the semantic engines */
	elements__index: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__index_any: Array<Scalars['String']['output']>;
	/** page title - extracted from the page */
	elements__page_title: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__page_title_any: Array<Scalars['String']['output']>;
	/** page url - extracted from the page */
	elements__page_url: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__page_url_any: Array<Scalars['String']['output']>;
	/** element selector - extracted from the element */
	elements__selector: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__selector_any: Array<Scalars['String']['output']>;
	/** Accessible name for the element */
	elements__signature_accessible_name: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__signature_accessible_name_any: Array<Scalars['String']['output']>;
	/** Accessible role for the element */
	elements__signature_accessible_role: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__signature_accessible_role_any: Array<Scalars['String']['output']>;
	/** Semantic path for the element */
	elements__signature_semantic_path: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__signature_semantic_path_any: Array<Scalars['String']['output']>;
	/** XPath for the element */
	elements__signature_xpath: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__signature_xpath_any: Array<Scalars['String']['output']>;
	/** View ID of the element (Android only) */
	elements__view_id: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	elements__view_id_any: Array<Scalars['String']['output']>;
	/** semantic engines version used to generate current issue */
	engines_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	engines_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	engines_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_min: Scalars['String']['output'];
	/** environment in which the issue was detected */
	environment: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	environment_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	environment_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_min: Scalars['String']['output'];
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	/** user flow in which the issue was detected */
	flow: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	flow_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	flow_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	flow_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	flow_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	flow_min: Scalars['String']['output'];
	/** time of issue ingestion */
	ingestion_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	ingestion_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** issue id - generated by the semantic engines */
	issue_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	issue_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** issue index - generated by the semantic engines */
	issue_index: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_index_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_index_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	issue_index_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	issue_index_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_index_min: Scalars['String']['output'];
	/** link to the evinced knowledge base detailing further explanations for the current validation */
	knowledge_base_link: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	knowledge_base_link_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	knowledge_base_link_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	knowledge_base_link_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	knowledge_base_link_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	knowledge_base_link_min: Scalars['String']['output'];
	/** issue metadata in JSON format */
	metadata: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	metadata_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	metadata_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	metadata_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	metadata_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	metadata_min: Scalars['String']['output'];
	/** indicates if mobile kit was used */
	mobile_kit: Scalars['Boolean']['output'];
	/** note made by user for this specific issue */
	note: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	note_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	note_count: Scalars['Int']['output'];
	/** time when the note was created */
	note_creation_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	note_creation_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	note_creation_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	note_creation_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	note_creation_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	note_creation_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	note_creation_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	note_creation_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	note_creation_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** group unique array aggregate function */
	note_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	note_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	note_min: Scalars['String']['output'];
	/** operating system */
	os: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_min: Scalars['String']['output'];
	/** operating system version */
	os_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_min: Scalars['String']['output'];
	/** user/service account running the analysis */
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** user / service account */
	owner_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	owner_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_min: Scalars['String']['output'];
	/** page identifier */
	page_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	page_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	page_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	page_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** page title - extracted from the page */
	page_title: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	page_title_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	page_title_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_min: Scalars['String']['output'];
	/** product identifier */
	product_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	product_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	product_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** product name */
	product_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_min: Scalars['String']['output'];
	/** internal product version */
	product_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_min: Scalars['String']['output'];
	/** list of all properties associated with current issue */
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	/** regulation standard (EN_301_549, Section_508, etc.) */
	regulations__id: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	regulations__id_any: Array<Scalars['String']['output']>;
	/** regulation criterion name */
	regulations__name: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	regulations__name_any: Array<Scalars['String']['output']>;
	/** success criteria identifier (e.g., 9.2.1.1) */
	regulations__success_criteria: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	regulations__success_criteria_any: Array<Scalars['String']['output']>;
	/** violation type: primary or secondary */
	regulations__type: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	regulations__type_any: Array<Scalars['String']['output']>;
	/** link to regulation documentation */
	regulations__url: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	regulations__url_any: Array<Scalars['String']['output']>;
	/** run identifier - represent a single group of issues. value is equivalent to testId, sessionId, scanId */
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** json holding metadata fields on current run */
	run_metadata: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	run_metadata_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	run_metadata_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_metadata_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_metadata_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	run_metadata_min: Scalars['String']['output'];
	/** time of run start on client side */
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** scan identifier */
	scan_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	scan_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** scan name as sent by mfa */
	scan_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	scan_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	scan_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_name_min: Scalars['String']['output'];
	/** screenshot - link to the screenshot of the issue */
	screenshot: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	screenshot_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	screenshot_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	screenshot_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	screenshot_max: Scalars['String']['output'];
	/** screenshot metadata information */
	screenshot_metadata: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	screenshot_metadata_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	screenshot_metadata_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	screenshot_metadata_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	screenshot_metadata_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	screenshot_metadata_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	screenshot_min: Scalars['String']['output'];
	/** sdk type used */
	sdk_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	sdk_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	sdk_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_min: Scalars['String']['output'];
	/** test name as sent by the sdk - used to differentiate between tests */
	session_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	session_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	session_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_min: Scalars['String']['output'];
	/** severity id - generated by the semantic engines */
	severity_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_id_min: Scalars['String']['output'];
	/** issue severity - generated by the semantic engines */
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	/** issue signature - generated by the semantic engines */
	signature: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	signature_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	signature_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	signature_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	signature_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	signature_min: Scalars['String']['output'];
	/** issue summary - generated by the semantic engines */
	summary: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	summary_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	summary_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	summary_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	summary_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	summary_min: Scalars['String']['output'];
	/** array containing tag descriptions */
	tags__description: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	tags__description_any: Array<Scalars['String']['output']>;
	/** array containing tag identifiers */
	tags__id: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	tags__id_any: Array<Scalars['String']['output']>;
	/** array containing links to the tag definition */
	tags__link: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	tags__link_any: Array<Scalars['String']['output']>;
	/** title of the tag */
	tags__title: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	tags__title_any: Array<Scalars['String']['output']>;
	/** type of the tag */
	tags__type: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	tags__type_any: Array<Scalars['String']['output']>;
	/** tenant identifier */
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** test case name */
	test_case: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_case_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_case_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_case_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_case_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_case_min: Scalars['String']['output'];
	/** test id - as sent by the sdk */
	test_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	test_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	test_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** test method name */
	test_method: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_method_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_method_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_method_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_method_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_method_min: Scalars['String']['output'];
	/** test name as sent by the sdk - used to differentiate between tests */
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	/** full test path - as populated by the sdk */
	test_path: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_path_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_path_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_min: Scalars['String']['output'];
	/** test suite name */
	test_suite: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_suite_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_suite_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_suite_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_suite_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_suite_min: Scalars['String']['output'];
	/** unique identifier for the test */
	test_unique_identifier: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_unique_identifier_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_min: Scalars['String']['output'];
	/** ticket key */
	tickets__key: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	tickets__key_any: Array<Scalars['String']['output']>;
	/** ticket link */
	tickets__link: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	tickets__link_any: Array<Scalars['String']['output']>;
	/** type id - generated by the semantic engines */
	type_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_id_min: Scalars['String']['output'];
	/** type name - generated by the semantic engines */
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
	/** unique identifier for the issue - created by the issue uniqueness algorithm */
	uniqueness_id?: Maybe<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	uniqueness_id_any?: Maybe<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	uniqueness_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	uniqueness_id_group_uniq_array?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
	/** time of last update */
	update_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	update_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	update_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** url - extracted from the page */
	url: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	url_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	url_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_min: Scalars['String']['output'];
	/** product name */
	user_agent: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_agent_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_agent_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	user_agent_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	user_agent_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_agent_min: Scalars['String']['output'];
	/** validation identifier as generated by the semantic engines */
	validation_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	validation_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** indicates if the validation PASSED or FAILED */
	validation_status: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_status_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_status_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	validation_status_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	validation_status_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	validation_status_min: Scalars['String']['output'];
	/** height - view port extracted during the run */
	viewport_height: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	viewport_height_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	viewport_height_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_sum: Scalars['Int']['output'];
	/** width - view port extracted during the run */
	viewport_width: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	viewport_width_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	viewport_width_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_sum: Scalars['Int']['output'];
};

export type IssuesAnalysis_Root_Selector_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesAnalysis_Root_Selector_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesAnalysis_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IssuesAnalysis_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesApp_Build_Number_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesApp_Build_Number_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesApp_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesApp_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesApp_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesApp_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesApp_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesApp_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesAxe_Additional_Information_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesAxe_Additional_Information_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesCanonical_Url_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesCanonical_Url_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesClient_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesClient_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesCompanion_App_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesCompanion_App_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesDescription_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesDescription_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesDevice_Manufacturer_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesDevice_Manufacturer_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesDevice_Model_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesDevice_Model_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesDevice_Personalized_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesDevice_Personalized_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesDevice_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesDevice_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesDomain_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesDomain_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesDuplicates_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesDuplicates_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesEngines_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesEngines_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesEnvironment_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesEnvironment_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesFlow_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesFlow_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesIngestion_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IssuesIngestion_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesIssue_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesIssue_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesIssue_Index_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesIssue_Index_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesKnowledge_Base_Link_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesKnowledge_Base_Link_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesMetadata_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesMetadata_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesNote_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesNote_Creation_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IssuesNote_Creation_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesNote_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesOs_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesOs_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesOs_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesOs_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesOwner_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesOwner_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesPage_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesPage_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesPage_Title_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesPage_Title_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesProduct_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesProduct_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesProduct_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesProduct_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesProduct_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesProduct_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesRun_Metadata_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesRun_Metadata_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IssuesRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesScan_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesScan_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesScan_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesScan_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesScreenshot_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesScreenshot_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesScreenshot_Metadata_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesScreenshot_Metadata_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesSdk_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesSdk_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesSession_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesSession_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesSeverity_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesSeverity_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesSeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesSeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesSignature_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesSignature_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesSummary_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesSummary_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTest_Case_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesTest_Case_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTest_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesTest_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTest_Method_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesTest_Method_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTest_Path_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesTest_Path_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTest_Suite_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesTest_Suite_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesTest_Unique_Identifier_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesTest_Unique_Identifier_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesType_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesType_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesUniqueness_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesUniqueness_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesUpdate_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IssuesUpdate_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesUrl_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesUrl_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesUser_Agent_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesUser_Agent_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesValidation_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type IssuesValidation_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesValidation_Status_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type IssuesValidation_Status_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesViewport_Height_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type IssuesViewport_Height_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IssuesViewport_Width_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type IssuesViewport_Width_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for issues queries. */
export type IssuesAndFilter = {
	/** Equals (FieldName: analysis_root_selector) */
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: analysis_root_selector) */
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: analysis_root_selector) */
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: analysis_time) */
	analysis_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: analysis_time) */
	analysis_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: analysis_time) */
	analysis_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: analysis_time) */
	analysis_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: analysis_time) */
	analysis_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: analysis_time) */
	analysis_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: analysis_time) */
	analysis_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: axe_additional_information) */
	axe_additional_information_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: axe_additional_information) */
	axe_additional_information_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: axe_additional_information) */
	axe_additional_information_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: axe_additional_information) */
	axe_additional_information_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: axe_additional_information) */
	axe_additional_information_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: axe_additional_information) */
	axe_additional_information_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: canonical_url) */
	canonical_url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: canonical_url) */
	canonical_url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: canonical_url) */
	canonical_url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: canonical_url) */
	canonical_url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: canonical_url) */
	canonical_url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: canonical_url) */
	canonical_url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: client_version) */
	client_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: client_version) */
	client_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: client_version) */
	client_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: client_version) */
	client_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: client_version) */
	client_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: client_version) */
	client_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: description) */
	description_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: description) */
	description_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: description) */
	description_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: description) */
	description_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: description) */
	description_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: description) */
	description_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: domain) */
	domain_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: domain) */
	domain_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: domain) */
	domain_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: domain) */
	domain_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: domain) */
	domain_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: domain) */
	domain_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: duplicates) */
	duplicates_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: duplicates) */
	duplicates_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: duplicates) */
	duplicates_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: duplicates) */
	duplicates_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: duplicates) */
	duplicates_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: duplicates) */
	duplicates_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: engines_version) */
	engines_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: engines_version) */
	engines_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: engines_version) */
	engines_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: engines_version) */
	engines_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: engines_version) */
	engines_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: engines_version) */
	engines_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flow) */
	flow_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flow) */
	flow_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flow) */
	flow_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flow) */
	flow_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flow) */
	flow_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flow) */
	flow_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: ingestion_time) */
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: ingestion_time) */
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: ingestion_time) */
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: ingestion_time) */
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: ingestion_time) */
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: ingestion_time) */
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: ingestion_time) */
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: issue_id) */
	issue_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: issue_id) */
	issue_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: issue_id) */
	issue_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: issue_id) */
	issue_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: issue_id) */
	issue_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: issue_id) */
	issue_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: issue_index) */
	issue_index_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: issue_index) */
	issue_index_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: issue_index) */
	issue_index_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: issue_index) */
	issue_index_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: issue_index) */
	issue_index_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: issue_index) */
	issue_index_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: knowledge_base_link) */
	knowledge_base_link_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: knowledge_base_link) */
	knowledge_base_link_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: knowledge_base_link) */
	knowledge_base_link_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: knowledge_base_link) */
	knowledge_base_link_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: knowledge_base_link) */
	knowledge_base_link_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: knowledge_base_link) */
	knowledge_base_link_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: metadata) */
	metadata_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: metadata) */
	metadata_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: metadata) */
	metadata_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: metadata) */
	metadata_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: metadata) */
	metadata_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: metadata) */
	metadata_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: note_creation_time) */
	note_creation_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: note_creation_time) */
	note_creation_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: note_creation_time) */
	note_creation_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: note_creation_time) */
	note_creation_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: note_creation_time) */
	note_creation_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: note_creation_time) */
	note_creation_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: note_creation_time) */
	note_creation_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: note) */
	note_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: note) */
	note_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: note) */
	note_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: note) */
	note_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: note) */
	note_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: note) */
	note_ne?: InputMaybe<ConditionString>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<IssuesOrFilter>>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: owner_type) */
	owner_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: owner_type) */
	owner_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: owner_type) */
	owner_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: owner_type) */
	owner_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: owner_type) */
	owner_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: owner_type) */
	owner_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: page_id) */
	page_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: page_id) */
	page_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: page_id) */
	page_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: page_id) */
	page_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: page_id) */
	page_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: page_id) */
	page_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_id) */
	product_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: product_id) */
	product_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: product_id) */
	product_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: product_id) */
	product_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: product_id) */
	product_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: product_id) */
	product_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_metadata) */
	run_metadata_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: run_metadata) */
	run_metadata_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: run_metadata) */
	run_metadata_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: run_metadata) */
	run_metadata_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: run_metadata) */
	run_metadata_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: run_metadata) */
	run_metadata_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: scan_name) */
	scan_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: scan_name) */
	scan_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: scan_name) */
	scan_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: scan_name) */
	scan_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: scan_name) */
	scan_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: scan_name) */
	scan_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: screenshot) */
	screenshot_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: screenshot) */
	screenshot_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: screenshot) */
	screenshot_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: screenshot) */
	screenshot_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: screenshot) */
	screenshot_lt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: screenshot_metadata) */
	screenshot_metadata_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: screenshot_metadata) */
	screenshot_metadata_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: screenshot_metadata) */
	screenshot_metadata_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: screenshot_metadata) */
	screenshot_metadata_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: screenshot_metadata) */
	screenshot_metadata_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: screenshot_metadata) */
	screenshot_metadata_ne?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: screenshot) */
	screenshot_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_id) */
	severity_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_id) */
	severity_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_id) */
	severity_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_id) */
	severity_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_id) */
	severity_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_id) */
	severity_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: signature) */
	signature_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: signature) */
	signature_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: signature) */
	signature_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: signature) */
	signature_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: signature) */
	signature_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: signature) */
	signature_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: summary) */
	summary_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: summary) */
	summary_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: summary) */
	summary_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: summary) */
	summary_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: summary) */
	summary_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: summary) */
	summary_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_case) */
	test_case_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_case) */
	test_case_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_case) */
	test_case_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_case) */
	test_case_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_case) */
	test_case_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_case) */
	test_case_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_id) */
	test_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: test_id) */
	test_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: test_id) */
	test_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: test_id) */
	test_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: test_id) */
	test_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: test_id) */
	test_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_method) */
	test_method_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_method) */
	test_method_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_method) */
	test_method_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_method) */
	test_method_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_method) */
	test_method_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_method) */
	test_method_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_suite) */
	test_suite_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_suite) */
	test_suite_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_suite) */
	test_suite_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_suite) */
	test_suite_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_suite) */
	test_suite_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_suite) */
	test_suite_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_unique_identifier) */
	test_unique_identifier_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_unique_identifier) */
	test_unique_identifier_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_unique_identifier) */
	test_unique_identifier_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<IssuesSearchInsensitive>;
	text_equals?: InputMaybe<IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<IssuesSearch>;
	text_starts_with?: InputMaybe<IssuesSearchInsensitive>;
	/** Equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_id) */
	type_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_id) */
	type_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_id) */
	type_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_id) */
	type_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_id) */
	type_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_id) */
	type_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: uniqueness_id) */
	uniqueness_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: uniqueness_id) */
	uniqueness_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: uniqueness_id) */
	uniqueness_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: uniqueness_id) */
	uniqueness_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: uniqueness_id) */
	uniqueness_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: uniqueness_id) */
	uniqueness_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: url) */
	url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: url) */
	url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: url) */
	url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: url) */
	url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: url) */
	url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: url) */
	url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: user_agent) */
	user_agent_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_agent) */
	user_agent_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_agent) */
	user_agent_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_agent) */
	user_agent_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_agent) */
	user_agent_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_agent) */
	user_agent_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: validation_id) */
	validation_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: validation_id) */
	validation_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: validation_id) */
	validation_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: validation_id) */
	validation_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: validation_id) */
	validation_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: validation_id) */
	validation_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: validation_status) */
	validation_status_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: validation_status) */
	validation_status_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: validation_status) */
	validation_status_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: validation_status) */
	validation_status_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: validation_status) */
	validation_status_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: validation_status) */
	validation_status_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: viewport_height) */
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_height) */
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_height) */
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_height) */
	viewport_height_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_height) */
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_height) */
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: viewport_width) */
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_width) */
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_width) */
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_width) */
	viewport_width_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_width) */
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_width) */
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export enum IssuesGroup {
	AnalysisRootSelector = 'analysis_root_selector',
	AnalysisRootSelectorAny = 'analysis_root_selector_any',
	AnalysisRootSelectorCount = 'analysis_root_selector_count',
	AnalysisRootSelectorGroupUniqArray = 'analysis_root_selector_group_uniq_array',
	AnalysisRootSelectorMax = 'analysis_root_selector_max',
	AnalysisRootSelectorMin = 'analysis_root_selector_min',
	AnalysisTime = 'analysis_time',
	AnalysisTimeAny = 'analysis_time_any',
	AnalysisTimeCount = 'analysis_time_count',
	AnalysisTimeGroupUniqArray = 'analysis_time_group_uniq_array',
	AnalysisTimeMax = 'analysis_time_max',
	AnalysisTimeMin = 'analysis_time_min',
	AnalysisTimeTruncDay = 'analysis_time_truncDay',
	AnalysisTimeTruncMonth = 'analysis_time_truncMonth',
	AnalysisTimeTruncYear = 'analysis_time_truncYear',
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	AxeAdditionalInformation = 'axe_additional_information',
	AxeAdditionalInformationAny = 'axe_additional_information_any',
	AxeAdditionalInformationCount = 'axe_additional_information_count',
	AxeAdditionalInformationGroupUniqArray = 'axe_additional_information_group_uniq_array',
	AxeAdditionalInformationMax = 'axe_additional_information_max',
	AxeAdditionalInformationMin = 'axe_additional_information_min',
	CanonicalUrl = 'canonical_url',
	CanonicalUrlAny = 'canonical_url_any',
	CanonicalUrlCount = 'canonical_url_count',
	CanonicalUrlGroupUniqArray = 'canonical_url_group_uniq_array',
	CanonicalUrlMax = 'canonical_url_max',
	CanonicalUrlMin = 'canonical_url_min',
	ClientVersion = 'client_version',
	ClientVersionAny = 'client_version_any',
	ClientVersionCount = 'client_version_count',
	ClientVersionGroupUniqArray = 'client_version_group_uniq_array',
	ClientVersionMax = 'client_version_max',
	ClientVersionMin = 'client_version_min',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	ConformanceAny = 'conformance_any',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	Deleted = 'deleted',
	Description = 'description',
	DescriptionAny = 'description_any',
	DescriptionCount = 'description_count',
	DescriptionGroupUniqArray = 'description_group_uniq_array',
	DescriptionMax = 'description_max',
	DescriptionMin = 'description_min',
	DescriptionScreenshotIdsAny = 'description_screenshot_ids_any',
	DetectionTypesAny = 'detection_types_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	Domain = 'domain',
	DomainAny = 'domain_any',
	DomainCount = 'domain_count',
	DomainGroupUniqArray = 'domain_group_uniq_array',
	DomainMax = 'domain_max',
	DomainMin = 'domain_min',
	Duplicates = 'duplicates',
	DuplicatesAny = 'duplicates_any',
	DuplicatesCount = 'duplicates_count',
	DuplicatesGroupUniqArray = 'duplicates_group_uniq_array',
	DuplicatesMax = 'duplicates_max',
	DuplicatesMin = 'duplicates_min',
	ElementsAccessibilityIdentifierAny = 'elements__accessibility_identifier_any',
	ElementsAccessibilityLabelAny = 'elements__accessibility_label_any',
	ElementsBoundingBoxBottomAny = 'elements__bounding_box_bottom_any',
	ElementsBoundingBoxHeightAny = 'elements__bounding_box_height_any',
	ElementsBoundingBoxLeftAny = 'elements__bounding_box_left_any',
	ElementsBoundingBoxRightAny = 'elements__bounding_box_right_any',
	ElementsBoundingBoxTopAny = 'elements__bounding_box_top_any',
	ElementsBoundingBoxWidthAny = 'elements__bounding_box_width_any',
	ElementsBoundingBoxXAny = 'elements__bounding_box_x_any',
	ElementsBoundingBoxYAny = 'elements__bounding_box_y_any',
	ElementsCanonicalUrlAny = 'elements__canonical_url_any',
	ElementsClassNameAny = 'elements__class_name_any',
	ElementsComponentIdAny = 'elements__component_id_any',
	ElementsContentDescriptionAny = 'elements__content_description_any',
	ElementsDomSnippetAny = 'elements__dom_snippet_any',
	ElementsElementTypeAny = 'elements__element_type_any',
	ElementsIdAny = 'elements__id_any',
	ElementsIndexAny = 'elements__index_any',
	ElementsPageTitleAny = 'elements__page_title_any',
	ElementsPageUrlAny = 'elements__page_url_any',
	ElementsSelectorAny = 'elements__selector_any',
	ElementsSignatureAccessibleNameAny = 'elements__signature_accessible_name_any',
	ElementsSignatureAccessibleRoleAny = 'elements__signature_accessible_role_any',
	ElementsSignatureSemanticPathAny = 'elements__signature_semantic_path_any',
	ElementsSignatureXpathAny = 'elements__signature_xpath_any',
	ElementsViewIdAny = 'elements__view_id_any',
	EnginesVersion = 'engines_version',
	EnginesVersionAny = 'engines_version_any',
	EnginesVersionCount = 'engines_version_count',
	EnginesVersionGroupUniqArray = 'engines_version_group_uniq_array',
	EnginesVersionMax = 'engines_version_max',
	EnginesVersionMin = 'engines_version_min',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	FilteredCustomFields = 'filtered_custom_fields',
	Flow = 'flow',
	FlowAny = 'flow_any',
	FlowCount = 'flow_count',
	FlowGroupUniqArray = 'flow_group_uniq_array',
	FlowMax = 'flow_max',
	FlowMin = 'flow_min',
	IngestionTime = 'ingestion_time',
	IngestionTimeAny = 'ingestion_time_any',
	IngestionTimeCount = 'ingestion_time_count',
	IngestionTimeGroupUniqArray = 'ingestion_time_group_uniq_array',
	IngestionTimeMax = 'ingestion_time_max',
	IngestionTimeMin = 'ingestion_time_min',
	IngestionTimeTruncDay = 'ingestion_time_truncDay',
	IngestionTimeTruncMonth = 'ingestion_time_truncMonth',
	IngestionTimeTruncYear = 'ingestion_time_truncYear',
	IssueId = 'issue_id',
	IssueIdAny = 'issue_id_any',
	IssueIdCount = 'issue_id_count',
	IssueIdGroupUniqArray = 'issue_id_group_uniq_array',
	IssueIndex = 'issue_index',
	IssueIndexAny = 'issue_index_any',
	IssueIndexCount = 'issue_index_count',
	IssueIndexGroupUniqArray = 'issue_index_group_uniq_array',
	IssueIndexMax = 'issue_index_max',
	IssueIndexMin = 'issue_index_min',
	KnowledgeBaseLink = 'knowledge_base_link',
	KnowledgeBaseLinkAny = 'knowledge_base_link_any',
	KnowledgeBaseLinkCount = 'knowledge_base_link_count',
	KnowledgeBaseLinkGroupUniqArray = 'knowledge_base_link_group_uniq_array',
	KnowledgeBaseLinkMax = 'knowledge_base_link_max',
	KnowledgeBaseLinkMin = 'knowledge_base_link_min',
	Metadata = 'metadata',
	MetadataAny = 'metadata_any',
	MetadataCount = 'metadata_count',
	MetadataGroupUniqArray = 'metadata_group_uniq_array',
	MetadataMax = 'metadata_max',
	MetadataMin = 'metadata_min',
	MobileKit = 'mobile_kit',
	Note = 'note',
	NoteAny = 'note_any',
	NoteCount = 'note_count',
	NoteCreationTime = 'note_creation_time',
	NoteCreationTimeAny = 'note_creation_time_any',
	NoteCreationTimeCount = 'note_creation_time_count',
	NoteCreationTimeGroupUniqArray = 'note_creation_time_group_uniq_array',
	NoteCreationTimeMax = 'note_creation_time_max',
	NoteCreationTimeMin = 'note_creation_time_min',
	NoteCreationTimeTruncDay = 'note_creation_time_truncDay',
	NoteCreationTimeTruncMonth = 'note_creation_time_truncMonth',
	NoteCreationTimeTruncYear = 'note_creation_time_truncYear',
	NoteGroupUniqArray = 'note_group_uniq_array',
	NoteMax = 'note_max',
	NoteMin = 'note_min',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	OwnerType = 'owner_type',
	OwnerTypeAny = 'owner_type_any',
	OwnerTypeCount = 'owner_type_count',
	OwnerTypeGroupUniqArray = 'owner_type_group_uniq_array',
	OwnerTypeMax = 'owner_type_max',
	OwnerTypeMin = 'owner_type_min',
	PageId = 'page_id',
	PageIdAny = 'page_id_any',
	PageIdCount = 'page_id_count',
	PageIdGroupUniqArray = 'page_id_group_uniq_array',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	ProductId = 'product_id',
	ProductIdAny = 'product_id_any',
	ProductIdCount = 'product_id_count',
	ProductIdGroupUniqArray = 'product_id_group_uniq_array',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RegulationsIdAny = 'regulations__id_any',
	RegulationsNameAny = 'regulations__name_any',
	RegulationsSuccessCriteriaAny = 'regulations__success_criteria_any',
	RegulationsTypeAny = 'regulations__type_any',
	RegulationsUrlAny = 'regulations__url_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunMetadata = 'run_metadata',
	RunMetadataAny = 'run_metadata_any',
	RunMetadataCount = 'run_metadata_count',
	RunMetadataGroupUniqArray = 'run_metadata_group_uniq_array',
	RunMetadataMax = 'run_metadata_max',
	RunMetadataMin = 'run_metadata_min',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	ScanName = 'scan_name',
	ScanNameAny = 'scan_name_any',
	ScanNameCount = 'scan_name_count',
	ScanNameGroupUniqArray = 'scan_name_group_uniq_array',
	ScanNameMax = 'scan_name_max',
	ScanNameMin = 'scan_name_min',
	Screenshot = 'screenshot',
	ScreenshotAny = 'screenshot_any',
	ScreenshotCount = 'screenshot_count',
	ScreenshotGroupUniqArray = 'screenshot_group_uniq_array',
	ScreenshotMax = 'screenshot_max',
	ScreenshotMetadata = 'screenshot_metadata',
	ScreenshotMetadataAny = 'screenshot_metadata_any',
	ScreenshotMetadataCount = 'screenshot_metadata_count',
	ScreenshotMetadataGroupUniqArray = 'screenshot_metadata_group_uniq_array',
	ScreenshotMetadataMax = 'screenshot_metadata_max',
	ScreenshotMetadataMin = 'screenshot_metadata_min',
	ScreenshotMin = 'screenshot_min',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	SeverityId = 'severity_id',
	SeverityIdAny = 'severity_id_any',
	SeverityIdCount = 'severity_id_count',
	SeverityIdGroupUniqArray = 'severity_id_group_uniq_array',
	SeverityIdMax = 'severity_id_max',
	SeverityIdMin = 'severity_id_min',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	Signature = 'signature',
	SignatureAny = 'signature_any',
	SignatureCount = 'signature_count',
	SignatureGroupUniqArray = 'signature_group_uniq_array',
	SignatureMax = 'signature_max',
	SignatureMin = 'signature_min',
	Summary = 'summary',
	SummaryAny = 'summary_any',
	SummaryCount = 'summary_count',
	SummaryGroupUniqArray = 'summary_group_uniq_array',
	SummaryMax = 'summary_max',
	SummaryMin = 'summary_min',
	TagsDescriptionAny = 'tags__description_any',
	TagsIdAny = 'tags__id_any',
	TagsLinkAny = 'tags__link_any',
	TagsTitleAny = 'tags__title_any',
	TagsTypeAny = 'tags__type_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestCase = 'test_case',
	TestCaseAny = 'test_case_any',
	TestCaseCount = 'test_case_count',
	TestCaseGroupUniqArray = 'test_case_group_uniq_array',
	TestCaseMax = 'test_case_max',
	TestCaseMin = 'test_case_min',
	TestId = 'test_id',
	TestIdAny = 'test_id_any',
	TestIdCount = 'test_id_count',
	TestIdGroupUniqArray = 'test_id_group_uniq_array',
	TestMethod = 'test_method',
	TestMethodAny = 'test_method_any',
	TestMethodCount = 'test_method_count',
	TestMethodGroupUniqArray = 'test_method_group_uniq_array',
	TestMethodMax = 'test_method_max',
	TestMethodMin = 'test_method_min',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TestSuite = 'test_suite',
	TestSuiteAny = 'test_suite_any',
	TestSuiteCount = 'test_suite_count',
	TestSuiteGroupUniqArray = 'test_suite_group_uniq_array',
	TestSuiteMax = 'test_suite_max',
	TestSuiteMin = 'test_suite_min',
	TestUniqueIdentifier = 'test_unique_identifier',
	TestUniqueIdentifierAny = 'test_unique_identifier_any',
	TestUniqueIdentifierCount = 'test_unique_identifier_count',
	TestUniqueIdentifierGroupUniqArray = 'test_unique_identifier_group_uniq_array',
	TestUniqueIdentifierMax = 'test_unique_identifier_max',
	TestUniqueIdentifierMin = 'test_unique_identifier_min',
	TicketsKeyAny = 'tickets__key_any',
	TicketsLinkAny = 'tickets__link_any',
	TypeId = 'type_id',
	TypeIdAny = 'type_id_any',
	TypeIdCount = 'type_id_count',
	TypeIdGroupUniqArray = 'type_id_group_uniq_array',
	TypeIdMax = 'type_id_max',
	TypeIdMin = 'type_id_min',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min',
	UniquenessId = 'uniqueness_id',
	UniquenessIdAny = 'uniqueness_id_any',
	UniquenessIdCount = 'uniqueness_id_count',
	UniquenessIdGroupUniqArray = 'uniqueness_id_group_uniq_array',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	Url = 'url',
	UrlAny = 'url_any',
	UrlCount = 'url_count',
	UrlGroupUniqArray = 'url_group_uniq_array',
	UrlMax = 'url_max',
	UrlMin = 'url_min',
	UserAgent = 'user_agent',
	UserAgentAny = 'user_agent_any',
	UserAgentCount = 'user_agent_count',
	UserAgentGroupUniqArray = 'user_agent_group_uniq_array',
	UserAgentMax = 'user_agent_max',
	UserAgentMin = 'user_agent_min',
	ValidationId = 'validation_id',
	ValidationIdAny = 'validation_id_any',
	ValidationIdCount = 'validation_id_count',
	ValidationIdGroupUniqArray = 'validation_id_group_uniq_array',
	ValidationStatus = 'validation_status',
	ValidationStatusAny = 'validation_status_any',
	ValidationStatusCount = 'validation_status_count',
	ValidationStatusGroupUniqArray = 'validation_status_group_uniq_array',
	ValidationStatusMax = 'validation_status_max',
	ValidationStatusMin = 'validation_status_min',
	ViewportHeight = 'viewport_height',
	ViewportHeightAny = 'viewport_height_any',
	ViewportHeightCount = 'viewport_height_count',
	ViewportHeightGroupUniqArray = 'viewport_height_group_uniq_array',
	ViewportHeightMax = 'viewport_height_max',
	ViewportHeightMin = 'viewport_height_min',
	ViewportHeightSum = 'viewport_height_sum',
	ViewportWidth = 'viewport_width',
	ViewportWidthAny = 'viewport_width_any',
	ViewportWidthCount = 'viewport_width_count',
	ViewportWidthGroupUniqArray = 'viewport_width_group_uniq_array',
	ViewportWidthMax = 'viewport_width_max',
	ViewportWidthMin = 'viewport_width_min',
	ViewportWidthSum = 'viewport_width_sum'
}

/** Logical OR filter group for issues queries. */
export type IssuesOrFilter = {
	/** Equals (FieldName: analysis_root_selector) */
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: analysis_root_selector) */
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: analysis_root_selector) */
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: analysis_time) */
	analysis_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: analysis_time) */
	analysis_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: analysis_time) */
	analysis_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: analysis_time) */
	analysis_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: analysis_time) */
	analysis_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: analysis_time) */
	analysis_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: analysis_time) */
	analysis_time_ne?: InputMaybe<ConditionDateTime>;
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<IssuesAndFilter>>;
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: axe_additional_information) */
	axe_additional_information_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: axe_additional_information) */
	axe_additional_information_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: axe_additional_information) */
	axe_additional_information_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: axe_additional_information) */
	axe_additional_information_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: axe_additional_information) */
	axe_additional_information_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: axe_additional_information) */
	axe_additional_information_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: canonical_url) */
	canonical_url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: canonical_url) */
	canonical_url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: canonical_url) */
	canonical_url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: canonical_url) */
	canonical_url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: canonical_url) */
	canonical_url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: canonical_url) */
	canonical_url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: client_version) */
	client_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: client_version) */
	client_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: client_version) */
	client_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: client_version) */
	client_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: client_version) */
	client_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: client_version) */
	client_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: description) */
	description_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: description) */
	description_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: description) */
	description_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: description) */
	description_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: description) */
	description_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: description) */
	description_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: description_screenshot_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	description_screenshot_ids_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: description_screenshot_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	description_screenshot_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: domain) */
	domain_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: domain) */
	domain_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: domain) */
	domain_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: domain) */
	domain_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: domain) */
	domain_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: domain) */
	domain_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: duplicates) */
	duplicates_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: duplicates) */
	duplicates_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: duplicates) */
	duplicates_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: duplicates) */
	duplicates_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: duplicates) */
	duplicates_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: duplicates) */
	duplicates_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_identifier): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_identifier_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_identifier): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_identifier_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_label): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__accessibility_label_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__accessibility_label): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__accessibility_label_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_bottom): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_bottom_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_bottom): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_bottom_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_height): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_height_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_height): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_height_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_left): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_left_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_left): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_left_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_right): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_right_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_right): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_right_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_top): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_top_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_top): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_top_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_width): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_width_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_width): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_width_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_x): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_x_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_x): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_x_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_eq_any_item?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_eq_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_eq_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_ge_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ge_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ge_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_gt_any_item?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_gt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Greater than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_gt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_le_any_item?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_le_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than or equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_le_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_lt_any_item?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_lt_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Less than (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_lt_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_y): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__bounding_box_y_ne_any_item?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ne_any_item_for_all_values?: InputMaybe<ConditionFloatArray>;
	/** Not equals (FieldName: elements__bounding_box_y): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__bounding_box_y_ne_any_item_for_any_value?: InputMaybe<ConditionFloatArray>;
	/** Equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__canonical_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__canonical_url_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__canonical_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__canonical_url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__class_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__class_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__class_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__class_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__component_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__component_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__component_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__component_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__content_description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__content_description_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__content_description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__content_description_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__dom_snippet): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__dom_snippet_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__dom_snippet): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__dom_snippet_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__element_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__element_type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__element_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__element_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: elements__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__id_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__id_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: elements__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__id_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__index): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__index_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__index_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__index): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__index_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_title_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_title_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__page_url_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__page_url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__page_url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__selector): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__selector_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__selector): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__selector_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_role): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_accessible_role_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_accessible_role): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_accessible_role_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_semantic_path): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_semantic_path_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_semantic_path): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_semantic_path_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_xpath): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__signature_xpath_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__signature_xpath): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__signature_xpath_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__view_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	elements__view_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: elements__view_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	elements__view_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: engines_version) */
	engines_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: engines_version) */
	engines_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: engines_version) */
	engines_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: engines_version) */
	engines_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: engines_version) */
	engines_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: engines_version) */
	engines_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flow) */
	flow_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flow) */
	flow_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flow) */
	flow_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flow) */
	flow_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flow) */
	flow_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flow) */
	flow_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: ingestion_time) */
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: ingestion_time) */
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: ingestion_time) */
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: ingestion_time) */
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: ingestion_time) */
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: ingestion_time) */
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: ingestion_time) */
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: issue_id) */
	issue_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: issue_id) */
	issue_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: issue_id) */
	issue_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: issue_id) */
	issue_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: issue_id) */
	issue_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: issue_id) */
	issue_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: issue_index) */
	issue_index_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: issue_index) */
	issue_index_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: issue_index) */
	issue_index_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: issue_index) */
	issue_index_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: issue_index) */
	issue_index_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: issue_index) */
	issue_index_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: knowledge_base_link) */
	knowledge_base_link_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: knowledge_base_link) */
	knowledge_base_link_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: knowledge_base_link) */
	knowledge_base_link_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: knowledge_base_link) */
	knowledge_base_link_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: knowledge_base_link) */
	knowledge_base_link_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: knowledge_base_link) */
	knowledge_base_link_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: metadata) */
	metadata_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: metadata) */
	metadata_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: metadata) */
	metadata_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: metadata) */
	metadata_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: metadata) */
	metadata_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: metadata) */
	metadata_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: note_creation_time) */
	note_creation_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: note_creation_time) */
	note_creation_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: note_creation_time) */
	note_creation_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: note_creation_time) */
	note_creation_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: note_creation_time) */
	note_creation_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: note_creation_time) */
	note_creation_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: note_creation_time) */
	note_creation_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: note) */
	note_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: note) */
	note_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: note) */
	note_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: note) */
	note_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: note) */
	note_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: note) */
	note_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: owner_type) */
	owner_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: owner_type) */
	owner_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: owner_type) */
	owner_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: owner_type) */
	owner_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: owner_type) */
	owner_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: owner_type) */
	owner_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: page_id) */
	page_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: page_id) */
	page_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: page_id) */
	page_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: page_id) */
	page_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: page_id) */
	page_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: page_id) */
	page_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_id) */
	product_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: product_id) */
	product_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: product_id) */
	product_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: product_id) */
	product_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: product_id) */
	product_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: product_id) */
	product_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__success_criteria): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__success_criteria_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__success_criteria): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__success_criteria_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__url): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	regulations__url_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: regulations__url): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	regulations__url_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_metadata) */
	run_metadata_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: run_metadata) */
	run_metadata_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: run_metadata) */
	run_metadata_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: run_metadata) */
	run_metadata_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: run_metadata) */
	run_metadata_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: run_metadata) */
	run_metadata_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: scan_name) */
	scan_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: scan_name) */
	scan_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: scan_name) */
	scan_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: scan_name) */
	scan_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: scan_name) */
	scan_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: scan_name) */
	scan_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: screenshot) */
	screenshot_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: screenshot) */
	screenshot_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: screenshot) */
	screenshot_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: screenshot) */
	screenshot_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: screenshot) */
	screenshot_lt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: screenshot_metadata) */
	screenshot_metadata_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: screenshot_metadata) */
	screenshot_metadata_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: screenshot_metadata) */
	screenshot_metadata_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: screenshot_metadata) */
	screenshot_metadata_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: screenshot_metadata) */
	screenshot_metadata_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: screenshot_metadata) */
	screenshot_metadata_ne?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: screenshot) */
	screenshot_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_id) */
	severity_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_id) */
	severity_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_id) */
	severity_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_id) */
	severity_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_id) */
	severity_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_id) */
	severity_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: signature) */
	signature_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: signature) */
	signature_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: signature) */
	signature_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: signature) */
	signature_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: signature) */
	signature_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: signature) */
	signature_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: summary) */
	summary_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: summary) */
	summary_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: summary) */
	summary_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: summary) */
	summary_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: summary) */
	summary_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: summary) */
	summary_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__description): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__description_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__description_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__description): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__description_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__link_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__link_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__link_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__title): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__title_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__title_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__title): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__title_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tags__type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tags__type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tags__type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tags__type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_case) */
	test_case_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_case) */
	test_case_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_case) */
	test_case_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_case) */
	test_case_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_case) */
	test_case_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_case) */
	test_case_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_id) */
	test_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: test_id) */
	test_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: test_id) */
	test_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: test_id) */
	test_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: test_id) */
	test_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: test_id) */
	test_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_method) */
	test_method_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_method) */
	test_method_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_method) */
	test_method_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_method) */
	test_method_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_method) */
	test_method_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_method) */
	test_method_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_suite) */
	test_suite_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_suite) */
	test_suite_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_suite) */
	test_suite_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_suite) */
	test_suite_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_suite) */
	test_suite_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_suite) */
	test_suite_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_unique_identifier) */
	test_unique_identifier_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_unique_identifier) */
	test_unique_identifier_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_unique_identifier) */
	test_unique_identifier_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<IssuesSearchInsensitive>;
	text_equals?: InputMaybe<IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<IssuesSearch>;
	text_starts_with?: InputMaybe<IssuesSearchInsensitive>;
	/** Equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__key): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__key_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__key): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__key_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__link): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	tickets__link_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: tickets__link): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	tickets__link_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_id) */
	type_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_id) */
	type_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_id) */
	type_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_id) */
	type_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_id) */
	type_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_id) */
	type_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: uniqueness_id) */
	uniqueness_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: uniqueness_id) */
	uniqueness_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: uniqueness_id) */
	uniqueness_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: uniqueness_id) */
	uniqueness_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: uniqueness_id) */
	uniqueness_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: uniqueness_id) */
	uniqueness_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: url) */
	url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: url) */
	url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: url) */
	url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: url) */
	url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: url) */
	url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: url) */
	url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: user_agent) */
	user_agent_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_agent) */
	user_agent_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_agent) */
	user_agent_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_agent) */
	user_agent_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_agent) */
	user_agent_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_agent) */
	user_agent_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: validation_id) */
	validation_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: validation_id) */
	validation_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: validation_id) */
	validation_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: validation_id) */
	validation_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: validation_id) */
	validation_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: validation_id) */
	validation_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: validation_status) */
	validation_status_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: validation_status) */
	validation_status_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: validation_status) */
	validation_status_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: validation_status) */
	validation_status_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: validation_status) */
	validation_status_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: validation_status) */
	validation_status_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: viewport_height) */
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_height) */
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_height) */
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_height) */
	viewport_height_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_height) */
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_height) */
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: viewport_width) */
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_width) */
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_width) */
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_width) */
	viewport_width_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_width) */
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_width) */
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export type IssuesSearch = {
	searchFields: Array<IssuesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type IssuesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<IssuesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type IssuesSort = {
	fields: Array<IssuesSortFields>;
	order?: InputMaybe<IssuesSortOrder>;
};

export enum IssuesSortFields {
	AnalysisRootSelector = 'analysis_root_selector',
	AnalysisRootSelectorAny = 'analysis_root_selector_any',
	AnalysisRootSelectorCount = 'analysis_root_selector_count',
	AnalysisRootSelectorGroupUniqArray = 'analysis_root_selector_group_uniq_array',
	AnalysisRootSelectorMax = 'analysis_root_selector_max',
	AnalysisRootSelectorMin = 'analysis_root_selector_min',
	AnalysisTime = 'analysis_time',
	AnalysisTimeAny = 'analysis_time_any',
	AnalysisTimeCount = 'analysis_time_count',
	AnalysisTimeGroupUniqArray = 'analysis_time_group_uniq_array',
	AnalysisTimeMax = 'analysis_time_max',
	AnalysisTimeMin = 'analysis_time_min',
	AnalysisTimeTruncDay = 'analysis_time_truncDay',
	AnalysisTimeTruncMonth = 'analysis_time_truncMonth',
	AnalysisTimeTruncYear = 'analysis_time_truncYear',
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	AxeAdditionalInformation = 'axe_additional_information',
	AxeAdditionalInformationAny = 'axe_additional_information_any',
	AxeAdditionalInformationCount = 'axe_additional_information_count',
	AxeAdditionalInformationGroupUniqArray = 'axe_additional_information_group_uniq_array',
	AxeAdditionalInformationMax = 'axe_additional_information_max',
	AxeAdditionalInformationMin = 'axe_additional_information_min',
	CanonicalUrl = 'canonical_url',
	CanonicalUrlAny = 'canonical_url_any',
	CanonicalUrlCount = 'canonical_url_count',
	CanonicalUrlGroupUniqArray = 'canonical_url_group_uniq_array',
	CanonicalUrlMax = 'canonical_url_max',
	CanonicalUrlMin = 'canonical_url_min',
	ClientVersion = 'client_version',
	ClientVersionAny = 'client_version_any',
	ClientVersionCount = 'client_version_count',
	ClientVersionGroupUniqArray = 'client_version_group_uniq_array',
	ClientVersionMax = 'client_version_max',
	ClientVersionMin = 'client_version_min',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	ConformanceAny = 'conformance_any',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	Deleted = 'deleted',
	Description = 'description',
	DescriptionAny = 'description_any',
	DescriptionCount = 'description_count',
	DescriptionGroupUniqArray = 'description_group_uniq_array',
	DescriptionMax = 'description_max',
	DescriptionMin = 'description_min',
	DescriptionScreenshotIdsAny = 'description_screenshot_ids_any',
	DetectionTypesAny = 'detection_types_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	Domain = 'domain',
	DomainAny = 'domain_any',
	DomainCount = 'domain_count',
	DomainGroupUniqArray = 'domain_group_uniq_array',
	DomainMax = 'domain_max',
	DomainMin = 'domain_min',
	Duplicates = 'duplicates',
	DuplicatesAny = 'duplicates_any',
	DuplicatesCount = 'duplicates_count',
	DuplicatesGroupUniqArray = 'duplicates_group_uniq_array',
	DuplicatesMax = 'duplicates_max',
	DuplicatesMin = 'duplicates_min',
	ElementsAccessibilityIdentifierAny = 'elements__accessibility_identifier_any',
	ElementsAccessibilityLabelAny = 'elements__accessibility_label_any',
	ElementsBoundingBoxBottomAny = 'elements__bounding_box_bottom_any',
	ElementsBoundingBoxHeightAny = 'elements__bounding_box_height_any',
	ElementsBoundingBoxLeftAny = 'elements__bounding_box_left_any',
	ElementsBoundingBoxRightAny = 'elements__bounding_box_right_any',
	ElementsBoundingBoxTopAny = 'elements__bounding_box_top_any',
	ElementsBoundingBoxWidthAny = 'elements__bounding_box_width_any',
	ElementsBoundingBoxXAny = 'elements__bounding_box_x_any',
	ElementsBoundingBoxYAny = 'elements__bounding_box_y_any',
	ElementsCanonicalUrlAny = 'elements__canonical_url_any',
	ElementsClassNameAny = 'elements__class_name_any',
	ElementsComponentIdAny = 'elements__component_id_any',
	ElementsContentDescriptionAny = 'elements__content_description_any',
	ElementsDomSnippetAny = 'elements__dom_snippet_any',
	ElementsElementTypeAny = 'elements__element_type_any',
	ElementsIdAny = 'elements__id_any',
	ElementsIndexAny = 'elements__index_any',
	ElementsPageTitleAny = 'elements__page_title_any',
	ElementsPageUrlAny = 'elements__page_url_any',
	ElementsSelectorAny = 'elements__selector_any',
	ElementsSignatureAccessibleNameAny = 'elements__signature_accessible_name_any',
	ElementsSignatureAccessibleRoleAny = 'elements__signature_accessible_role_any',
	ElementsSignatureSemanticPathAny = 'elements__signature_semantic_path_any',
	ElementsSignatureXpathAny = 'elements__signature_xpath_any',
	ElementsViewIdAny = 'elements__view_id_any',
	EnginesVersion = 'engines_version',
	EnginesVersionAny = 'engines_version_any',
	EnginesVersionCount = 'engines_version_count',
	EnginesVersionGroupUniqArray = 'engines_version_group_uniq_array',
	EnginesVersionMax = 'engines_version_max',
	EnginesVersionMin = 'engines_version_min',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	FilteredCustomFields = 'filtered_custom_fields',
	Flow = 'flow',
	FlowAny = 'flow_any',
	FlowCount = 'flow_count',
	FlowGroupUniqArray = 'flow_group_uniq_array',
	FlowMax = 'flow_max',
	FlowMin = 'flow_min',
	IngestionTime = 'ingestion_time',
	IngestionTimeAny = 'ingestion_time_any',
	IngestionTimeCount = 'ingestion_time_count',
	IngestionTimeGroupUniqArray = 'ingestion_time_group_uniq_array',
	IngestionTimeMax = 'ingestion_time_max',
	IngestionTimeMin = 'ingestion_time_min',
	IngestionTimeTruncDay = 'ingestion_time_truncDay',
	IngestionTimeTruncMonth = 'ingestion_time_truncMonth',
	IngestionTimeTruncYear = 'ingestion_time_truncYear',
	IssueId = 'issue_id',
	IssueIdAny = 'issue_id_any',
	IssueIdCount = 'issue_id_count',
	IssueIdGroupUniqArray = 'issue_id_group_uniq_array',
	IssueIndex = 'issue_index',
	IssueIndexAny = 'issue_index_any',
	IssueIndexCount = 'issue_index_count',
	IssueIndexGroupUniqArray = 'issue_index_group_uniq_array',
	IssueIndexMax = 'issue_index_max',
	IssueIndexMin = 'issue_index_min',
	KnowledgeBaseLink = 'knowledge_base_link',
	KnowledgeBaseLinkAny = 'knowledge_base_link_any',
	KnowledgeBaseLinkCount = 'knowledge_base_link_count',
	KnowledgeBaseLinkGroupUniqArray = 'knowledge_base_link_group_uniq_array',
	KnowledgeBaseLinkMax = 'knowledge_base_link_max',
	KnowledgeBaseLinkMin = 'knowledge_base_link_min',
	Metadata = 'metadata',
	MetadataAny = 'metadata_any',
	MetadataCount = 'metadata_count',
	MetadataGroupUniqArray = 'metadata_group_uniq_array',
	MetadataMax = 'metadata_max',
	MetadataMin = 'metadata_min',
	MobileKit = 'mobile_kit',
	Note = 'note',
	NoteAny = 'note_any',
	NoteCount = 'note_count',
	NoteCreationTime = 'note_creation_time',
	NoteCreationTimeAny = 'note_creation_time_any',
	NoteCreationTimeCount = 'note_creation_time_count',
	NoteCreationTimeGroupUniqArray = 'note_creation_time_group_uniq_array',
	NoteCreationTimeMax = 'note_creation_time_max',
	NoteCreationTimeMin = 'note_creation_time_min',
	NoteCreationTimeTruncDay = 'note_creation_time_truncDay',
	NoteCreationTimeTruncMonth = 'note_creation_time_truncMonth',
	NoteCreationTimeTruncYear = 'note_creation_time_truncYear',
	NoteGroupUniqArray = 'note_group_uniq_array',
	NoteMax = 'note_max',
	NoteMin = 'note_min',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	OwnerType = 'owner_type',
	OwnerTypeAny = 'owner_type_any',
	OwnerTypeCount = 'owner_type_count',
	OwnerTypeGroupUniqArray = 'owner_type_group_uniq_array',
	OwnerTypeMax = 'owner_type_max',
	OwnerTypeMin = 'owner_type_min',
	PageId = 'page_id',
	PageIdAny = 'page_id_any',
	PageIdCount = 'page_id_count',
	PageIdGroupUniqArray = 'page_id_group_uniq_array',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	ProductId = 'product_id',
	ProductIdAny = 'product_id_any',
	ProductIdCount = 'product_id_count',
	ProductIdGroupUniqArray = 'product_id_group_uniq_array',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RegulationsIdAny = 'regulations__id_any',
	RegulationsNameAny = 'regulations__name_any',
	RegulationsSuccessCriteriaAny = 'regulations__success_criteria_any',
	RegulationsTypeAny = 'regulations__type_any',
	RegulationsUrlAny = 'regulations__url_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunMetadata = 'run_metadata',
	RunMetadataAny = 'run_metadata_any',
	RunMetadataCount = 'run_metadata_count',
	RunMetadataGroupUniqArray = 'run_metadata_group_uniq_array',
	RunMetadataMax = 'run_metadata_max',
	RunMetadataMin = 'run_metadata_min',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	ScanName = 'scan_name',
	ScanNameAny = 'scan_name_any',
	ScanNameCount = 'scan_name_count',
	ScanNameGroupUniqArray = 'scan_name_group_uniq_array',
	ScanNameMax = 'scan_name_max',
	ScanNameMin = 'scan_name_min',
	Screenshot = 'screenshot',
	ScreenshotAny = 'screenshot_any',
	ScreenshotCount = 'screenshot_count',
	ScreenshotGroupUniqArray = 'screenshot_group_uniq_array',
	ScreenshotMax = 'screenshot_max',
	ScreenshotMetadata = 'screenshot_metadata',
	ScreenshotMetadataAny = 'screenshot_metadata_any',
	ScreenshotMetadataCount = 'screenshot_metadata_count',
	ScreenshotMetadataGroupUniqArray = 'screenshot_metadata_group_uniq_array',
	ScreenshotMetadataMax = 'screenshot_metadata_max',
	ScreenshotMetadataMin = 'screenshot_metadata_min',
	ScreenshotMin = 'screenshot_min',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	SeverityId = 'severity_id',
	SeverityIdAny = 'severity_id_any',
	SeverityIdCount = 'severity_id_count',
	SeverityIdGroupUniqArray = 'severity_id_group_uniq_array',
	SeverityIdMax = 'severity_id_max',
	SeverityIdMin = 'severity_id_min',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	Signature = 'signature',
	SignatureAny = 'signature_any',
	SignatureCount = 'signature_count',
	SignatureGroupUniqArray = 'signature_group_uniq_array',
	SignatureMax = 'signature_max',
	SignatureMin = 'signature_min',
	Summary = 'summary',
	SummaryAny = 'summary_any',
	SummaryCount = 'summary_count',
	SummaryGroupUniqArray = 'summary_group_uniq_array',
	SummaryMax = 'summary_max',
	SummaryMin = 'summary_min',
	TagsDescriptionAny = 'tags__description_any',
	TagsIdAny = 'tags__id_any',
	TagsLinkAny = 'tags__link_any',
	TagsTitleAny = 'tags__title_any',
	TagsTypeAny = 'tags__type_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestCase = 'test_case',
	TestCaseAny = 'test_case_any',
	TestCaseCount = 'test_case_count',
	TestCaseGroupUniqArray = 'test_case_group_uniq_array',
	TestCaseMax = 'test_case_max',
	TestCaseMin = 'test_case_min',
	TestId = 'test_id',
	TestIdAny = 'test_id_any',
	TestIdCount = 'test_id_count',
	TestIdGroupUniqArray = 'test_id_group_uniq_array',
	TestMethod = 'test_method',
	TestMethodAny = 'test_method_any',
	TestMethodCount = 'test_method_count',
	TestMethodGroupUniqArray = 'test_method_group_uniq_array',
	TestMethodMax = 'test_method_max',
	TestMethodMin = 'test_method_min',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TestSuite = 'test_suite',
	TestSuiteAny = 'test_suite_any',
	TestSuiteCount = 'test_suite_count',
	TestSuiteGroupUniqArray = 'test_suite_group_uniq_array',
	TestSuiteMax = 'test_suite_max',
	TestSuiteMin = 'test_suite_min',
	TestUniqueIdentifier = 'test_unique_identifier',
	TestUniqueIdentifierAny = 'test_unique_identifier_any',
	TestUniqueIdentifierCount = 'test_unique_identifier_count',
	TestUniqueIdentifierGroupUniqArray = 'test_unique_identifier_group_uniq_array',
	TestUniqueIdentifierMax = 'test_unique_identifier_max',
	TestUniqueIdentifierMin = 'test_unique_identifier_min',
	TicketsKeyAny = 'tickets__key_any',
	TicketsLinkAny = 'tickets__link_any',
	TypeId = 'type_id',
	TypeIdAny = 'type_id_any',
	TypeIdCount = 'type_id_count',
	TypeIdGroupUniqArray = 'type_id_group_uniq_array',
	TypeIdMax = 'type_id_max',
	TypeIdMin = 'type_id_min',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min',
	UniquenessId = 'uniqueness_id',
	UniquenessIdAny = 'uniqueness_id_any',
	UniquenessIdCount = 'uniqueness_id_count',
	UniquenessIdGroupUniqArray = 'uniqueness_id_group_uniq_array',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	Url = 'url',
	UrlAny = 'url_any',
	UrlCount = 'url_count',
	UrlGroupUniqArray = 'url_group_uniq_array',
	UrlMax = 'url_max',
	UrlMin = 'url_min',
	UserAgent = 'user_agent',
	UserAgentAny = 'user_agent_any',
	UserAgentCount = 'user_agent_count',
	UserAgentGroupUniqArray = 'user_agent_group_uniq_array',
	UserAgentMax = 'user_agent_max',
	UserAgentMin = 'user_agent_min',
	ValidationId = 'validation_id',
	ValidationIdAny = 'validation_id_any',
	ValidationIdCount = 'validation_id_count',
	ValidationIdGroupUniqArray = 'validation_id_group_uniq_array',
	ValidationStatus = 'validation_status',
	ValidationStatusAny = 'validation_status_any',
	ValidationStatusCount = 'validation_status_count',
	ValidationStatusGroupUniqArray = 'validation_status_group_uniq_array',
	ValidationStatusMax = 'validation_status_max',
	ValidationStatusMin = 'validation_status_min',
	ViewportHeight = 'viewport_height',
	ViewportHeightAny = 'viewport_height_any',
	ViewportHeightCount = 'viewport_height_count',
	ViewportHeightGroupUniqArray = 'viewport_height_group_uniq_array',
	ViewportHeightMax = 'viewport_height_max',
	ViewportHeightMin = 'viewport_height_min',
	ViewportHeightSum = 'viewport_height_sum',
	ViewportWidth = 'viewport_width',
	ViewportWidthAny = 'viewport_width_any',
	ViewportWidthCount = 'viewport_width_count',
	ViewportWidthGroupUniqArray = 'viewport_width_group_uniq_array',
	ViewportWidthMax = 'viewport_width_max',
	ViewportWidthMin = 'viewport_width_min',
	ViewportWidthSum = 'viewport_width_sum'
}

/** An example enum type */
export enum IssuesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum IssuesTextSearchFields {
	AnalysisRootSelector = 'analysis_root_selector',
	AnalysisTime = 'analysis_time',
	App = 'app',
	AppBuildNumber = 'app_build_number',
	AppId = 'app_id',
	AppVersion = 'app_version',
	AxeAdditionalInformation = 'axe_additional_information',
	CanonicalUrl = 'canonical_url',
	ClientVersion = 'client_version',
	CompanionAppVersion = 'companion_app_version',
	Conformance = 'conformance',
	CustomFields = 'custom_fields',
	Deleted = 'deleted',
	Description = 'description',
	DescriptionScreenshotIds = 'description_screenshot_ids',
	DetectionTypes = 'detection_types',
	DeviceManufacturer = 'device_manufacturer',
	DeviceModel = 'device_model',
	DevicePersonalizedName = 'device_personalized_name',
	DeviceType = 'device_type',
	Domain = 'domain',
	Duplicates = 'duplicates',
	ElementsAccessibilityIdentifier = 'elements__accessibility_identifier',
	ElementsAccessibilityLabel = 'elements__accessibility_label',
	ElementsBoundingBoxBottom = 'elements__bounding_box_bottom',
	ElementsBoundingBoxHeight = 'elements__bounding_box_height',
	ElementsBoundingBoxLeft = 'elements__bounding_box_left',
	ElementsBoundingBoxRight = 'elements__bounding_box_right',
	ElementsBoundingBoxTop = 'elements__bounding_box_top',
	ElementsBoundingBoxWidth = 'elements__bounding_box_width',
	ElementsBoundingBoxX = 'elements__bounding_box_x',
	ElementsBoundingBoxY = 'elements__bounding_box_y',
	ElementsCanonicalUrl = 'elements__canonical_url',
	ElementsClassName = 'elements__class_name',
	ElementsComponentId = 'elements__component_id',
	ElementsContentDescription = 'elements__content_description',
	ElementsDomSnippet = 'elements__dom_snippet',
	ElementsElementType = 'elements__element_type',
	ElementsId = 'elements__id',
	ElementsIndex = 'elements__index',
	ElementsPageTitle = 'elements__page_title',
	ElementsPageUrl = 'elements__page_url',
	ElementsSelector = 'elements__selector',
	ElementsSignatureAccessibleName = 'elements__signature_accessible_name',
	ElementsSignatureAccessibleRole = 'elements__signature_accessible_role',
	ElementsSignatureSemanticPath = 'elements__signature_semantic_path',
	ElementsSignatureXpath = 'elements__signature_xpath',
	ElementsViewId = 'elements__view_id',
	EnginesVersion = 'engines_version',
	Environment = 'environment',
	FilteredCustomFields = 'filtered_custom_fields',
	Flow = 'flow',
	IngestionTime = 'ingestion_time',
	IssueId = 'issue_id',
	IssueIndex = 'issue_index',
	KnowledgeBaseLink = 'knowledge_base_link',
	Metadata = 'metadata',
	MobileKit = 'mobile_kit',
	Note = 'note',
	NoteCreationTime = 'note_creation_time',
	Os = 'os',
	OsVersion = 'os_version',
	OwnerId = 'owner_id',
	OwnerType = 'owner_type',
	PageId = 'page_id',
	PageTitle = 'page_title',
	ProductId = 'product_id',
	ProductName = 'product_name',
	ProductVersion = 'product_version',
	PropertyIds = 'property_ids',
	RegulationsId = 'regulations__id',
	RegulationsName = 'regulations__name',
	RegulationsSuccessCriteria = 'regulations__success_criteria',
	RegulationsType = 'regulations__type',
	RegulationsUrl = 'regulations__url',
	RunId = 'run_id',
	RunMetadata = 'run_metadata',
	RunTime = 'run_time',
	ScanId = 'scan_id',
	ScanName = 'scan_name',
	Screenshot = 'screenshot',
	ScreenshotMetadata = 'screenshot_metadata',
	SdkType = 'sdk_type',
	SessionName = 'session_name',
	SeverityId = 'severity_id',
	SeverityName = 'severity_name',
	Signature = 'signature',
	Summary = 'summary',
	TagsDescription = 'tags__description',
	TagsId = 'tags__id',
	TagsLink = 'tags__link',
	TagsTitle = 'tags__title',
	TagsType = 'tags__type',
	TenantId = 'tenant_id',
	TestCase = 'test_case',
	TestId = 'test_id',
	TestMethod = 'test_method',
	TestName = 'test_name',
	TestPath = 'test_path',
	TestSuite = 'test_suite',
	TestUniqueIdentifier = 'test_unique_identifier',
	TicketsKey = 'tickets__key',
	TicketsLink = 'tickets__link',
	TypeId = 'type_id',
	TypeName = 'type_name',
	UpdateTime = 'update_time',
	Url = 'url',
	UserAgent = 'user_agent',
	ValidationId = 'validation_id',
	ValidationStatus = 'validation_status',
	ViewportHeight = 'viewport_height',
	ViewportWidth = 'viewport_width'
}

export type Mfa_Scans_Impacted_Per_Issue_Severity = {
	__typename?: 'mfa_scans_impacted_per_issue_severity';
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeveritySeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeveritySeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeverityTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for mfa_scans_impacted_per_issue_severity queries. */
export type Mfa_Scans_Impacted_Per_Issue_SeverityAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_SeverityOrFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearch>;
	text_starts_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export enum Mfa_Scans_Impacted_Per_Issue_SeverityGroup {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** Logical OR filter group for mfa_scans_impacted_per_issue_severity queries. */
export type Mfa_Scans_Impacted_Per_Issue_SeverityOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_SeverityAndFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearch>;
	text_starts_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeveritySearch = {
	searchFields: Array<Mfa_Scans_Impacted_Per_Issue_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeveritySearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Mfa_Scans_Impacted_Per_Issue_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_SeveritySort = {
	fields: Array<Mfa_Scans_Impacted_Per_Issue_SeveritySortFields>;
	order?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_SeveritySortOrder>;
};

export enum Mfa_Scans_Impacted_Per_Issue_SeveritySortFields {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** An example enum type */
export enum Mfa_Scans_Impacted_Per_Issue_SeveritySortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Mfa_Scans_Impacted_Per_Issue_SeverityTextSearchFields {
	OwnerId = 'owner_id',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TotalScans = 'total_scans'
}

export type Mfa_Scans_Impacted_Per_Issue_Type = {
	__typename?: 'mfa_scans_impacted_per_issue_type';
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
};

export type Mfa_Scans_Impacted_Per_Issue_TypeOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for mfa_scans_impacted_per_issue_type queries. */
export type Mfa_Scans_Impacted_Per_Issue_TypeAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_TypeOrFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearch>;
	text_starts_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export enum Mfa_Scans_Impacted_Per_Issue_TypeGroup {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** Logical OR filter group for mfa_scans_impacted_per_issue_type queries. */
export type Mfa_Scans_Impacted_Per_Issue_TypeOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Mfa_Scans_Impacted_Per_Issue_TypeAndFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearch>;
	text_starts_with?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeSearch = {
	searchFields: Array<Mfa_Scans_Impacted_Per_Issue_TypeTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Mfa_Scans_Impacted_Per_Issue_TypeTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Scans_Impacted_Per_Issue_TypeSort = {
	fields: Array<Mfa_Scans_Impacted_Per_Issue_TypeSortFields>;
	order?: InputMaybe<Mfa_Scans_Impacted_Per_Issue_TypeSortOrder>;
};

export enum Mfa_Scans_Impacted_Per_Issue_TypeSortFields {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** An example enum type */
export enum Mfa_Scans_Impacted_Per_Issue_TypeSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Mfa_Scans_Impacted_Per_Issue_TypeTextSearchFields {
	OwnerId = 'owner_id',
	RunId = 'run_id',
	RunTime = 'run_time',
	TenantId = 'tenant_id',
	TotalScans = 'total_scans',
	TypeName = 'type_name'
}

export type Mfa_Session_Runs = {
	__typename?: 'mfa_session_runs';
	app: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_any: Array<Scalars['String']['output']>;
	app_build_number: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_build_number_any: Array<Scalars['String']['output']>;
	app_id: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_id_any: Array<Scalars['String']['output']>;
	app_version: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_version_any: Array<Scalars['String']['output']>;
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	companion_app_version: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	companion_app_version_any: Array<Scalars['String']['output']>;
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	device_manufacturer: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_any: Array<Scalars['String']['output']>;
	device_model: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_model_any: Array<Scalars['String']['output']>;
	device_personalized_name: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_any: Array<Scalars['String']['output']>;
	device_type: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_type_any: Array<Scalars['String']['output']>;
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	mobile_kit: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	mobile_kit_any: Array<Scalars['String']['output']>;
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	os: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	os_any: Array<Scalars['String']['output']>;
	os_version: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	os_version_any: Array<Scalars['String']['output']>;
	product_version: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	product_version_any: Array<Scalars['String']['output']>;
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	run_updated_at: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_updated_at_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_updated_at_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_updated_at_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_updated_at_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_updated_at_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_updated_at_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_updated_at_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_updated_at_truncYear?: Maybe<Scalars['DateTime']['output']>;
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	session_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	session_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	session_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
	user_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	user_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	user_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_min: Scalars['String']['output'];
};

export type Mfa_Session_RunsBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Session_RunsMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Session_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Session_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsRun_Updated_At_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Session_RunsRun_Updated_At_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsSession_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Session_RunsSession_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Session_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Session_RunsUser_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Session_RunsUser_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for mfa_session_runs queries. */
export type Mfa_Session_RunsAndFilter = {
	/** Equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Mfa_Session_RunsOrFilter>>;
	/** Equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: run_updated_at) */
	run_updated_at_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_updated_at) */
	run_updated_at_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_updated_at) */
	run_updated_at_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_updated_at) */
	run_updated_at_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_updated_at) */
	run_updated_at_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_updated_at) */
	run_updated_at_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_updated_at) */
	run_updated_at_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Session_RunsSearch>;
	text_starts_with?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: user_name) */
	user_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_name) */
	user_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_name) */
	user_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_name) */
	user_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_name) */
	user_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_name) */
	user_name_ne?: InputMaybe<ConditionString>;
};

export enum Mfa_Session_RunsGroup {
	AppAny = 'app_any',
	AppBuildNumberAny = 'app_build_number_any',
	AppIdAny = 'app_id_any',
	AppVersionAny = 'app_version_any',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersionAny = 'companion_app_version_any',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceModelAny = 'device_model_any',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DeviceTypeAny = 'device_type_any',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKitAny = 'mobile_kit_any',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	OsAny = 'os_any',
	OsVersionAny = 'os_version_any',
	ProductVersionAny = 'product_version_any',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	RunUpdatedAt = 'run_updated_at',
	RunUpdatedAtAny = 'run_updated_at_any',
	RunUpdatedAtCount = 'run_updated_at_count',
	RunUpdatedAtGroupUniqArray = 'run_updated_at_group_uniq_array',
	RunUpdatedAtMax = 'run_updated_at_max',
	RunUpdatedAtMin = 'run_updated_at_min',
	RunUpdatedAtTruncDay = 'run_updated_at_truncDay',
	RunUpdatedAtTruncMonth = 'run_updated_at_truncMonth',
	RunUpdatedAtTruncYear = 'run_updated_at_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum',
	UserName = 'user_name',
	UserNameAny = 'user_name_any',
	UserNameCount = 'user_name_count',
	UserNameGroupUniqArray = 'user_name_group_uniq_array',
	UserNameMax = 'user_name_max',
	UserNameMin = 'user_name_min'
}

/** Logical OR filter group for mfa_session_runs queries. */
export type Mfa_Session_RunsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Mfa_Session_RunsAndFilter>>;
	/** Equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: product_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	product_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	product_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: product_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	product_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: run_updated_at) */
	run_updated_at_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_updated_at) */
	run_updated_at_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_updated_at) */
	run_updated_at_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_updated_at) */
	run_updated_at_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_updated_at) */
	run_updated_at_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_updated_at) */
	run_updated_at_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_updated_at) */
	run_updated_at_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Session_RunsSearch>;
	text_starts_with?: InputMaybe<Mfa_Session_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: user_name) */
	user_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_name) */
	user_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_name) */
	user_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_name) */
	user_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_name) */
	user_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_name) */
	user_name_ne?: InputMaybe<ConditionString>;
};

export type Mfa_Session_RunsSearch = {
	searchFields: Array<Mfa_Session_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Session_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Mfa_Session_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Session_RunsSort = {
	fields: Array<Mfa_Session_RunsSortFields>;
	order?: InputMaybe<Mfa_Session_RunsSortOrder>;
};

export enum Mfa_Session_RunsSortFields {
	AppAny = 'app_any',
	AppBuildNumberAny = 'app_build_number_any',
	AppIdAny = 'app_id_any',
	AppVersionAny = 'app_version_any',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersionAny = 'companion_app_version_any',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceModelAny = 'device_model_any',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DeviceTypeAny = 'device_type_any',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKitAny = 'mobile_kit_any',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	OsAny = 'os_any',
	OsVersionAny = 'os_version_any',
	ProductVersionAny = 'product_version_any',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	RunUpdatedAt = 'run_updated_at',
	RunUpdatedAtAny = 'run_updated_at_any',
	RunUpdatedAtCount = 'run_updated_at_count',
	RunUpdatedAtGroupUniqArray = 'run_updated_at_group_uniq_array',
	RunUpdatedAtMax = 'run_updated_at_max',
	RunUpdatedAtMin = 'run_updated_at_min',
	RunUpdatedAtTruncDay = 'run_updated_at_truncDay',
	RunUpdatedAtTruncMonth = 'run_updated_at_truncMonth',
	RunUpdatedAtTruncYear = 'run_updated_at_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum',
	UserName = 'user_name',
	UserNameAny = 'user_name_any',
	UserNameCount = 'user_name_count',
	UserNameGroupUniqArray = 'user_name_group_uniq_array',
	UserNameMax = 'user_name_max',
	UserNameMin = 'user_name_min'
}

/** An example enum type */
export enum Mfa_Session_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Mfa_Session_RunsTextSearchFields {
	App = 'app',
	AppBuildNumber = 'app_build_number',
	AppId = 'app_id',
	AppVersion = 'app_version',
	BestPracticeIssues = 'best_practice_issues',
	CompanionAppVersion = 'companion_app_version',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	DeviceManufacturer = 'device_manufacturer',
	DeviceModel = 'device_model',
	DevicePersonalizedName = 'device_personalized_name',
	DeviceType = 'device_type',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MobileKit = 'mobile_kit',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	Os = 'os',
	OsVersion = 'os_version',
	ProductVersion = 'product_version',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	RunUpdatedAt = 'run_updated_at',
	SeriousIssues = 'serious_issues',
	SessionName = 'session_name',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TotalScans = 'total_scans',
	UserName = 'user_name'
}

export type Mfa_Test_By_Issue_Types = {
	__typename?: 'mfa_test_by_issue_types';
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
};

export type Mfa_Test_By_Issue_TypesOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_By_Issue_TypesOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_Issue_TypesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_By_Issue_TypesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_Issue_TypesRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Test_By_Issue_TypesRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_Issue_TypesSeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Test_By_Issue_TypesSeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_Issue_TypesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_By_Issue_TypesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_Issue_TypesTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_Issue_TypesTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_Issue_TypesType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Test_By_Issue_TypesType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for mfa_test_by_issue_types queries. */
export type Mfa_Test_By_Issue_TypesAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Mfa_Test_By_Issue_TypesOrFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_By_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export enum Mfa_Test_By_Issue_TypesGroup {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** Logical OR filter group for mfa_test_by_issue_types queries. */
export type Mfa_Test_By_Issue_TypesOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Mfa_Test_By_Issue_TypesAndFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_By_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Mfa_Test_By_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export type Mfa_Test_By_Issue_TypesSearch = {
	searchFields: Array<Mfa_Test_By_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Test_By_Issue_TypesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Mfa_Test_By_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Test_By_Issue_TypesSort = {
	fields: Array<Mfa_Test_By_Issue_TypesSortFields>;
	order?: InputMaybe<Mfa_Test_By_Issue_TypesSortOrder>;
};

export enum Mfa_Test_By_Issue_TypesSortFields {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** An example enum type */
export enum Mfa_Test_By_Issue_TypesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Mfa_Test_By_Issue_TypesTextSearchFields {
	OwnerId = 'owner_id',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TypeName = 'type_name'
}

export type Mfa_Test_By_Severity = {
	__typename?: 'mfa_test_by_severity';
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	percentage: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	percentage_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	percentage_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_sum: Scalars['Int']['output'];
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
};

export type Mfa_Test_By_SeverityOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_By_SeverityOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_SeverityPercentage_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type Mfa_Test_By_SeverityPercentage_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_SeverityRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_By_SeverityRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_SeverityRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Test_By_SeverityRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_SeveritySeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Test_By_SeveritySeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_SeverityTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_By_SeverityTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_SeverityTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_By_SeverityTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for mfa_test_by_severity queries. */
export type Mfa_Test_By_SeverityAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Mfa_Test_By_SeverityOrFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: percentage) */
	percentage_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: percentage) */
	percentage_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: percentage) */
	percentage_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: percentage) */
	percentage_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: percentage) */
	percentage_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: percentage) */
	percentage_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_By_SeveritySearch>;
	text_starts_with?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export enum Mfa_Test_By_SeverityGroup {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	Percentage = 'percentage',
	PercentageAny = 'percentage_any',
	PercentageCount = 'percentage_count',
	PercentageGroupUniqArray = 'percentage_group_uniq_array',
	PercentageMax = 'percentage_max',
	PercentageMin = 'percentage_min',
	PercentageSum = 'percentage_sum',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** Logical OR filter group for mfa_test_by_severity queries. */
export type Mfa_Test_By_SeverityOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Mfa_Test_By_SeverityAndFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: percentage) */
	percentage_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: percentage) */
	percentage_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: percentage) */
	percentage_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: percentage) */
	percentage_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: percentage) */
	percentage_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: percentage) */
	percentage_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_By_SeveritySearch>;
	text_starts_with?: InputMaybe<Mfa_Test_By_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type Mfa_Test_By_SeveritySearch = {
	searchFields: Array<Mfa_Test_By_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Test_By_SeveritySearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Mfa_Test_By_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Test_By_SeveritySort = {
	fields: Array<Mfa_Test_By_SeveritySortFields>;
	order?: InputMaybe<Mfa_Test_By_SeveritySortOrder>;
};

export enum Mfa_Test_By_SeveritySortFields {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	Percentage = 'percentage',
	PercentageAny = 'percentage_any',
	PercentageCount = 'percentage_count',
	PercentageGroupUniqArray = 'percentage_group_uniq_array',
	PercentageMax = 'percentage_max',
	PercentageMin = 'percentage_min',
	PercentageSum = 'percentage_sum',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** An example enum type */
export enum Mfa_Test_By_SeveritySortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Mfa_Test_By_SeverityTextSearchFields {
	OwnerId = 'owner_id',
	Percentage = 'percentage',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues'
}

export type Mfa_Test_Top_Issue_Types = {
	__typename?: 'mfa_test_top_issue_types';
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
};

export type Mfa_Test_Top_Issue_TypesOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_Top_Issue_TypesOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_Top_Issue_TypesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_Top_Issue_TypesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_Top_Issue_TypesRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Test_Top_Issue_TypesRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_Top_Issue_TypesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Test_Top_Issue_TypesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_Top_Issue_TypesTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_Top_Issue_TypesTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Test_Top_Issue_TypesType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Mfa_Test_Top_Issue_TypesType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for mfa_test_top_issue_types queries. */
export type Mfa_Test_Top_Issue_TypesAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Mfa_Test_Top_Issue_TypesOrFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_Top_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export enum Mfa_Test_Top_Issue_TypesGroup {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** Logical OR filter group for mfa_test_top_issue_types queries. */
export type Mfa_Test_Top_Issue_TypesOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Mfa_Test_Top_Issue_TypesAndFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Test_Top_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Mfa_Test_Top_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export type Mfa_Test_Top_Issue_TypesSearch = {
	searchFields: Array<Mfa_Test_Top_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Test_Top_Issue_TypesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Mfa_Test_Top_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Test_Top_Issue_TypesSort = {
	fields: Array<Mfa_Test_Top_Issue_TypesSortFields>;
	order?: InputMaybe<Mfa_Test_Top_Issue_TypesSortOrder>;
};

export enum Mfa_Test_Top_Issue_TypesSortFields {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** An example enum type */
export enum Mfa_Test_Top_Issue_TypesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Mfa_Test_Top_Issue_TypesTextSearchFields {
	OwnerId = 'owner_id',
	RunId = 'run_id',
	RunTime = 'run_time',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TypeName = 'type_name'
}

export type Mfa_Worst_Performing_Scans = {
	__typename?: 'mfa_worst_performing_scans';
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	scan_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	scan_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
};

export type Mfa_Worst_Performing_ScansOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Worst_Performing_ScansOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Worst_Performing_ScansRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Worst_Performing_ScansRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Worst_Performing_ScansRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Mfa_Worst_Performing_ScansRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Worst_Performing_ScansScan_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Worst_Performing_ScansScan_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Worst_Performing_ScansTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Mfa_Worst_Performing_ScansTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Worst_Performing_ScansTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Mfa_Worst_Performing_ScansTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for mfa_worst_performing_scans queries. */
export type Mfa_Worst_Performing_ScansAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Mfa_Worst_Performing_ScansOrFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Worst_Performing_ScansSearch>;
	text_starts_with?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export enum Mfa_Worst_Performing_ScansGroup {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** Logical OR filter group for mfa_worst_performing_scans queries. */
export type Mfa_Worst_Performing_ScansOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Mfa_Worst_Performing_ScansAndFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_equals?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<Mfa_Worst_Performing_ScansSearch>;
	text_starts_with?: InputMaybe<Mfa_Worst_Performing_ScansSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type Mfa_Worst_Performing_ScansSearch = {
	searchFields: Array<Mfa_Worst_Performing_ScansTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Worst_Performing_ScansSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Mfa_Worst_Performing_ScansTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Mfa_Worst_Performing_ScansSort = {
	fields: Array<Mfa_Worst_Performing_ScansSortFields>;
	order?: InputMaybe<Mfa_Worst_Performing_ScansSortOrder>;
};

export enum Mfa_Worst_Performing_ScansSortFields {
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** An example enum type */
export enum Mfa_Worst_Performing_ScansSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Mfa_Worst_Performing_ScansTextSearchFields {
	OwnerId = 'owner_id',
	RunId = 'run_id',
	RunTime = 'run_time',
	ScanId = 'scan_id',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues'
}

export type Msdk_Report_Runs = {
	__typename?: 'msdk_report_runs';
	app: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_any: Scalars['String']['output'];
	app_build_number: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_build_number_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_build_number_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	app_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_min: Scalars['String']['output'];
	app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_min: Scalars['String']['output'];
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	companion_app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	companion_app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	companion_app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_min: Scalars['String']['output'];
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	device_manufacturer: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_manufacturer_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_min: Scalars['String']['output'];
	device_model: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_model_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_model_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_min: Scalars['String']['output'];
	device_personalized_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_personalized_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_min: Scalars['String']['output'];
	device_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_min: Scalars['String']['output'];
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	mobile_kit: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	mobile_kit_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	mobile_kit_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_min: Scalars['String']['output'];
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	os: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_min: Scalars['String']['output'];
	os_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_min: Scalars['String']['output'];
	product_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_min: Scalars['String']['output'];
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	sdk_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	sdk_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	sdk_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_min: Scalars['String']['output'];
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
};

export type Msdk_Report_RunsApp_Build_Number_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsApp_Build_Number_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsApp_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsApp_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsApp_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsApp_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsApp_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsApp_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsCompanion_App_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsCompanion_App_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsDevice_Manufacturer_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsDevice_Manufacturer_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsDevice_Model_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsDevice_Model_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsDevice_Personalized_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsDevice_Personalized_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsDevice_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsDevice_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsMobile_Kit_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsMobile_Kit_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsOs_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsOs_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsOs_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsOs_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsProduct_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsProduct_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Report_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Report_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsSdk_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsSdk_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Report_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_RunsTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_RunsTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_report_runs queries. */
export type Msdk_Report_RunsAndFilter = {
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Report_RunsOrFilter>>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Report_RunsSearch>;
	text_starts_with?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export enum Msdk_Report_RunsGroup {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKit = 'mobile_kit',
	MobileKitAny = 'mobile_kit_any',
	MobileKitCount = 'mobile_kit_count',
	MobileKitGroupUniqArray = 'mobile_kit_group_uniq_array',
	MobileKitMax = 'mobile_kit_max',
	MobileKitMin = 'mobile_kit_min',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** Logical OR filter group for msdk_report_runs queries. */
export type Msdk_Report_RunsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Report_RunsAndFilter>>;
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Report_RunsSearch>;
	text_starts_with?: InputMaybe<Msdk_Report_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type Msdk_Report_RunsSearch = {
	searchFields: Array<Msdk_Report_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Report_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Report_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Report_RunsSort = {
	fields: Array<Msdk_Report_RunsSortFields>;
	order?: InputMaybe<Msdk_Report_RunsSortOrder>;
};

export enum Msdk_Report_RunsSortFields {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKit = 'mobile_kit',
	MobileKitAny = 'mobile_kit_any',
	MobileKitCount = 'mobile_kit_count',
	MobileKitGroupUniqArray = 'mobile_kit_group_uniq_array',
	MobileKitMax = 'mobile_kit_max',
	MobileKitMin = 'mobile_kit_min',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** An example enum type */
export enum Msdk_Report_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Report_RunsTextSearchFields {
	App = 'app',
	AppBuildNumber = 'app_build_number',
	AppId = 'app_id',
	AppVersion = 'app_version',
	BestPracticeIssues = 'best_practice_issues',
	CompanionAppVersion = 'companion_app_version',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	DeviceManufacturer = 'device_manufacturer',
	DeviceModel = 'device_model',
	DevicePersonalizedName = 'device_personalized_name',
	DeviceType = 'device_type',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MobileKit = 'mobile_kit',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	Os = 'os',
	OsVersion = 'os_version',
	ProductVersion = 'product_version',
	RunId = 'run_id',
	RunTime = 'run_time',
	SdkType = 'sdk_type',
	SeriousIssues = 'serious_issues',
	TenantId = 'tenant_id',
	TestName = 'test_name',
	TotalIssues = 'total_issues',
	TotalScans = 'total_scans'
}

export type Msdk_Report_Runs_Latest = {
	__typename?: 'msdk_report_runs_latest';
	app: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_any: Scalars['String']['output'];
	app_build_number: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_build_number_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_build_number_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	app_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_min: Scalars['String']['output'];
	app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_min: Scalars['String']['output'];
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	companion_app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	companion_app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	companion_app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_min: Scalars['String']['output'];
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	device_manufacturer: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_manufacturer_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_min: Scalars['String']['output'];
	device_model: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_model_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_model_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_min: Scalars['String']['output'];
	device_personalized_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_personalized_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_min: Scalars['String']['output'];
	device_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_min: Scalars['String']['output'];
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	mobile_kit: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	mobile_kit_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	mobile_kit_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_min: Scalars['String']['output'];
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	os: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_min: Scalars['String']['output'];
	os_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_min: Scalars['String']['output'];
	product_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_min: Scalars['String']['output'];
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	sdk_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	sdk_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	sdk_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_min: Scalars['String']['output'];
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
};

export type Msdk_Report_Runs_LatestApp_Build_Number_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestApp_Build_Number_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestApp_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestApp_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestApp_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestApp_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestApp_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestApp_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestCompanion_App_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestCompanion_App_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Manufacturer_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Manufacturer_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Model_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Model_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Personalized_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Personalized_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestDevice_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestMobile_Kit_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestMobile_Kit_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestOs_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestOs_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestOs_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestOs_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestProduct_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestProduct_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Report_Runs_LatestRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Report_Runs_LatestRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestSdk_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestSdk_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Report_Runs_LatestTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Report_Runs_LatestTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_report_runs_latest queries. */
export type Msdk_Report_Runs_LatestAndFilter = {
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Report_Runs_LatestOrFilter>>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Report_Runs_LatestSearch>;
	text_starts_with?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export enum Msdk_Report_Runs_LatestGroup {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKit = 'mobile_kit',
	MobileKitAny = 'mobile_kit_any',
	MobileKitCount = 'mobile_kit_count',
	MobileKitGroupUniqArray = 'mobile_kit_group_uniq_array',
	MobileKitMax = 'mobile_kit_max',
	MobileKitMin = 'mobile_kit_min',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** Logical OR filter group for msdk_report_runs_latest queries. */
export type Msdk_Report_Runs_LatestOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Report_Runs_LatestAndFilter>>;
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Report_Runs_LatestSearch>;
	text_starts_with?: InputMaybe<Msdk_Report_Runs_LatestSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type Msdk_Report_Runs_LatestSearch = {
	searchFields: Array<Msdk_Report_Runs_LatestTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Report_Runs_LatestTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Report_Runs_LatestSort = {
	fields: Array<Msdk_Report_Runs_LatestSortFields>;
	order?: InputMaybe<Msdk_Report_Runs_LatestSortOrder>;
};

export enum Msdk_Report_Runs_LatestSortFields {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKit = 'mobile_kit',
	MobileKitAny = 'mobile_kit_any',
	MobileKitCount = 'mobile_kit_count',
	MobileKitGroupUniqArray = 'mobile_kit_group_uniq_array',
	MobileKitMax = 'mobile_kit_max',
	MobileKitMin = 'mobile_kit_min',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** An example enum type */
export enum Msdk_Report_Runs_LatestSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Report_Runs_LatestTextSearchFields {
	App = 'app',
	AppBuildNumber = 'app_build_number',
	AppId = 'app_id',
	AppVersion = 'app_version',
	BestPracticeIssues = 'best_practice_issues',
	CompanionAppVersion = 'companion_app_version',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	DeviceManufacturer = 'device_manufacturer',
	DeviceModel = 'device_model',
	DevicePersonalizedName = 'device_personalized_name',
	DeviceType = 'device_type',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MobileKit = 'mobile_kit',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	Os = 'os',
	OsVersion = 'os_version',
	ProductVersion = 'product_version',
	RunId = 'run_id',
	RunTime = 'run_time',
	SdkType = 'sdk_type',
	SeriousIssues = 'serious_issues',
	TenantId = 'tenant_id',
	TestName = 'test_name',
	TotalIssues = 'total_issues',
	TotalScans = 'total_scans'
}

export type Msdk_Scans_Impacted_Per_Issue_Severity = {
	__typename?: 'msdk_scans_impacted_per_issue_severity';
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeveritySeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeveritySeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeverityTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_scans_impacted_per_issue_severity queries. */
export type Msdk_Scans_Impacted_Per_Issue_SeverityAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_SeverityOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearch>;
	text_starts_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export enum Msdk_Scans_Impacted_Per_Issue_SeverityGroup {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** Logical OR filter group for msdk_scans_impacted_per_issue_severity queries. */
export type Msdk_Scans_Impacted_Per_Issue_SeverityOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_SeverityAndFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearch>;
	text_starts_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeveritySearch = {
	searchFields: Array<Msdk_Scans_Impacted_Per_Issue_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeveritySearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Scans_Impacted_Per_Issue_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_SeveritySort = {
	fields: Array<Msdk_Scans_Impacted_Per_Issue_SeveritySortFields>;
	order?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_SeveritySortOrder>;
};

export enum Msdk_Scans_Impacted_Per_Issue_SeveritySortFields {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** An example enum type */
export enum Msdk_Scans_Impacted_Per_Issue_SeveritySortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Scans_Impacted_Per_Issue_SeverityTextSearchFields {
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TotalScans = 'total_scans'
}

export type Msdk_Scans_Impacted_Per_Issue_Type = {
	__typename?: 'msdk_scans_impacted_per_issue_type';
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
};

export type Msdk_Scans_Impacted_Per_Issue_TypeRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_scans_impacted_per_issue_type queries. */
export type Msdk_Scans_Impacted_Per_Issue_TypeAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_TypeOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearch>;
	text_starts_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export enum Msdk_Scans_Impacted_Per_Issue_TypeGroup {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** Logical OR filter group for msdk_scans_impacted_per_issue_type queries. */
export type Msdk_Scans_Impacted_Per_Issue_TypeOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Scans_Impacted_Per_Issue_TypeAndFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearch>;
	text_starts_with?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeSearch = {
	searchFields: Array<Msdk_Scans_Impacted_Per_Issue_TypeTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Scans_Impacted_Per_Issue_TypeTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Scans_Impacted_Per_Issue_TypeSort = {
	fields: Array<Msdk_Scans_Impacted_Per_Issue_TypeSortFields>;
	order?: InputMaybe<Msdk_Scans_Impacted_Per_Issue_TypeSortOrder>;
};

export enum Msdk_Scans_Impacted_Per_Issue_TypeSortFields {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** An example enum type */
export enum Msdk_Scans_Impacted_Per_Issue_TypeSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Scans_Impacted_Per_Issue_TypeTextSearchFields {
	RunId = 'run_id',
	RunTime = 'run_time',
	TenantId = 'tenant_id',
	TotalScans = 'total_scans',
	TypeName = 'type_name'
}

export type Msdk_Test_By_Issue_Types = {
	__typename?: 'msdk_test_by_issue_types';
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
};

export type Msdk_Test_By_Issue_TypesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_By_Issue_TypesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_Issue_TypesRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Test_By_Issue_TypesRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_Issue_TypesSeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_By_Issue_TypesSeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_Issue_TypesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_By_Issue_TypesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_Issue_TypesTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_Issue_TypesTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_Issue_TypesType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_By_Issue_TypesType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_test_by_issue_types queries. */
export type Msdk_Test_By_Issue_TypesAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Test_By_Issue_TypesOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_By_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export enum Msdk_Test_By_Issue_TypesGroup {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** Logical OR filter group for msdk_test_by_issue_types queries. */
export type Msdk_Test_By_Issue_TypesOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Test_By_Issue_TypesAndFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_By_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_By_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export type Msdk_Test_By_Issue_TypesSearch = {
	searchFields: Array<Msdk_Test_By_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_By_Issue_TypesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Test_By_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_By_Issue_TypesSort = {
	fields: Array<Msdk_Test_By_Issue_TypesSortFields>;
	order?: InputMaybe<Msdk_Test_By_Issue_TypesSortOrder>;
};

export enum Msdk_Test_By_Issue_TypesSortFields {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** An example enum type */
export enum Msdk_Test_By_Issue_TypesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Test_By_Issue_TypesTextSearchFields {
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TypeName = 'type_name'
}

export type Msdk_Test_By_Severity = {
	__typename?: 'msdk_test_by_severity';
	percentage: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	percentage_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	percentage_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	percentage_sum: Scalars['Int']['output'];
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
};

export type Msdk_Test_By_SeverityPercentage_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type Msdk_Test_By_SeverityPercentage_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_SeverityRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_By_SeverityRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_SeverityRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Test_By_SeverityRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_SeveritySeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_By_SeveritySeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_SeverityTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_By_SeverityTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_SeverityTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_By_SeverityTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_test_by_severity queries. */
export type Msdk_Test_By_SeverityAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Test_By_SeverityOrFilter>>;
	/** Equals (FieldName: percentage) */
	percentage_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: percentage) */
	percentage_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: percentage) */
	percentage_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: percentage) */
	percentage_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: percentage) */
	percentage_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: percentage) */
	percentage_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_By_SeveritySearch>;
	text_starts_with?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export enum Msdk_Test_By_SeverityGroup {
	Percentage = 'percentage',
	PercentageAny = 'percentage_any',
	PercentageCount = 'percentage_count',
	PercentageGroupUniqArray = 'percentage_group_uniq_array',
	PercentageMax = 'percentage_max',
	PercentageMin = 'percentage_min',
	PercentageSum = 'percentage_sum',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** Logical OR filter group for msdk_test_by_severity queries. */
export type Msdk_Test_By_SeverityOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Test_By_SeverityAndFilter>>;
	/** Equals (FieldName: percentage) */
	percentage_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: percentage) */
	percentage_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: percentage) */
	percentage_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: percentage) */
	percentage_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: percentage) */
	percentage_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: percentage) */
	percentage_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_By_SeveritySearch>;
	text_starts_with?: InputMaybe<Msdk_Test_By_SeveritySearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type Msdk_Test_By_SeveritySearch = {
	searchFields: Array<Msdk_Test_By_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_By_SeveritySearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Test_By_SeverityTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_By_SeveritySort = {
	fields: Array<Msdk_Test_By_SeveritySortFields>;
	order?: InputMaybe<Msdk_Test_By_SeveritySortOrder>;
};

export enum Msdk_Test_By_SeveritySortFields {
	Percentage = 'percentage',
	PercentageAny = 'percentage_any',
	PercentageCount = 'percentage_count',
	PercentageGroupUniqArray = 'percentage_group_uniq_array',
	PercentageMax = 'percentage_max',
	PercentageMin = 'percentage_min',
	PercentageSum = 'percentage_sum',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** An example enum type */
export enum Msdk_Test_By_SeveritySortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Test_By_SeverityTextSearchFields {
	Percentage = 'percentage',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues'
}

export type Msdk_Test_Runs = {
	__typename?: 'msdk_test_runs';
	app: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_any: Scalars['String']['output'];
	app_build_number: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_build_number_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_build_number_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	app_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_min: Scalars['String']['output'];
	app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_min: Scalars['String']['output'];
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	companion_app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	companion_app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	companion_app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_min: Scalars['String']['output'];
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	device_manufacturer: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_manufacturer_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_min: Scalars['String']['output'];
	device_model: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_model_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_model_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_min: Scalars['String']['output'];
	device_personalized_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_personalized_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_min: Scalars['String']['output'];
	device_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_min: Scalars['String']['output'];
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	mobile_kit: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	mobile_kit_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	mobile_kit_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	mobile_kit_min: Scalars['String']['output'];
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	os: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_min: Scalars['String']['output'];
	os_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_min: Scalars['String']['output'];
	product_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_min: Scalars['String']['output'];
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	sdk_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	sdk_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	sdk_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_min: Scalars['String']['output'];
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	test_path: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_path_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_path_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_min: Scalars['String']['output'];
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
};

export type Msdk_Test_RunsApp_Build_Number_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsApp_Build_Number_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsApp_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsApp_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsApp_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsApp_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsApp_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsApp_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsCompanion_App_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsCompanion_App_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsDevice_Manufacturer_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsDevice_Manufacturer_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsDevice_Model_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsDevice_Model_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsDevice_Personalized_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsDevice_Personalized_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsDevice_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsDevice_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsMobile_Kit_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsMobile_Kit_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsOs_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsOs_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsOs_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsOs_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsProduct_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsProduct_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Test_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsSdk_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsSdk_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsTest_Path_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_RunsTest_Path_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_RunsTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_test_runs queries. */
export type Msdk_Test_RunsAndFilter = {
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Test_RunsOrFilter>>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export enum Msdk_Test_RunsGroup {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKit = 'mobile_kit',
	MobileKitAny = 'mobile_kit_any',
	MobileKitCount = 'mobile_kit_count',
	MobileKitGroupUniqArray = 'mobile_kit_group_uniq_array',
	MobileKitMax = 'mobile_kit_max',
	MobileKitMin = 'mobile_kit_min',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** Logical OR filter group for msdk_test_runs queries. */
export type Msdk_Test_RunsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Test_RunsAndFilter>>;
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type Msdk_Test_RunsSearch = {
	searchFields: Array<Msdk_Test_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Test_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_RunsSort = {
	fields: Array<Msdk_Test_RunsSortFields>;
	order?: InputMaybe<Msdk_Test_RunsSortOrder>;
};

export enum Msdk_Test_RunsSortFields {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKit = 'mobile_kit',
	MobileKitAny = 'mobile_kit_any',
	MobileKitCount = 'mobile_kit_count',
	MobileKitGroupUniqArray = 'mobile_kit_group_uniq_array',
	MobileKitMax = 'mobile_kit_max',
	MobileKitMin = 'mobile_kit_min',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** An example enum type */
export enum Msdk_Test_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Test_RunsTextSearchFields {
	App = 'app',
	AppBuildNumber = 'app_build_number',
	AppId = 'app_id',
	AppVersion = 'app_version',
	BestPracticeIssues = 'best_practice_issues',
	CompanionAppVersion = 'companion_app_version',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	DeviceManufacturer = 'device_manufacturer',
	DeviceModel = 'device_model',
	DevicePersonalizedName = 'device_personalized_name',
	DeviceType = 'device_type',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MobileKit = 'mobile_kit',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	Os = 'os',
	OsVersion = 'os_version',
	ProductVersion = 'product_version',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	SdkType = 'sdk_type',
	SeriousIssues = 'serious_issues',
	TenantId = 'tenant_id',
	TestName = 'test_name',
	TestPath = 'test_path',
	TotalIssues = 'total_issues',
	TotalScans = 'total_scans'
}

export type Msdk_Test_Runs_Latest = {
	__typename?: 'msdk_test_runs_latest';
	app: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_any: Scalars['String']['output'];
	app_build_number: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_build_number_any: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	app_id: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_id_any: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	app_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_min: Scalars['String']['output'];
	app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_min: Scalars['String']['output'];
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	companion_app_version: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	companion_app_version_any: Array<Scalars['String']['output']>;
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	device_manufacturer: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_any: Array<Scalars['String']['output']>;
	device_model: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_model_any: Array<Scalars['String']['output']>;
	device_personalized_name: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_any: Array<Scalars['String']['output']>;
	device_type: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	device_type_any: Array<Scalars['String']['output']>;
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	mobile_kit: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	mobile_kit_any: Array<Scalars['String']['output']>;
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	os: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_min: Scalars['String']['output'];
	os_version: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	os_version_any: Array<Scalars['String']['output']>;
	product_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_min: Scalars['String']['output'];
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	sdk_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	sdk_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	sdk_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_min: Scalars['String']['output'];
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	test_path: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_path_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_path_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_min: Scalars['String']['output'];
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_scans: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_scans_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_scans_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_scans_sum: Scalars['Int']['output'];
};

export type Msdk_Test_Runs_LatestApp_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestApp_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestApp_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestApp_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestOs_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestOs_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestProduct_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestProduct_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_Runs_LatestRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Test_Runs_LatestRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestSdk_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestSdk_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_Runs_LatestTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestTest_Path_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestTest_Path_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestTotal_Scans_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Runs_LatestTotal_Scans_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_test_runs_latest queries. */
export type Msdk_Test_Runs_LatestAndFilter = {
	/** Equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Test_Runs_LatestOrFilter>>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_Runs_LatestSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export enum Msdk_Test_Runs_LatestGroup {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumberAny = 'app_build_number_any',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppIdAny = 'app_id_any',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersionAny = 'companion_app_version_any',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceModelAny = 'device_model_any',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DeviceTypeAny = 'device_type_any',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKitAny = 'mobile_kit_any',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersionAny = 'os_version_any',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** Logical OR filter group for msdk_test_runs_latest queries. */
export type Msdk_Test_Runs_LatestOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Test_Runs_LatestAndFilter>>;
	/** Equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_build_number_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_build_number): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_build_number_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	app_id_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: app_id): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	app_id_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	companion_app_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: companion_app_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	companion_app_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_manufacturer_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_manufacturer): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_manufacturer_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_model_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_model): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_model_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_personalized_name_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_personalized_name): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_personalized_name_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	device_type_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: device_type): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	device_type_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	mobile_kit_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: mobile_kit): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	mobile_kit_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	os_version_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: os_version): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	os_version_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_Runs_LatestSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_Runs_LatestSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_scans) */
	total_scans_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_scans) */
	total_scans_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_scans) */
	total_scans_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_scans) */
	total_scans_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_scans) */
	total_scans_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_scans) */
	total_scans_ne?: InputMaybe<ConditionInt>;
};

export type Msdk_Test_Runs_LatestSearch = {
	searchFields: Array<Msdk_Test_Runs_LatestTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Test_Runs_LatestTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_Runs_LatestSort = {
	fields: Array<Msdk_Test_Runs_LatestSortFields>;
	order?: InputMaybe<Msdk_Test_Runs_LatestSortOrder>;
};

export enum Msdk_Test_Runs_LatestSortFields {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumberAny = 'app_build_number_any',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppIdAny = 'app_id_any',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CompanionAppVersionAny = 'companion_app_version_any',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceModelAny = 'device_model_any',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DeviceTypeAny = 'device_type_any',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	MobileKitAny = 'mobile_kit_any',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersionAny = 'os_version_any',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalScans = 'total_scans',
	TotalScansAny = 'total_scans_any',
	TotalScansCount = 'total_scans_count',
	TotalScansGroupUniqArray = 'total_scans_group_uniq_array',
	TotalScansMax = 'total_scans_max',
	TotalScansMin = 'total_scans_min',
	TotalScansSum = 'total_scans_sum'
}

/** An example enum type */
export enum Msdk_Test_Runs_LatestSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Test_Runs_LatestTextSearchFields {
	App = 'app',
	AppBuildNumber = 'app_build_number',
	AppId = 'app_id',
	AppVersion = 'app_version',
	BestPracticeIssues = 'best_practice_issues',
	CompanionAppVersion = 'companion_app_version',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	DeviceManufacturer = 'device_manufacturer',
	DeviceModel = 'device_model',
	DevicePersonalizedName = 'device_personalized_name',
	DeviceType = 'device_type',
	FilteredCustomFields = 'filtered_custom_fields',
	MinorIssues = 'minor_issues',
	MobileKit = 'mobile_kit',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	Os = 'os',
	OsVersion = 'os_version',
	ProductVersion = 'product_version',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	SdkType = 'sdk_type',
	SeriousIssues = 'serious_issues',
	TenantId = 'tenant_id',
	TestName = 'test_name',
	TestPath = 'test_path',
	TotalIssues = 'total_issues',
	TotalScans = 'total_scans'
}

export type Msdk_Test_Top_Issue_Types = {
	__typename?: 'msdk_test_top_issue_types';
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
};

export type Msdk_Test_Top_Issue_TypesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_Top_Issue_TypesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Top_Issue_TypesRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Test_Top_Issue_TypesRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Top_Issue_TypesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Test_Top_Issue_TypesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Top_Issue_TypesTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Top_Issue_TypesTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Test_Top_Issue_TypesType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Msdk_Test_Top_Issue_TypesType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_test_top_issue_types queries. */
export type Msdk_Test_Top_Issue_TypesAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Test_Top_Issue_TypesOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_Top_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export enum Msdk_Test_Top_Issue_TypesGroup {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** Logical OR filter group for msdk_test_top_issue_types queries. */
export type Msdk_Test_Top_Issue_TypesOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Test_Top_Issue_TypesAndFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Test_Top_Issue_TypesSearch>;
	text_starts_with?: InputMaybe<Msdk_Test_Top_Issue_TypesSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export type Msdk_Test_Top_Issue_TypesSearch = {
	searchFields: Array<Msdk_Test_Top_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_Top_Issue_TypesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Test_Top_Issue_TypesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Test_Top_Issue_TypesSort = {
	fields: Array<Msdk_Test_Top_Issue_TypesSortFields>;
	order?: InputMaybe<Msdk_Test_Top_Issue_TypesSortOrder>;
};

export enum Msdk_Test_Top_Issue_TypesSortFields {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** An example enum type */
export enum Msdk_Test_Top_Issue_TypesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Test_Top_Issue_TypesTextSearchFields {
	RunId = 'run_id',
	RunTime = 'run_time',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TypeName = 'type_name'
}

export type Msdk_Worst_Performing_Scans = {
	__typename?: 'msdk_worst_performing_scans';
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	scan_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	scan_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
};

export type Msdk_Worst_Performing_ScansRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Worst_Performing_ScansRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Worst_Performing_ScansRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Msdk_Worst_Performing_ScansRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Worst_Performing_ScansScan_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Worst_Performing_ScansScan_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Worst_Performing_ScansTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Msdk_Worst_Performing_ScansTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Worst_Performing_ScansTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Msdk_Worst_Performing_ScansTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for msdk_worst_performing_scans queries. */
export type Msdk_Worst_Performing_ScansAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Msdk_Worst_Performing_ScansOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Worst_Performing_ScansSearch>;
	text_starts_with?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export enum Msdk_Worst_Performing_ScansGroup {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** Logical OR filter group for msdk_worst_performing_scans queries. */
export type Msdk_Worst_Performing_ScansOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Msdk_Worst_Performing_ScansAndFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_equals?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<Msdk_Worst_Performing_ScansSearch>;
	text_starts_with?: InputMaybe<Msdk_Worst_Performing_ScansSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
};

export type Msdk_Worst_Performing_ScansSearch = {
	searchFields: Array<Msdk_Worst_Performing_ScansTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Worst_Performing_ScansSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Msdk_Worst_Performing_ScansTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Msdk_Worst_Performing_ScansSort = {
	fields: Array<Msdk_Worst_Performing_ScansSortFields>;
	order?: InputMaybe<Msdk_Worst_Performing_ScansSortOrder>;
};

export enum Msdk_Worst_Performing_ScansSortFields {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum'
}

/** An example enum type */
export enum Msdk_Worst_Performing_ScansSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Msdk_Worst_Performing_ScansTextSearchFields {
	RunId = 'run_id',
	RunTime = 'run_time',
	ScanId = 'scan_id',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues'
}

export type Pages = {
	__typename?: 'pages';
	/** selector of DOM */
	analysis_root_selector: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	analysis_root_selector_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_min: Scalars['String']['output'];
	/** canonical url - extracted from the page */
	canonical_url: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	canonical_url_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	canonical_url_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	canonical_url_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	canonical_url_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	canonical_url_min: Scalars['String']['output'];
	/** client version - as populated by the sdk */
	client_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	client_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	client_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	client_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	client_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	client_version_min: Scalars['String']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** indicates that record has been mark for delete - soft delete */
	deleted: Scalars['Boolean']['output'];
	/** types of detection used for the issues */
	detection_types: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	detection_types_any: Array<Scalars['String']['output']>;
	/** domain of the page */
	domain: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	domain_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	domain_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_min: Scalars['String']['output'];
	/** semantic engines version used to generate current issue */
	engines_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	engines_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	engines_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_min: Scalars['String']['output'];
	/** environment in which the issue was detected */
	environment: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	environment_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	environment_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_min: Scalars['String']['output'];
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	/** user flow in which the issue was detected */
	flow: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	flow_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	flow_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	flow_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	flow_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	flow_min: Scalars['String']['output'];
	/** time of issue ingestion */
	ingestion_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	ingestion_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** user/service account running the analysis */
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** user / service account */
	owner_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	owner_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_min: Scalars['String']['output'];
	/** page id - generated by the client for each page */
	page_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	page_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	page_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	page_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** page title - extracted from the page */
	page_title: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	page_title_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	page_title_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_min: Scalars['String']['output'];
	/** product identifier */
	product_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	product_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	product_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** product name */
	product_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_min: Scalars['String']['output'];
	/** internal product version */
	product_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_min: Scalars['String']['output'];
	/** list of all properties associated with current issue */
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	/** run identifier - represent a single group of issues. value is equivalent to testId, sessionId, scanId */
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** time of run start on client side */
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** test name as sent by the sdk - used to differentiate between tests */
	session_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	session_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	session_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_min: Scalars['String']['output'];
	/** tenant identifier */
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** test id - as sent by the sdk */
	test_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	test_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	test_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** test name as sent by the sdk - used to differentiate between tests */
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	/** full test path - as populated by the sdk */
	test_path: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_path_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_path_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_min: Scalars['String']['output'];
	/** time of last update */
	update_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	update_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	update_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** url - extracted from the page */
	url: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	url_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	url_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	url_min: Scalars['String']['output'];
	/** product name */
	user_agent: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_agent_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_agent_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	user_agent_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	user_agent_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_agent_min: Scalars['String']['output'];
	/** height - view port extracted during the run */
	viewport_height: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	viewport_height_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	viewport_height_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_sum: Scalars['Int']['output'];
	/** width - view port extracted during the run */
	viewport_width: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	viewport_width_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	viewport_width_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_sum: Scalars['Int']['output'];
};

export type PagesAnalysis_Root_Selector_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesAnalysis_Root_Selector_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesCanonical_Url_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesCanonical_Url_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesClient_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesClient_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesDomain_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesDomain_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesEngines_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesEngines_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesEnvironment_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesEnvironment_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesFlow_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesFlow_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesIngestion_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PagesIngestion_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type PagesOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesOwner_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesOwner_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesPage_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type PagesPage_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesPage_Title_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesPage_Title_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesProduct_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type PagesProduct_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesProduct_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesProduct_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesProduct_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesProduct_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type PagesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PagesRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesSession_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesSession_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type PagesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesTest_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type PagesTest_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesTest_Path_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesTest_Path_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesUpdate_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PagesUpdate_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesUrl_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesUrl_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesUser_Agent_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type PagesUser_Agent_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesViewport_Height_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type PagesViewport_Height_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PagesViewport_Width_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type PagesViewport_Width_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for pages queries. */
export type PagesAndFilter = {
	/** Equals (FieldName: analysis_root_selector) */
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: analysis_root_selector) */
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: analysis_root_selector) */
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: canonical_url) */
	canonical_url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: canonical_url) */
	canonical_url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: canonical_url) */
	canonical_url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: canonical_url) */
	canonical_url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: canonical_url) */
	canonical_url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: canonical_url) */
	canonical_url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: client_version) */
	client_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: client_version) */
	client_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: client_version) */
	client_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: client_version) */
	client_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: client_version) */
	client_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: client_version) */
	client_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: domain) */
	domain_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: domain) */
	domain_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: domain) */
	domain_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: domain) */
	domain_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: domain) */
	domain_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: domain) */
	domain_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: engines_version) */
	engines_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: engines_version) */
	engines_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: engines_version) */
	engines_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: engines_version) */
	engines_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: engines_version) */
	engines_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: engines_version) */
	engines_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flow) */
	flow_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flow) */
	flow_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flow) */
	flow_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flow) */
	flow_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flow) */
	flow_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flow) */
	flow_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: ingestion_time) */
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: ingestion_time) */
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: ingestion_time) */
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: ingestion_time) */
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: ingestion_time) */
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: ingestion_time) */
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: ingestion_time) */
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<PagesOrFilter>>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: owner_type) */
	owner_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: owner_type) */
	owner_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: owner_type) */
	owner_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: owner_type) */
	owner_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: owner_type) */
	owner_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: owner_type) */
	owner_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: page_id) */
	page_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: page_id) */
	page_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: page_id) */
	page_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: page_id) */
	page_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: page_id) */
	page_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: page_id) */
	page_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_id) */
	product_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: product_id) */
	product_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: product_id) */
	product_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: product_id) */
	product_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: product_id) */
	product_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: product_id) */
	product_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_id) */
	test_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: test_id) */
	test_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: test_id) */
	test_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: test_id) */
	test_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: test_id) */
	test_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: test_id) */
	test_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<PagesSearchInsensitive>;
	text_ends_with?: InputMaybe<PagesSearchInsensitive>;
	text_equals?: InputMaybe<PagesSearchInsensitive>;
	text_regex_match?: InputMaybe<PagesSearch>;
	text_starts_with?: InputMaybe<PagesSearchInsensitive>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: url) */
	url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: url) */
	url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: url) */
	url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: url) */
	url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: url) */
	url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: url) */
	url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: user_agent) */
	user_agent_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_agent) */
	user_agent_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_agent) */
	user_agent_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_agent) */
	user_agent_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_agent) */
	user_agent_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_agent) */
	user_agent_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: viewport_height) */
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_height) */
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_height) */
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_height) */
	viewport_height_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_height) */
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_height) */
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: viewport_width) */
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_width) */
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_width) */
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_width) */
	viewport_width_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_width) */
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_width) */
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export enum PagesGroup {
	AnalysisRootSelector = 'analysis_root_selector',
	AnalysisRootSelectorAny = 'analysis_root_selector_any',
	AnalysisRootSelectorCount = 'analysis_root_selector_count',
	AnalysisRootSelectorGroupUniqArray = 'analysis_root_selector_group_uniq_array',
	AnalysisRootSelectorMax = 'analysis_root_selector_max',
	AnalysisRootSelectorMin = 'analysis_root_selector_min',
	CanonicalUrl = 'canonical_url',
	CanonicalUrlAny = 'canonical_url_any',
	CanonicalUrlCount = 'canonical_url_count',
	CanonicalUrlGroupUniqArray = 'canonical_url_group_uniq_array',
	CanonicalUrlMax = 'canonical_url_max',
	CanonicalUrlMin = 'canonical_url_min',
	ClientVersion = 'client_version',
	ClientVersionAny = 'client_version_any',
	ClientVersionCount = 'client_version_count',
	ClientVersionGroupUniqArray = 'client_version_group_uniq_array',
	ClientVersionMax = 'client_version_max',
	ClientVersionMin = 'client_version_min',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	Deleted = 'deleted',
	DetectionTypesAny = 'detection_types_any',
	Domain = 'domain',
	DomainAny = 'domain_any',
	DomainCount = 'domain_count',
	DomainGroupUniqArray = 'domain_group_uniq_array',
	DomainMax = 'domain_max',
	DomainMin = 'domain_min',
	EnginesVersion = 'engines_version',
	EnginesVersionAny = 'engines_version_any',
	EnginesVersionCount = 'engines_version_count',
	EnginesVersionGroupUniqArray = 'engines_version_group_uniq_array',
	EnginesVersionMax = 'engines_version_max',
	EnginesVersionMin = 'engines_version_min',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	FilteredCustomFields = 'filtered_custom_fields',
	Flow = 'flow',
	FlowAny = 'flow_any',
	FlowCount = 'flow_count',
	FlowGroupUniqArray = 'flow_group_uniq_array',
	FlowMax = 'flow_max',
	FlowMin = 'flow_min',
	IngestionTime = 'ingestion_time',
	IngestionTimeAny = 'ingestion_time_any',
	IngestionTimeCount = 'ingestion_time_count',
	IngestionTimeGroupUniqArray = 'ingestion_time_group_uniq_array',
	IngestionTimeMax = 'ingestion_time_max',
	IngestionTimeMin = 'ingestion_time_min',
	IngestionTimeTruncDay = 'ingestion_time_truncDay',
	IngestionTimeTruncMonth = 'ingestion_time_truncMonth',
	IngestionTimeTruncYear = 'ingestion_time_truncYear',
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	OwnerType = 'owner_type',
	OwnerTypeAny = 'owner_type_any',
	OwnerTypeCount = 'owner_type_count',
	OwnerTypeGroupUniqArray = 'owner_type_group_uniq_array',
	OwnerTypeMax = 'owner_type_max',
	OwnerTypeMin = 'owner_type_min',
	PageId = 'page_id',
	PageIdAny = 'page_id_any',
	PageIdCount = 'page_id_count',
	PageIdGroupUniqArray = 'page_id_group_uniq_array',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	ProductId = 'product_id',
	ProductIdAny = 'product_id_any',
	ProductIdCount = 'product_id_count',
	ProductIdGroupUniqArray = 'product_id_group_uniq_array',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestId = 'test_id',
	TestIdAny = 'test_id_any',
	TestIdCount = 'test_id_count',
	TestIdGroupUniqArray = 'test_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	Url = 'url',
	UrlAny = 'url_any',
	UrlCount = 'url_count',
	UrlGroupUniqArray = 'url_group_uniq_array',
	UrlMax = 'url_max',
	UrlMin = 'url_min',
	UserAgent = 'user_agent',
	UserAgentAny = 'user_agent_any',
	UserAgentCount = 'user_agent_count',
	UserAgentGroupUniqArray = 'user_agent_group_uniq_array',
	UserAgentMax = 'user_agent_max',
	UserAgentMin = 'user_agent_min',
	ViewportHeight = 'viewport_height',
	ViewportHeightAny = 'viewport_height_any',
	ViewportHeightCount = 'viewport_height_count',
	ViewportHeightGroupUniqArray = 'viewport_height_group_uniq_array',
	ViewportHeightMax = 'viewport_height_max',
	ViewportHeightMin = 'viewport_height_min',
	ViewportHeightSum = 'viewport_height_sum',
	ViewportWidth = 'viewport_width',
	ViewportWidthAny = 'viewport_width_any',
	ViewportWidthCount = 'viewport_width_count',
	ViewportWidthGroupUniqArray = 'viewport_width_group_uniq_array',
	ViewportWidthMax = 'viewport_width_max',
	ViewportWidthMin = 'viewport_width_min',
	ViewportWidthSum = 'viewport_width_sum'
}

/** Logical OR filter group for pages queries. */
export type PagesOrFilter = {
	/** Equals (FieldName: analysis_root_selector) */
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: analysis_root_selector) */
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: analysis_root_selector) */
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<PagesAndFilter>>;
	/** Equals (FieldName: canonical_url) */
	canonical_url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: canonical_url) */
	canonical_url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: canonical_url) */
	canonical_url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: canonical_url) */
	canonical_url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: canonical_url) */
	canonical_url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: canonical_url) */
	canonical_url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: client_version) */
	client_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: client_version) */
	client_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: client_version) */
	client_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: client_version) */
	client_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: client_version) */
	client_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: client_version) */
	client_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: domain) */
	domain_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: domain) */
	domain_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: domain) */
	domain_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: domain) */
	domain_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: domain) */
	domain_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: domain) */
	domain_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: engines_version) */
	engines_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: engines_version) */
	engines_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: engines_version) */
	engines_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: engines_version) */
	engines_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: engines_version) */
	engines_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: engines_version) */
	engines_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flow) */
	flow_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flow) */
	flow_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flow) */
	flow_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flow) */
	flow_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flow) */
	flow_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flow) */
	flow_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: ingestion_time) */
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: ingestion_time) */
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: ingestion_time) */
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: ingestion_time) */
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: ingestion_time) */
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: ingestion_time) */
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: ingestion_time) */
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: owner_type) */
	owner_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: owner_type) */
	owner_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: owner_type) */
	owner_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: owner_type) */
	owner_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: owner_type) */
	owner_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: owner_type) */
	owner_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: page_id) */
	page_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: page_id) */
	page_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: page_id) */
	page_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: page_id) */
	page_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: page_id) */
	page_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: page_id) */
	page_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_id) */
	product_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: product_id) */
	product_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: product_id) */
	product_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: product_id) */
	product_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: product_id) */
	product_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: product_id) */
	product_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_id) */
	test_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: test_id) */
	test_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: test_id) */
	test_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: test_id) */
	test_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: test_id) */
	test_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: test_id) */
	test_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<PagesSearchInsensitive>;
	text_ends_with?: InputMaybe<PagesSearchInsensitive>;
	text_equals?: InputMaybe<PagesSearchInsensitive>;
	text_regex_match?: InputMaybe<PagesSearch>;
	text_starts_with?: InputMaybe<PagesSearchInsensitive>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: url) */
	url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: url) */
	url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: url) */
	url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: url) */
	url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: url) */
	url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: url) */
	url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: user_agent) */
	user_agent_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_agent) */
	user_agent_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_agent) */
	user_agent_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_agent) */
	user_agent_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_agent) */
	user_agent_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_agent) */
	user_agent_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: viewport_height) */
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_height) */
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_height) */
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_height) */
	viewport_height_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_height) */
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_height) */
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: viewport_width) */
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_width) */
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_width) */
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_width) */
	viewport_width_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_width) */
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_width) */
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export type PagesSearch = {
	searchFields: Array<PagesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type PagesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<PagesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type PagesSort = {
	fields: Array<PagesSortFields>;
	order?: InputMaybe<PagesSortOrder>;
};

export enum PagesSortFields {
	AnalysisRootSelector = 'analysis_root_selector',
	AnalysisRootSelectorAny = 'analysis_root_selector_any',
	AnalysisRootSelectorCount = 'analysis_root_selector_count',
	AnalysisRootSelectorGroupUniqArray = 'analysis_root_selector_group_uniq_array',
	AnalysisRootSelectorMax = 'analysis_root_selector_max',
	AnalysisRootSelectorMin = 'analysis_root_selector_min',
	CanonicalUrl = 'canonical_url',
	CanonicalUrlAny = 'canonical_url_any',
	CanonicalUrlCount = 'canonical_url_count',
	CanonicalUrlGroupUniqArray = 'canonical_url_group_uniq_array',
	CanonicalUrlMax = 'canonical_url_max',
	CanonicalUrlMin = 'canonical_url_min',
	ClientVersion = 'client_version',
	ClientVersionAny = 'client_version_any',
	ClientVersionCount = 'client_version_count',
	ClientVersionGroupUniqArray = 'client_version_group_uniq_array',
	ClientVersionMax = 'client_version_max',
	ClientVersionMin = 'client_version_min',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	Deleted = 'deleted',
	DetectionTypesAny = 'detection_types_any',
	Domain = 'domain',
	DomainAny = 'domain_any',
	DomainCount = 'domain_count',
	DomainGroupUniqArray = 'domain_group_uniq_array',
	DomainMax = 'domain_max',
	DomainMin = 'domain_min',
	EnginesVersion = 'engines_version',
	EnginesVersionAny = 'engines_version_any',
	EnginesVersionCount = 'engines_version_count',
	EnginesVersionGroupUniqArray = 'engines_version_group_uniq_array',
	EnginesVersionMax = 'engines_version_max',
	EnginesVersionMin = 'engines_version_min',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	FilteredCustomFields = 'filtered_custom_fields',
	Flow = 'flow',
	FlowAny = 'flow_any',
	FlowCount = 'flow_count',
	FlowGroupUniqArray = 'flow_group_uniq_array',
	FlowMax = 'flow_max',
	FlowMin = 'flow_min',
	IngestionTime = 'ingestion_time',
	IngestionTimeAny = 'ingestion_time_any',
	IngestionTimeCount = 'ingestion_time_count',
	IngestionTimeGroupUniqArray = 'ingestion_time_group_uniq_array',
	IngestionTimeMax = 'ingestion_time_max',
	IngestionTimeMin = 'ingestion_time_min',
	IngestionTimeTruncDay = 'ingestion_time_truncDay',
	IngestionTimeTruncMonth = 'ingestion_time_truncMonth',
	IngestionTimeTruncYear = 'ingestion_time_truncYear',
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	OwnerType = 'owner_type',
	OwnerTypeAny = 'owner_type_any',
	OwnerTypeCount = 'owner_type_count',
	OwnerTypeGroupUniqArray = 'owner_type_group_uniq_array',
	OwnerTypeMax = 'owner_type_max',
	OwnerTypeMin = 'owner_type_min',
	PageId = 'page_id',
	PageIdAny = 'page_id_any',
	PageIdCount = 'page_id_count',
	PageIdGroupUniqArray = 'page_id_group_uniq_array',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	ProductId = 'product_id',
	ProductIdAny = 'product_id_any',
	ProductIdCount = 'product_id_count',
	ProductIdGroupUniqArray = 'product_id_group_uniq_array',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestId = 'test_id',
	TestIdAny = 'test_id_any',
	TestIdCount = 'test_id_count',
	TestIdGroupUniqArray = 'test_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	Url = 'url',
	UrlAny = 'url_any',
	UrlCount = 'url_count',
	UrlGroupUniqArray = 'url_group_uniq_array',
	UrlMax = 'url_max',
	UrlMin = 'url_min',
	UserAgent = 'user_agent',
	UserAgentAny = 'user_agent_any',
	UserAgentCount = 'user_agent_count',
	UserAgentGroupUniqArray = 'user_agent_group_uniq_array',
	UserAgentMax = 'user_agent_max',
	UserAgentMin = 'user_agent_min',
	ViewportHeight = 'viewport_height',
	ViewportHeightAny = 'viewport_height_any',
	ViewportHeightCount = 'viewport_height_count',
	ViewportHeightGroupUniqArray = 'viewport_height_group_uniq_array',
	ViewportHeightMax = 'viewport_height_max',
	ViewportHeightMin = 'viewport_height_min',
	ViewportHeightSum = 'viewport_height_sum',
	ViewportWidth = 'viewport_width',
	ViewportWidthAny = 'viewport_width_any',
	ViewportWidthCount = 'viewport_width_count',
	ViewportWidthGroupUniqArray = 'viewport_width_group_uniq_array',
	ViewportWidthMax = 'viewport_width_max',
	ViewportWidthMin = 'viewport_width_min',
	ViewportWidthSum = 'viewport_width_sum'
}

/** An example enum type */
export enum PagesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum PagesTextSearchFields {
	AnalysisRootSelector = 'analysis_root_selector',
	CanonicalUrl = 'canonical_url',
	ClientVersion = 'client_version',
	CustomFields = 'custom_fields',
	Deleted = 'deleted',
	DetectionTypes = 'detection_types',
	Domain = 'domain',
	EnginesVersion = 'engines_version',
	Environment = 'environment',
	FilteredCustomFields = 'filtered_custom_fields',
	Flow = 'flow',
	IngestionTime = 'ingestion_time',
	OwnerId = 'owner_id',
	OwnerType = 'owner_type',
	PageId = 'page_id',
	PageTitle = 'page_title',
	ProductId = 'product_id',
	ProductName = 'product_name',
	ProductVersion = 'product_version',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	SessionName = 'session_name',
	TenantId = 'tenant_id',
	TestId = 'test_id',
	TestName = 'test_name',
	TestPath = 'test_path',
	UpdateTime = 'update_time',
	Url = 'url',
	UserAgent = 'user_agent',
	ViewportHeight = 'viewport_height',
	ViewportWidth = 'viewport_width'
}

export type Scans = {
	__typename?: 'scans';
	/** app name */
	app: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_any: Scalars['String']['output'];
	/** app build number */
	app_build_number: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_build_number_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_build_number_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_build_number_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** app identifier */
	app_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_id_min: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_min: Scalars['String']['output'];
	/** app version */
	app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	app_version_min: Scalars['String']['output'];
	/** companion app version */
	companion_app_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	companion_app_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	companion_app_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	companion_app_version_min: Scalars['String']['output'];
	/** Timestamp of when the scan was created */
	created_at: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	created_at_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	created_at_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	created_at_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	created_at_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** custom fields as key-value pairs */
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** indicates that record has been mark for delete - soft delete */
	deleted: Scalars['Boolean']['output'];
	/** device manufacturer */
	device_manufacturer: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_manufacturer_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_manufacturer_min: Scalars['String']['output'];
	/** device model */
	device_model: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_model_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_model_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_model_min: Scalars['String']['output'];
	/** device personalized name */
	device_personalized_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_personalized_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_personalized_name_min: Scalars['String']['output'];
	/** device type */
	device_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	device_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	device_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	device_type_min: Scalars['String']['output'];
	/** semantic engines version used */
	engines_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	engines_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	engines_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	engines_version_min: Scalars['String']['output'];
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	/** time of scan ingestion */
	ingestion_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	ingestion_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	ingestion_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** indicates if mobile kit was used */
	mobile_kit: Scalars['Boolean']['output'];
	/** operating system */
	os: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_min: Scalars['String']['output'];
	/** operating system version */
	os_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	os_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	os_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	os_version_min: Scalars['String']['output'];
	/** user/service account running the analysis */
	owner_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** user / service account */
	owner_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	owner_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	owner_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	owner_type_min: Scalars['String']['output'];
	/** product identifier */
	product_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	product_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	product_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** product name */
	product_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_min: Scalars['String']['output'];
	/** internal product version */
	product_version: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_version_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_version_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_version_min: Scalars['String']['output'];
	/** list of properties calculated during ingestion/update */
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	/** run identifier - represent a single group of scans */
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** time of run start on client side */
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** scan identifier */
	scan_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	scan_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** scan name as sent by mfa */
	scan_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	scan_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	scan_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	scan_name_min: Scalars['String']['output'];
	/** type of SDK used */
	sdk_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	sdk_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	sdk_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	sdk_type_min: Scalars['String']['output'];
	/** session name - used to differentiate between sessions */
	session_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	session_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	session_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_min: Scalars['String']['output'];
	/** tenant identifier */
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** test case name */
	test_case: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_case_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_case_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_case_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_case_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_case_min: Scalars['String']['output'];
	/** test method name */
	test_method: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_method_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_method_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_method_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_method_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_method_min: Scalars['String']['output'];
	/** test name as sent by the sdk */
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	/** full test path - as populated by the sdk */
	test_path: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_path_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_path_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_min: Scalars['String']['output'];
	/** test suite name */
	test_suite: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_suite_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_suite_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_suite_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_suite_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_suite_min: Scalars['String']['output'];
	/** unique identifier for the test */
	test_unique_identifier: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_unique_identifier_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_unique_identifier_min: Scalars['String']['output'];
	/** time of last update */
	update_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	update_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	update_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** height - view port extracted during the run */
	viewport_height: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	viewport_height_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	viewport_height_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_height_sum: Scalars['Int']['output'];
	/** width - view port extracted during the run */
	viewport_width: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	viewport_width_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	viewport_width_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	viewport_width_sum: Scalars['Int']['output'];
};

export type ScansApp_Build_Number_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansApp_Build_Number_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansApp_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansApp_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansApp_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansApp_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansApp_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansApp_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansCompanion_App_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansCompanion_App_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansCreated_At_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScansCreated_At_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansDevice_Manufacturer_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansDevice_Manufacturer_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansDevice_Model_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansDevice_Model_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansDevice_Personalized_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansDevice_Personalized_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansDevice_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansDevice_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansEngines_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansEngines_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansIngestion_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScansIngestion_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansOs_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansOs_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansOs_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansOs_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansOwner_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type ScansOwner_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansOwner_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansOwner_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansProduct_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type ScansProduct_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansProduct_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansProduct_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansProduct_Version_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansProduct_Version_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type ScansRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScansRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansScan_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type ScansScan_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansScan_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansScan_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansSdk_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansSdk_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansSession_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansSession_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type ScansTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansTest_Case_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansTest_Case_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansTest_Method_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansTest_Method_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansTest_Path_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansTest_Path_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansTest_Suite_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansTest_Suite_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansTest_Unique_Identifier_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type ScansTest_Unique_Identifier_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansUpdate_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScansUpdate_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansViewport_Height_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type ScansViewport_Height_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScansViewport_Width_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type ScansViewport_Width_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for scans queries. */
export type ScansAndFilter = {
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: created_at) */
	created_at_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: created_at) */
	created_at_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: created_at) */
	created_at_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: created_at) */
	created_at_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: created_at) */
	created_at_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: created_at) */
	created_at_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: created_at) */
	created_at_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: engines_version) */
	engines_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: engines_version) */
	engines_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: engines_version) */
	engines_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: engines_version) */
	engines_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: engines_version) */
	engines_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: engines_version) */
	engines_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: ingestion_time) */
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: ingestion_time) */
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: ingestion_time) */
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: ingestion_time) */
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: ingestion_time) */
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: ingestion_time) */
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: ingestion_time) */
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionBoolean>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<ScansOrFilter>>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: owner_type) */
	owner_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: owner_type) */
	owner_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: owner_type) */
	owner_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: owner_type) */
	owner_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: owner_type) */
	owner_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: owner_type) */
	owner_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_id) */
	product_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: product_id) */
	product_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: product_id) */
	product_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: product_id) */
	product_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: product_id) */
	product_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: product_id) */
	product_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: scan_name) */
	scan_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: scan_name) */
	scan_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: scan_name) */
	scan_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: scan_name) */
	scan_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: scan_name) */
	scan_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: scan_name) */
	scan_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_case) */
	test_case_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_case) */
	test_case_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_case) */
	test_case_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_case) */
	test_case_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_case) */
	test_case_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_case) */
	test_case_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_method) */
	test_method_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_method) */
	test_method_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_method) */
	test_method_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_method) */
	test_method_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_method) */
	test_method_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_method) */
	test_method_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_suite) */
	test_suite_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_suite) */
	test_suite_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_suite) */
	test_suite_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_suite) */
	test_suite_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_suite) */
	test_suite_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_suite) */
	test_suite_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_unique_identifier) */
	test_unique_identifier_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_unique_identifier) */
	test_unique_identifier_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_unique_identifier) */
	test_unique_identifier_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<ScansSearchInsensitive>;
	text_equals?: InputMaybe<ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<ScansSearch>;
	text_starts_with?: InputMaybe<ScansSearchInsensitive>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: viewport_height) */
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_height) */
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_height) */
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_height) */
	viewport_height_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_height) */
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_height) */
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: viewport_width) */
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_width) */
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_width) */
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_width) */
	viewport_width_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_width) */
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_width) */
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export enum ScansGroup {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CreatedAt = 'created_at',
	CreatedAtAny = 'created_at_any',
	CreatedAtCount = 'created_at_count',
	CreatedAtGroupUniqArray = 'created_at_group_uniq_array',
	CreatedAtMax = 'created_at_max',
	CreatedAtMin = 'created_at_min',
	CreatedAtTruncDay = 'created_at_truncDay',
	CreatedAtTruncMonth = 'created_at_truncMonth',
	CreatedAtTruncYear = 'created_at_truncYear',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	Deleted = 'deleted',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	EnginesVersion = 'engines_version',
	EnginesVersionAny = 'engines_version_any',
	EnginesVersionCount = 'engines_version_count',
	EnginesVersionGroupUniqArray = 'engines_version_group_uniq_array',
	EnginesVersionMax = 'engines_version_max',
	EnginesVersionMin = 'engines_version_min',
	FilteredCustomFields = 'filtered_custom_fields',
	IngestionTime = 'ingestion_time',
	IngestionTimeAny = 'ingestion_time_any',
	IngestionTimeCount = 'ingestion_time_count',
	IngestionTimeGroupUniqArray = 'ingestion_time_group_uniq_array',
	IngestionTimeMax = 'ingestion_time_max',
	IngestionTimeMin = 'ingestion_time_min',
	IngestionTimeTruncDay = 'ingestion_time_truncDay',
	IngestionTimeTruncMonth = 'ingestion_time_truncMonth',
	IngestionTimeTruncYear = 'ingestion_time_truncYear',
	MobileKit = 'mobile_kit',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	OwnerType = 'owner_type',
	OwnerTypeAny = 'owner_type_any',
	OwnerTypeCount = 'owner_type_count',
	OwnerTypeGroupUniqArray = 'owner_type_group_uniq_array',
	OwnerTypeMax = 'owner_type_max',
	OwnerTypeMin = 'owner_type_min',
	ProductId = 'product_id',
	ProductIdAny = 'product_id_any',
	ProductIdCount = 'product_id_count',
	ProductIdGroupUniqArray = 'product_id_group_uniq_array',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	ScanName = 'scan_name',
	ScanNameAny = 'scan_name_any',
	ScanNameCount = 'scan_name_count',
	ScanNameGroupUniqArray = 'scan_name_group_uniq_array',
	ScanNameMax = 'scan_name_max',
	ScanNameMin = 'scan_name_min',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestCase = 'test_case',
	TestCaseAny = 'test_case_any',
	TestCaseCount = 'test_case_count',
	TestCaseGroupUniqArray = 'test_case_group_uniq_array',
	TestCaseMax = 'test_case_max',
	TestCaseMin = 'test_case_min',
	TestMethod = 'test_method',
	TestMethodAny = 'test_method_any',
	TestMethodCount = 'test_method_count',
	TestMethodGroupUniqArray = 'test_method_group_uniq_array',
	TestMethodMax = 'test_method_max',
	TestMethodMin = 'test_method_min',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TestSuite = 'test_suite',
	TestSuiteAny = 'test_suite_any',
	TestSuiteCount = 'test_suite_count',
	TestSuiteGroupUniqArray = 'test_suite_group_uniq_array',
	TestSuiteMax = 'test_suite_max',
	TestSuiteMin = 'test_suite_min',
	TestUniqueIdentifier = 'test_unique_identifier',
	TestUniqueIdentifierAny = 'test_unique_identifier_any',
	TestUniqueIdentifierCount = 'test_unique_identifier_count',
	TestUniqueIdentifierGroupUniqArray = 'test_unique_identifier_group_uniq_array',
	TestUniqueIdentifierMax = 'test_unique_identifier_max',
	TestUniqueIdentifierMin = 'test_unique_identifier_min',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	ViewportHeight = 'viewport_height',
	ViewportHeightAny = 'viewport_height_any',
	ViewportHeightCount = 'viewport_height_count',
	ViewportHeightGroupUniqArray = 'viewport_height_group_uniq_array',
	ViewportHeightMax = 'viewport_height_max',
	ViewportHeightMin = 'viewport_height_min',
	ViewportHeightSum = 'viewport_height_sum',
	ViewportWidth = 'viewport_width',
	ViewportWidthAny = 'viewport_width_any',
	ViewportWidthCount = 'viewport_width_count',
	ViewportWidthGroupUniqArray = 'viewport_width_group_uniq_array',
	ViewportWidthMax = 'viewport_width_max',
	ViewportWidthMin = 'viewport_width_min',
	ViewportWidthSum = 'viewport_width_sum'
}

/** Logical OR filter group for scans queries. */
export type ScansOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<ScansAndFilter>>;
	/** Equals (FieldName: app_build_number) */
	app_build_number_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_build_number) */
	app_build_number_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_build_number) */
	app_build_number_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_build_number) */
	app_build_number_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_build_number) */
	app_build_number_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_build_number) */
	app_build_number_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app) */
	app_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app) */
	app_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app) */
	app_gt?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_id) */
	app_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_id) */
	app_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_id) */
	app_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_id) */
	app_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_id) */
	app_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_id) */
	app_id_ne?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app) */
	app_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app) */
	app_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app) */
	app_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: app_version) */
	app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: app_version) */
	app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: app_version) */
	app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: app_version) */
	app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: app_version) */
	app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: app_version) */
	app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: companion_app_version) */
	companion_app_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: companion_app_version) */
	companion_app_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: companion_app_version) */
	companion_app_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: companion_app_version) */
	companion_app_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: companion_app_version) */
	companion_app_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: companion_app_version) */
	companion_app_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: created_at) */
	created_at_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: created_at) */
	created_at_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: created_at) */
	created_at_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: created_at) */
	created_at_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: created_at) */
	created_at_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: created_at) */
	created_at_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: created_at) */
	created_at_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: deleted) */
	deleted_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: deleted) */
	deleted_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: deleted) */
	deleted_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: deleted) */
	deleted_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: deleted) */
	deleted_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: deleted) */
	deleted_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: device_manufacturer) */
	device_manufacturer_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_manufacturer) */
	device_manufacturer_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_manufacturer) */
	device_manufacturer_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_manufacturer) */
	device_manufacturer_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_manufacturer) */
	device_manufacturer_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_manufacturer) */
	device_manufacturer_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_model) */
	device_model_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_model) */
	device_model_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_model) */
	device_model_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_model) */
	device_model_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_model) */
	device_model_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_model) */
	device_model_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_personalized_name) */
	device_personalized_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_personalized_name) */
	device_personalized_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_personalized_name) */
	device_personalized_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_personalized_name) */
	device_personalized_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_personalized_name) */
	device_personalized_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_personalized_name) */
	device_personalized_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: device_type) */
	device_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: device_type) */
	device_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: device_type) */
	device_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: device_type) */
	device_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: device_type) */
	device_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: device_type) */
	device_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: engines_version) */
	engines_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: engines_version) */
	engines_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: engines_version) */
	engines_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: engines_version) */
	engines_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: engines_version) */
	engines_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: engines_version) */
	engines_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: ingestion_time) */
	ingestion_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: ingestion_time) */
	ingestion_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: ingestion_time) */
	ingestion_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: ingestion_time) */
	ingestion_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: ingestion_time) */
	ingestion_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: ingestion_time) */
	ingestion_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: ingestion_time) */
	ingestion_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: mobile_kit) */
	mobile_kit_eq?: InputMaybe<ConditionBoolean>;
	/** Greater than or equals (FieldName: mobile_kit) */
	mobile_kit_ge?: InputMaybe<ConditionBoolean>;
	/** Greater than (FieldName: mobile_kit) */
	mobile_kit_gt?: InputMaybe<ConditionBoolean>;
	/** Less than or equals (FieldName: mobile_kit) */
	mobile_kit_le?: InputMaybe<ConditionBoolean>;
	/** Less than (FieldName: mobile_kit) */
	mobile_kit_lt?: InputMaybe<ConditionBoolean>;
	/** Not equals (FieldName: mobile_kit) */
	mobile_kit_ne?: InputMaybe<ConditionBoolean>;
	/** Equals (FieldName: os) */
	os_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os) */
	os_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os) */
	os_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os) */
	os_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os) */
	os_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os) */
	os_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: os_version) */
	os_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: os_version) */
	os_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: os_version) */
	os_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: os_version) */
	os_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: os_version) */
	os_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: os_version) */
	os_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: owner_id) */
	owner_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: owner_id) */
	owner_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: owner_id) */
	owner_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: owner_id) */
	owner_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: owner_id) */
	owner_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: owner_id) */
	owner_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: owner_type) */
	owner_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: owner_type) */
	owner_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: owner_type) */
	owner_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: owner_type) */
	owner_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: owner_type) */
	owner_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: owner_type) */
	owner_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_id) */
	product_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: product_id) */
	product_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: product_id) */
	product_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: product_id) */
	product_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: product_id) */
	product_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: product_id) */
	product_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_version) */
	product_version_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_version) */
	product_version_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_version) */
	product_version_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_version) */
	product_version_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_version) */
	product_version_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_version) */
	product_version_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: scan_id) */
	scan_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: scan_id) */
	scan_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: scan_id) */
	scan_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: scan_id) */
	scan_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: scan_id) */
	scan_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: scan_id) */
	scan_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: scan_name) */
	scan_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: scan_name) */
	scan_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: scan_name) */
	scan_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: scan_name) */
	scan_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: scan_name) */
	scan_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: scan_name) */
	scan_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: sdk_type) */
	sdk_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: sdk_type) */
	sdk_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: sdk_type) */
	sdk_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: sdk_type) */
	sdk_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: sdk_type) */
	sdk_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: sdk_type) */
	sdk_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_case) */
	test_case_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_case) */
	test_case_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_case) */
	test_case_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_case) */
	test_case_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_case) */
	test_case_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_case) */
	test_case_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_method) */
	test_method_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_method) */
	test_method_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_method) */
	test_method_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_method) */
	test_method_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_method) */
	test_method_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_method) */
	test_method_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_suite) */
	test_suite_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_suite) */
	test_suite_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_suite) */
	test_suite_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_suite) */
	test_suite_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_suite) */
	test_suite_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_suite) */
	test_suite_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_unique_identifier) */
	test_unique_identifier_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_unique_identifier) */
	test_unique_identifier_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_unique_identifier) */
	test_unique_identifier_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_unique_identifier) */
	test_unique_identifier_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_unique_identifier) */
	test_unique_identifier_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<ScansSearchInsensitive>;
	text_ends_with?: InputMaybe<ScansSearchInsensitive>;
	text_equals?: InputMaybe<ScansSearchInsensitive>;
	text_regex_match?: InputMaybe<ScansSearch>;
	text_starts_with?: InputMaybe<ScansSearchInsensitive>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: viewport_height) */
	viewport_height_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_height) */
	viewport_height_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_height) */
	viewport_height_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_height) */
	viewport_height_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_height) */
	viewport_height_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_height) */
	viewport_height_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: viewport_width) */
	viewport_width_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: viewport_width) */
	viewport_width_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: viewport_width) */
	viewport_width_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: viewport_width) */
	viewport_width_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: viewport_width) */
	viewport_width_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: viewport_width) */
	viewport_width_ne?: InputMaybe<ConditionFloat>;
};

export type ScansSearch = {
	searchFields: Array<ScansTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type ScansSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<ScansTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type ScansSort = {
	fields: Array<ScansSortFields>;
	order?: InputMaybe<ScansSortOrder>;
};

export enum ScansSortFields {
	App = 'app',
	AppAny = 'app_any',
	AppBuildNumber = 'app_build_number',
	AppBuildNumberAny = 'app_build_number_any',
	AppBuildNumberCount = 'app_build_number_count',
	AppBuildNumberGroupUniqArray = 'app_build_number_group_uniq_array',
	AppBuildNumberMax = 'app_build_number_max',
	AppBuildNumberMin = 'app_build_number_min',
	AppCount = 'app_count',
	AppGroupUniqArray = 'app_group_uniq_array',
	AppId = 'app_id',
	AppIdAny = 'app_id_any',
	AppIdCount = 'app_id_count',
	AppIdGroupUniqArray = 'app_id_group_uniq_array',
	AppIdMax = 'app_id_max',
	AppIdMin = 'app_id_min',
	AppMax = 'app_max',
	AppMin = 'app_min',
	AppVersion = 'app_version',
	AppVersionAny = 'app_version_any',
	AppVersionCount = 'app_version_count',
	AppVersionGroupUniqArray = 'app_version_group_uniq_array',
	AppVersionMax = 'app_version_max',
	AppVersionMin = 'app_version_min',
	CompanionAppVersion = 'companion_app_version',
	CompanionAppVersionAny = 'companion_app_version_any',
	CompanionAppVersionCount = 'companion_app_version_count',
	CompanionAppVersionGroupUniqArray = 'companion_app_version_group_uniq_array',
	CompanionAppVersionMax = 'companion_app_version_max',
	CompanionAppVersionMin = 'companion_app_version_min',
	CreatedAt = 'created_at',
	CreatedAtAny = 'created_at_any',
	CreatedAtCount = 'created_at_count',
	CreatedAtGroupUniqArray = 'created_at_group_uniq_array',
	CreatedAtMax = 'created_at_max',
	CreatedAtMin = 'created_at_min',
	CreatedAtTruncDay = 'created_at_truncDay',
	CreatedAtTruncMonth = 'created_at_truncMonth',
	CreatedAtTruncYear = 'created_at_truncYear',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	Deleted = 'deleted',
	DeviceManufacturer = 'device_manufacturer',
	DeviceManufacturerAny = 'device_manufacturer_any',
	DeviceManufacturerCount = 'device_manufacturer_count',
	DeviceManufacturerGroupUniqArray = 'device_manufacturer_group_uniq_array',
	DeviceManufacturerMax = 'device_manufacturer_max',
	DeviceManufacturerMin = 'device_manufacturer_min',
	DeviceModel = 'device_model',
	DeviceModelAny = 'device_model_any',
	DeviceModelCount = 'device_model_count',
	DeviceModelGroupUniqArray = 'device_model_group_uniq_array',
	DeviceModelMax = 'device_model_max',
	DeviceModelMin = 'device_model_min',
	DevicePersonalizedName = 'device_personalized_name',
	DevicePersonalizedNameAny = 'device_personalized_name_any',
	DevicePersonalizedNameCount = 'device_personalized_name_count',
	DevicePersonalizedNameGroupUniqArray = 'device_personalized_name_group_uniq_array',
	DevicePersonalizedNameMax = 'device_personalized_name_max',
	DevicePersonalizedNameMin = 'device_personalized_name_min',
	DeviceType = 'device_type',
	DeviceTypeAny = 'device_type_any',
	DeviceTypeCount = 'device_type_count',
	DeviceTypeGroupUniqArray = 'device_type_group_uniq_array',
	DeviceTypeMax = 'device_type_max',
	DeviceTypeMin = 'device_type_min',
	EnginesVersion = 'engines_version',
	EnginesVersionAny = 'engines_version_any',
	EnginesVersionCount = 'engines_version_count',
	EnginesVersionGroupUniqArray = 'engines_version_group_uniq_array',
	EnginesVersionMax = 'engines_version_max',
	EnginesVersionMin = 'engines_version_min',
	FilteredCustomFields = 'filtered_custom_fields',
	IngestionTime = 'ingestion_time',
	IngestionTimeAny = 'ingestion_time_any',
	IngestionTimeCount = 'ingestion_time_count',
	IngestionTimeGroupUniqArray = 'ingestion_time_group_uniq_array',
	IngestionTimeMax = 'ingestion_time_max',
	IngestionTimeMin = 'ingestion_time_min',
	IngestionTimeTruncDay = 'ingestion_time_truncDay',
	IngestionTimeTruncMonth = 'ingestion_time_truncMonth',
	IngestionTimeTruncYear = 'ingestion_time_truncYear',
	MobileKit = 'mobile_kit',
	Os = 'os',
	OsAny = 'os_any',
	OsCount = 'os_count',
	OsGroupUniqArray = 'os_group_uniq_array',
	OsMax = 'os_max',
	OsMin = 'os_min',
	OsVersion = 'os_version',
	OsVersionAny = 'os_version_any',
	OsVersionCount = 'os_version_count',
	OsVersionGroupUniqArray = 'os_version_group_uniq_array',
	OsVersionMax = 'os_version_max',
	OsVersionMin = 'os_version_min',
	OwnerId = 'owner_id',
	OwnerIdAny = 'owner_id_any',
	OwnerIdCount = 'owner_id_count',
	OwnerIdGroupUniqArray = 'owner_id_group_uniq_array',
	OwnerType = 'owner_type',
	OwnerTypeAny = 'owner_type_any',
	OwnerTypeCount = 'owner_type_count',
	OwnerTypeGroupUniqArray = 'owner_type_group_uniq_array',
	OwnerTypeMax = 'owner_type_max',
	OwnerTypeMin = 'owner_type_min',
	ProductId = 'product_id',
	ProductIdAny = 'product_id_any',
	ProductIdCount = 'product_id_count',
	ProductIdGroupUniqArray = 'product_id_group_uniq_array',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	ProductVersion = 'product_version',
	ProductVersionAny = 'product_version_any',
	ProductVersionCount = 'product_version_count',
	ProductVersionGroupUniqArray = 'product_version_group_uniq_array',
	ProductVersionMax = 'product_version_max',
	ProductVersionMin = 'product_version_min',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	ScanId = 'scan_id',
	ScanIdAny = 'scan_id_any',
	ScanIdCount = 'scan_id_count',
	ScanIdGroupUniqArray = 'scan_id_group_uniq_array',
	ScanName = 'scan_name',
	ScanNameAny = 'scan_name_any',
	ScanNameCount = 'scan_name_count',
	ScanNameGroupUniqArray = 'scan_name_group_uniq_array',
	ScanNameMax = 'scan_name_max',
	ScanNameMin = 'scan_name_min',
	SdkType = 'sdk_type',
	SdkTypeAny = 'sdk_type_any',
	SdkTypeCount = 'sdk_type_count',
	SdkTypeGroupUniqArray = 'sdk_type_group_uniq_array',
	SdkTypeMax = 'sdk_type_max',
	SdkTypeMin = 'sdk_type_min',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestCase = 'test_case',
	TestCaseAny = 'test_case_any',
	TestCaseCount = 'test_case_count',
	TestCaseGroupUniqArray = 'test_case_group_uniq_array',
	TestCaseMax = 'test_case_max',
	TestCaseMin = 'test_case_min',
	TestMethod = 'test_method',
	TestMethodAny = 'test_method_any',
	TestMethodCount = 'test_method_count',
	TestMethodGroupUniqArray = 'test_method_group_uniq_array',
	TestMethodMax = 'test_method_max',
	TestMethodMin = 'test_method_min',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TestSuite = 'test_suite',
	TestSuiteAny = 'test_suite_any',
	TestSuiteCount = 'test_suite_count',
	TestSuiteGroupUniqArray = 'test_suite_group_uniq_array',
	TestSuiteMax = 'test_suite_max',
	TestSuiteMin = 'test_suite_min',
	TestUniqueIdentifier = 'test_unique_identifier',
	TestUniqueIdentifierAny = 'test_unique_identifier_any',
	TestUniqueIdentifierCount = 'test_unique_identifier_count',
	TestUniqueIdentifierGroupUniqArray = 'test_unique_identifier_group_uniq_array',
	TestUniqueIdentifierMax = 'test_unique_identifier_max',
	TestUniqueIdentifierMin = 'test_unique_identifier_min',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	ViewportHeight = 'viewport_height',
	ViewportHeightAny = 'viewport_height_any',
	ViewportHeightCount = 'viewport_height_count',
	ViewportHeightGroupUniqArray = 'viewport_height_group_uniq_array',
	ViewportHeightMax = 'viewport_height_max',
	ViewportHeightMin = 'viewport_height_min',
	ViewportHeightSum = 'viewport_height_sum',
	ViewportWidth = 'viewport_width',
	ViewportWidthAny = 'viewport_width_any',
	ViewportWidthCount = 'viewport_width_count',
	ViewportWidthGroupUniqArray = 'viewport_width_group_uniq_array',
	ViewportWidthMax = 'viewport_width_max',
	ViewportWidthMin = 'viewport_width_min',
	ViewportWidthSum = 'viewport_width_sum'
}

/** An example enum type */
export enum ScansSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum ScansTextSearchFields {
	App = 'app',
	AppBuildNumber = 'app_build_number',
	AppId = 'app_id',
	AppVersion = 'app_version',
	CompanionAppVersion = 'companion_app_version',
	CreatedAt = 'created_at',
	CustomFields = 'custom_fields',
	Deleted = 'deleted',
	DeviceManufacturer = 'device_manufacturer',
	DeviceModel = 'device_model',
	DevicePersonalizedName = 'device_personalized_name',
	DeviceType = 'device_type',
	EnginesVersion = 'engines_version',
	FilteredCustomFields = 'filtered_custom_fields',
	IngestionTime = 'ingestion_time',
	MobileKit = 'mobile_kit',
	Os = 'os',
	OsVersion = 'os_version',
	OwnerId = 'owner_id',
	OwnerType = 'owner_type',
	ProductId = 'product_id',
	ProductName = 'product_name',
	ProductVersion = 'product_version',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	ScanId = 'scan_id',
	ScanName = 'scan_name',
	SdkType = 'sdk_type',
	SessionName = 'session_name',
	TenantId = 'tenant_id',
	TestCase = 'test_case',
	TestMethod = 'test_method',
	TestName = 'test_name',
	TestPath = 'test_path',
	TestSuite = 'test_suite',
	TestUniqueIdentifier = 'test_unique_identifier',
	UpdateTime = 'update_time',
	ViewportHeight = 'viewport_height',
	ViewportWidth = 'viewport_width'
}

export type Score_Web_Products = {
	__typename?: 'score_web_products';
	/** Date when score was calculated */
	calculation_date: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	calculation_date_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	calculation_date_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	calculation_date_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	calculation_date_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	calculation_date_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	calculation_date_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	calculation_date_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	calculation_date_truncYear?: Maybe<Scalars['DateTime']['output']>;
	created_at: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	created_at_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	created_at_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	created_at_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	created_at_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	created_at_truncYear?: Maybe<Scalars['DateTime']['output']>;
	/** Environment */
	environment: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	environment_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	environment_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_min: Scalars['String']['output'];
	/** Calculated accessibility score */
	score: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	score_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	score_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	score_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	score_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	score_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	score_sum: Scalars['Int']['output'];
	/** Tenant identifier */
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	/** Lookback period */
	timeframe_days: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	timeframe_days_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	timeframe_days_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	timeframe_days_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	timeframe_days_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	timeframe_days_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	timeframe_days_sum: Scalars['Int']['output'];
	/** Total issues (non-unique) */
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** Total critical issues (non-unique) */
	total_issues_critical: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_critical_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_critical_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_critical_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_critical_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_critical_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_critical_sum: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** Total serious issues (non-unique) */
	total_issues_serious: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_serious_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_serious_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_serious_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_serious_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_serious_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_serious_sum: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	/** Count of de-duplicated issues */
	unique_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_count: Scalars['Int']['output'];
	/** Count of de-duplicated critical issues */
	unique_issues_critical: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_critical_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_critical_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	unique_issues_critical_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	unique_issues_critical_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_critical_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_critical_sum: Scalars['Int']['output'];
	/** group unique array aggregate function */
	unique_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	unique_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_min: Scalars['Int']['output'];
	/** Count of de-duplicated serious issues */
	unique_issues_serious: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_serious_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_serious_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	unique_issues_serious_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	unique_issues_serious_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_serious_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_serious_sum: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	unique_issues_sum: Scalars['Int']['output'];
	/** Business unit */
	unit_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	unit_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	unit_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	unit_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	unit_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	unit_id_min: Scalars['String']['output'];
};

export type Score_Web_ProductsCalculation_Date_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Score_Web_ProductsCalculation_Date_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsCreated_At_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Score_Web_ProductsCreated_At_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsEnvironment_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Score_Web_ProductsEnvironment_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsScore_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type Score_Web_ProductsScore_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Score_Web_ProductsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTimeframe_Days_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTimeframe_Days_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTotal_Issues_Critical_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTotal_Issues_Critical_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTotal_Issues_Serious_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsTotal_Issues_Serious_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsUnique_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsUnique_Issues_Critical_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsUnique_Issues_Critical_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsUnique_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsUnique_Issues_Serious_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsUnique_Issues_Serious_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Score_Web_ProductsUnit_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Score_Web_ProductsUnit_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for score_web_products queries. */
export type Score_Web_ProductsAndFilter = {
	/** Equals (FieldName: calculation_date) */
	calculation_date_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: calculation_date) */
	calculation_date_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: calculation_date) */
	calculation_date_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: calculation_date) */
	calculation_date_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: calculation_date) */
	calculation_date_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: calculation_date) */
	calculation_date_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: calculation_date) */
	calculation_date_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: created_at) */
	created_at_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: created_at) */
	created_at_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: created_at) */
	created_at_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: created_at) */
	created_at_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: created_at) */
	created_at_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: created_at) */
	created_at_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: created_at) */
	created_at_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Score_Web_ProductsOrFilter>>;
	/** Equals (FieldName: score) */
	score_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: score) */
	score_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: score) */
	score_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: score) */
	score_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: score) */
	score_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: score) */
	score_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_ends_with?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_equals?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_regex_match?: InputMaybe<Score_Web_ProductsSearch>;
	text_starts_with?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	/** Equals (FieldName: timeframe_days) */
	timeframe_days_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: timeframe_days) */
	timeframe_days_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: timeframe_days) */
	timeframe_days_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: timeframe_days) */
	timeframe_days_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: timeframe_days) */
	timeframe_days_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: timeframe_days) */
	timeframe_days_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_issues_critical) */
	total_issues_critical_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues_critical) */
	total_issues_critical_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues_critical) */
	total_issues_critical_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues_critical) */
	total_issues_critical_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues_critical) */
	total_issues_critical_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues_critical) */
	total_issues_critical_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_issues_serious) */
	total_issues_serious_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues_serious) */
	total_issues_serious_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues_serious) */
	total_issues_serious_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues_serious) */
	total_issues_serious_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues_serious) */
	total_issues_serious_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues_serious) */
	total_issues_serious_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unique_issues_critical) */
	unique_issues_critical_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: unique_issues_critical) */
	unique_issues_critical_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: unique_issues_critical) */
	unique_issues_critical_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: unique_issues_critical) */
	unique_issues_critical_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: unique_issues_critical) */
	unique_issues_critical_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: unique_issues_critical) */
	unique_issues_critical_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unique_issues) */
	unique_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: unique_issues) */
	unique_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: unique_issues) */
	unique_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: unique_issues) */
	unique_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: unique_issues) */
	unique_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: unique_issues) */
	unique_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unique_issues_serious) */
	unique_issues_serious_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: unique_issues_serious) */
	unique_issues_serious_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: unique_issues_serious) */
	unique_issues_serious_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: unique_issues_serious) */
	unique_issues_serious_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: unique_issues_serious) */
	unique_issues_serious_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: unique_issues_serious) */
	unique_issues_serious_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unit_id) */
	unit_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: unit_id) */
	unit_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: unit_id) */
	unit_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: unit_id) */
	unit_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: unit_id) */
	unit_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: unit_id) */
	unit_id_ne?: InputMaybe<ConditionString>;
};

export enum Score_Web_ProductsGroup {
	CalculationDate = 'calculation_date',
	CalculationDateAny = 'calculation_date_any',
	CalculationDateCount = 'calculation_date_count',
	CalculationDateGroupUniqArray = 'calculation_date_group_uniq_array',
	CalculationDateMax = 'calculation_date_max',
	CalculationDateMin = 'calculation_date_min',
	CalculationDateTruncDay = 'calculation_date_truncDay',
	CalculationDateTruncMonth = 'calculation_date_truncMonth',
	CalculationDateTruncYear = 'calculation_date_truncYear',
	CreatedAt = 'created_at',
	CreatedAtAny = 'created_at_any',
	CreatedAtCount = 'created_at_count',
	CreatedAtGroupUniqArray = 'created_at_group_uniq_array',
	CreatedAtMax = 'created_at_max',
	CreatedAtMin = 'created_at_min',
	CreatedAtTruncDay = 'created_at_truncDay',
	CreatedAtTruncMonth = 'created_at_truncMonth',
	CreatedAtTruncYear = 'created_at_truncYear',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	Score = 'score',
	ScoreAny = 'score_any',
	ScoreCount = 'score_count',
	ScoreGroupUniqArray = 'score_group_uniq_array',
	ScoreMax = 'score_max',
	ScoreMin = 'score_min',
	ScoreSum = 'score_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TimeframeDays = 'timeframe_days',
	TimeframeDaysAny = 'timeframe_days_any',
	TimeframeDaysCount = 'timeframe_days_count',
	TimeframeDaysGroupUniqArray = 'timeframe_days_group_uniq_array',
	TimeframeDaysMax = 'timeframe_days_max',
	TimeframeDaysMin = 'timeframe_days_min',
	TimeframeDaysSum = 'timeframe_days_sum',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesCritical = 'total_issues_critical',
	TotalIssuesCriticalAny = 'total_issues_critical_any',
	TotalIssuesCriticalCount = 'total_issues_critical_count',
	TotalIssuesCriticalGroupUniqArray = 'total_issues_critical_group_uniq_array',
	TotalIssuesCriticalMax = 'total_issues_critical_max',
	TotalIssuesCriticalMin = 'total_issues_critical_min',
	TotalIssuesCriticalSum = 'total_issues_critical_sum',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSerious = 'total_issues_serious',
	TotalIssuesSeriousAny = 'total_issues_serious_any',
	TotalIssuesSeriousCount = 'total_issues_serious_count',
	TotalIssuesSeriousGroupUniqArray = 'total_issues_serious_group_uniq_array',
	TotalIssuesSeriousMax = 'total_issues_serious_max',
	TotalIssuesSeriousMin = 'total_issues_serious_min',
	TotalIssuesSeriousSum = 'total_issues_serious_sum',
	TotalIssuesSum = 'total_issues_sum',
	UniqueIssues = 'unique_issues',
	UniqueIssuesAny = 'unique_issues_any',
	UniqueIssuesCount = 'unique_issues_count',
	UniqueIssuesCritical = 'unique_issues_critical',
	UniqueIssuesCriticalAny = 'unique_issues_critical_any',
	UniqueIssuesCriticalCount = 'unique_issues_critical_count',
	UniqueIssuesCriticalGroupUniqArray = 'unique_issues_critical_group_uniq_array',
	UniqueIssuesCriticalMax = 'unique_issues_critical_max',
	UniqueIssuesCriticalMin = 'unique_issues_critical_min',
	UniqueIssuesCriticalSum = 'unique_issues_critical_sum',
	UniqueIssuesGroupUniqArray = 'unique_issues_group_uniq_array',
	UniqueIssuesMax = 'unique_issues_max',
	UniqueIssuesMin = 'unique_issues_min',
	UniqueIssuesSerious = 'unique_issues_serious',
	UniqueIssuesSeriousAny = 'unique_issues_serious_any',
	UniqueIssuesSeriousCount = 'unique_issues_serious_count',
	UniqueIssuesSeriousGroupUniqArray = 'unique_issues_serious_group_uniq_array',
	UniqueIssuesSeriousMax = 'unique_issues_serious_max',
	UniqueIssuesSeriousMin = 'unique_issues_serious_min',
	UniqueIssuesSeriousSum = 'unique_issues_serious_sum',
	UniqueIssuesSum = 'unique_issues_sum',
	UnitId = 'unit_id',
	UnitIdAny = 'unit_id_any',
	UnitIdCount = 'unit_id_count',
	UnitIdGroupUniqArray = 'unit_id_group_uniq_array',
	UnitIdMax = 'unit_id_max',
	UnitIdMin = 'unit_id_min'
}

/** Logical OR filter group for score_web_products queries. */
export type Score_Web_ProductsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Score_Web_ProductsAndFilter>>;
	/** Equals (FieldName: calculation_date) */
	calculation_date_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: calculation_date) */
	calculation_date_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: calculation_date) */
	calculation_date_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: calculation_date) */
	calculation_date_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: calculation_date) */
	calculation_date_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: calculation_date) */
	calculation_date_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: calculation_date) */
	calculation_date_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: created_at) */
	created_at_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: created_at) */
	created_at_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: created_at) */
	created_at_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: created_at) */
	created_at_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: created_at) */
	created_at_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: created_at) */
	created_at_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: created_at) */
	created_at_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: score) */
	score_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: score) */
	score_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: score) */
	score_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: score) */
	score_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: score) */
	score_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: score) */
	score_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_ends_with?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_equals?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	text_regex_match?: InputMaybe<Score_Web_ProductsSearch>;
	text_starts_with?: InputMaybe<Score_Web_ProductsSearchInsensitive>;
	/** Equals (FieldName: timeframe_days) */
	timeframe_days_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: timeframe_days) */
	timeframe_days_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: timeframe_days) */
	timeframe_days_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: timeframe_days) */
	timeframe_days_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: timeframe_days) */
	timeframe_days_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: timeframe_days) */
	timeframe_days_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_issues_critical) */
	total_issues_critical_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues_critical) */
	total_issues_critical_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues_critical) */
	total_issues_critical_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues_critical) */
	total_issues_critical_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues_critical) */
	total_issues_critical_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues_critical) */
	total_issues_critical_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_issues_serious) */
	total_issues_serious_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues_serious) */
	total_issues_serious_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues_serious) */
	total_issues_serious_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues_serious) */
	total_issues_serious_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues_serious) */
	total_issues_serious_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues_serious) */
	total_issues_serious_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unique_issues_critical) */
	unique_issues_critical_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: unique_issues_critical) */
	unique_issues_critical_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: unique_issues_critical) */
	unique_issues_critical_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: unique_issues_critical) */
	unique_issues_critical_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: unique_issues_critical) */
	unique_issues_critical_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: unique_issues_critical) */
	unique_issues_critical_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unique_issues) */
	unique_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: unique_issues) */
	unique_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: unique_issues) */
	unique_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: unique_issues) */
	unique_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: unique_issues) */
	unique_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: unique_issues) */
	unique_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unique_issues_serious) */
	unique_issues_serious_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: unique_issues_serious) */
	unique_issues_serious_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: unique_issues_serious) */
	unique_issues_serious_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: unique_issues_serious) */
	unique_issues_serious_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: unique_issues_serious) */
	unique_issues_serious_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: unique_issues_serious) */
	unique_issues_serious_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: unit_id) */
	unit_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: unit_id) */
	unit_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: unit_id) */
	unit_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: unit_id) */
	unit_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: unit_id) */
	unit_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: unit_id) */
	unit_id_ne?: InputMaybe<ConditionString>;
};

export type Score_Web_ProductsSearch = {
	searchFields: Array<Score_Web_ProductsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Score_Web_ProductsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Score_Web_ProductsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Score_Web_ProductsSort = {
	fields: Array<Score_Web_ProductsSortFields>;
	order?: InputMaybe<Score_Web_ProductsSortOrder>;
};

export enum Score_Web_ProductsSortFields {
	CalculationDate = 'calculation_date',
	CalculationDateAny = 'calculation_date_any',
	CalculationDateCount = 'calculation_date_count',
	CalculationDateGroupUniqArray = 'calculation_date_group_uniq_array',
	CalculationDateMax = 'calculation_date_max',
	CalculationDateMin = 'calculation_date_min',
	CalculationDateTruncDay = 'calculation_date_truncDay',
	CalculationDateTruncMonth = 'calculation_date_truncMonth',
	CalculationDateTruncYear = 'calculation_date_truncYear',
	CreatedAt = 'created_at',
	CreatedAtAny = 'created_at_any',
	CreatedAtCount = 'created_at_count',
	CreatedAtGroupUniqArray = 'created_at_group_uniq_array',
	CreatedAtMax = 'created_at_max',
	CreatedAtMin = 'created_at_min',
	CreatedAtTruncDay = 'created_at_truncDay',
	CreatedAtTruncMonth = 'created_at_truncMonth',
	CreatedAtTruncYear = 'created_at_truncYear',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	Score = 'score',
	ScoreAny = 'score_any',
	ScoreCount = 'score_count',
	ScoreGroupUniqArray = 'score_group_uniq_array',
	ScoreMax = 'score_max',
	ScoreMin = 'score_min',
	ScoreSum = 'score_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TimeframeDays = 'timeframe_days',
	TimeframeDaysAny = 'timeframe_days_any',
	TimeframeDaysCount = 'timeframe_days_count',
	TimeframeDaysGroupUniqArray = 'timeframe_days_group_uniq_array',
	TimeframeDaysMax = 'timeframe_days_max',
	TimeframeDaysMin = 'timeframe_days_min',
	TimeframeDaysSum = 'timeframe_days_sum',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesCritical = 'total_issues_critical',
	TotalIssuesCriticalAny = 'total_issues_critical_any',
	TotalIssuesCriticalCount = 'total_issues_critical_count',
	TotalIssuesCriticalGroupUniqArray = 'total_issues_critical_group_uniq_array',
	TotalIssuesCriticalMax = 'total_issues_critical_max',
	TotalIssuesCriticalMin = 'total_issues_critical_min',
	TotalIssuesCriticalSum = 'total_issues_critical_sum',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSerious = 'total_issues_serious',
	TotalIssuesSeriousAny = 'total_issues_serious_any',
	TotalIssuesSeriousCount = 'total_issues_serious_count',
	TotalIssuesSeriousGroupUniqArray = 'total_issues_serious_group_uniq_array',
	TotalIssuesSeriousMax = 'total_issues_serious_max',
	TotalIssuesSeriousMin = 'total_issues_serious_min',
	TotalIssuesSeriousSum = 'total_issues_serious_sum',
	TotalIssuesSum = 'total_issues_sum',
	UniqueIssues = 'unique_issues',
	UniqueIssuesAny = 'unique_issues_any',
	UniqueIssuesCount = 'unique_issues_count',
	UniqueIssuesCritical = 'unique_issues_critical',
	UniqueIssuesCriticalAny = 'unique_issues_critical_any',
	UniqueIssuesCriticalCount = 'unique_issues_critical_count',
	UniqueIssuesCriticalGroupUniqArray = 'unique_issues_critical_group_uniq_array',
	UniqueIssuesCriticalMax = 'unique_issues_critical_max',
	UniqueIssuesCriticalMin = 'unique_issues_critical_min',
	UniqueIssuesCriticalSum = 'unique_issues_critical_sum',
	UniqueIssuesGroupUniqArray = 'unique_issues_group_uniq_array',
	UniqueIssuesMax = 'unique_issues_max',
	UniqueIssuesMin = 'unique_issues_min',
	UniqueIssuesSerious = 'unique_issues_serious',
	UniqueIssuesSeriousAny = 'unique_issues_serious_any',
	UniqueIssuesSeriousCount = 'unique_issues_serious_count',
	UniqueIssuesSeriousGroupUniqArray = 'unique_issues_serious_group_uniq_array',
	UniqueIssuesSeriousMax = 'unique_issues_serious_max',
	UniqueIssuesSeriousMin = 'unique_issues_serious_min',
	UniqueIssuesSeriousSum = 'unique_issues_serious_sum',
	UniqueIssuesSum = 'unique_issues_sum',
	UnitId = 'unit_id',
	UnitIdAny = 'unit_id_any',
	UnitIdCount = 'unit_id_count',
	UnitIdGroupUniqArray = 'unit_id_group_uniq_array',
	UnitIdMax = 'unit_id_max',
	UnitIdMin = 'unit_id_min'
}

/** An example enum type */
export enum Score_Web_ProductsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Score_Web_ProductsTextSearchFields {
	CalculationDate = 'calculation_date',
	CreatedAt = 'created_at',
	Environment = 'environment',
	Score = 'score',
	TenantId = 'tenant_id',
	TimeframeDays = 'timeframe_days',
	TotalIssues = 'total_issues',
	TotalIssuesCritical = 'total_issues_critical',
	TotalIssuesSerious = 'total_issues_serious',
	UniqueIssues = 'unique_issues',
	UniqueIssuesCritical = 'unique_issues_critical',
	UniqueIssuesSerious = 'unique_issues_serious',
	UnitId = 'unit_id'
}

export type Uniqueness_Issues = {
	__typename?: 'uniqueness_issues';
	business_unit: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	business_unit_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	business_unit_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	business_unit_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	business_unit_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	business_unit_min: Scalars['String']['output'];
	environment: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	environment_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	environment_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	environment_min: Scalars['String']['output'];
	first_seen: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	first_seen_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	first_seen_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	first_seen_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	first_seen_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	first_seen_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	first_seen_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	first_seen_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	first_seen_truncYear?: Maybe<Scalars['DateTime']['output']>;
	issue_type: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_type_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_type_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	issue_type_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	issue_type_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	issue_type_min: Scalars['String']['output'];
	last_issue_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	last_issue_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	last_issue_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	last_issue_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	last_seen: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	last_seen_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	last_seen_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	last_seen_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	last_seen_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	last_seen_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	last_seen_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	last_seen_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	last_seen_truncYear?: Maybe<Scalars['DateTime']['output']>;
	page_title: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	page_title_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	page_title_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_title_min: Scalars['String']['output'];
	page_url: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_url_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_url_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	page_url_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	page_url_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	page_url_min: Scalars['String']['output'];
	product_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	product_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	product_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	product_name_min: Scalars['String']['output'];
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	severity: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	uniqueness_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	uniqueness_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	uniqueness_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	uniqueness_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
};

export type Uniqueness_IssuesBusiness_Unit_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Uniqueness_IssuesBusiness_Unit_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesEnvironment_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Uniqueness_IssuesEnvironment_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesFirst_Seen_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Uniqueness_IssuesFirst_Seen_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesIssue_Type_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Uniqueness_IssuesIssue_Type_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesLast_Issue_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Uniqueness_IssuesLast_Issue_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesLast_Seen_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Uniqueness_IssuesLast_Seen_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesPage_Title_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Uniqueness_IssuesPage_Title_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesPage_Url_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Uniqueness_IssuesPage_Url_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesProduct_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Uniqueness_IssuesProduct_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Uniqueness_IssuesRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesSeverity_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Uniqueness_IssuesSeverity_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Uniqueness_IssuesTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Uniqueness_IssuesUniqueness_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Uniqueness_IssuesUniqueness_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for uniqueness_issues queries. */
export type Uniqueness_IssuesAndFilter = {
	/** Equals (FieldName: business_unit) */
	business_unit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: business_unit) */
	business_unit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: business_unit) */
	business_unit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: business_unit) */
	business_unit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: business_unit) */
	business_unit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: business_unit) */
	business_unit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: first_seen) */
	first_seen_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: first_seen) */
	first_seen_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: first_seen) */
	first_seen_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: first_seen) */
	first_seen_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: first_seen) */
	first_seen_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: first_seen) */
	first_seen_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: first_seen) */
	first_seen_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: issue_type) */
	issue_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: issue_type) */
	issue_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: issue_type) */
	issue_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: issue_type) */
	issue_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: issue_type) */
	issue_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: issue_type) */
	issue_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: last_issue_id) */
	last_issue_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: last_issue_id) */
	last_issue_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: last_issue_id) */
	last_issue_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: last_issue_id) */
	last_issue_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: last_issue_id) */
	last_issue_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: last_issue_id) */
	last_issue_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: last_seen) */
	last_seen_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: last_seen) */
	last_seen_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: last_seen) */
	last_seen_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: last_seen) */
	last_seen_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: last_seen) */
	last_seen_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: last_seen) */
	last_seen_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: last_seen) */
	last_seen_ne?: InputMaybe<ConditionDateTime>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Uniqueness_IssuesOrFilter>>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: page_url) */
	page_url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_url) */
	page_url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_url) */
	page_url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_url) */
	page_url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_url) */
	page_url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_url) */
	page_url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: severity) */
	severity_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity) */
	severity_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity) */
	severity_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity) */
	severity_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity) */
	severity_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity) */
	severity_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_equals?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<Uniqueness_IssuesSearch>;
	text_starts_with?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	/** Equals (FieldName: uniqueness_id) */
	uniqueness_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: uniqueness_id) */
	uniqueness_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: uniqueness_id) */
	uniqueness_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: uniqueness_id) */
	uniqueness_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: uniqueness_id) */
	uniqueness_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: uniqueness_id) */
	uniqueness_id_ne?: InputMaybe<ConditionId>;
};

export enum Uniqueness_IssuesGroup {
	BusinessUnit = 'business_unit',
	BusinessUnitAny = 'business_unit_any',
	BusinessUnitCount = 'business_unit_count',
	BusinessUnitGroupUniqArray = 'business_unit_group_uniq_array',
	BusinessUnitMax = 'business_unit_max',
	BusinessUnitMin = 'business_unit_min',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	FirstSeen = 'first_seen',
	FirstSeenAny = 'first_seen_any',
	FirstSeenCount = 'first_seen_count',
	FirstSeenGroupUniqArray = 'first_seen_group_uniq_array',
	FirstSeenMax = 'first_seen_max',
	FirstSeenMin = 'first_seen_min',
	FirstSeenTruncDay = 'first_seen_truncDay',
	FirstSeenTruncMonth = 'first_seen_truncMonth',
	FirstSeenTruncYear = 'first_seen_truncYear',
	IssueType = 'issue_type',
	IssueTypeAny = 'issue_type_any',
	IssueTypeCount = 'issue_type_count',
	IssueTypeGroupUniqArray = 'issue_type_group_uniq_array',
	IssueTypeMax = 'issue_type_max',
	IssueTypeMin = 'issue_type_min',
	LastIssueId = 'last_issue_id',
	LastIssueIdAny = 'last_issue_id_any',
	LastIssueIdCount = 'last_issue_id_count',
	LastIssueIdGroupUniqArray = 'last_issue_id_group_uniq_array',
	LastSeen = 'last_seen',
	LastSeenAny = 'last_seen_any',
	LastSeenCount = 'last_seen_count',
	LastSeenGroupUniqArray = 'last_seen_group_uniq_array',
	LastSeenMax = 'last_seen_max',
	LastSeenMin = 'last_seen_min',
	LastSeenTruncDay = 'last_seen_truncDay',
	LastSeenTruncMonth = 'last_seen_truncMonth',
	LastSeenTruncYear = 'last_seen_truncYear',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	PageUrl = 'page_url',
	PageUrlAny = 'page_url_any',
	PageUrlCount = 'page_url_count',
	PageUrlGroupUniqArray = 'page_url_group_uniq_array',
	PageUrlMax = 'page_url_max',
	PageUrlMin = 'page_url_min',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	Severity = 'severity',
	SeverityAny = 'severity_any',
	SeverityCount = 'severity_count',
	SeverityGroupUniqArray = 'severity_group_uniq_array',
	SeverityMax = 'severity_max',
	SeverityMin = 'severity_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	UniquenessId = 'uniqueness_id',
	UniquenessIdAny = 'uniqueness_id_any',
	UniquenessIdCount = 'uniqueness_id_count',
	UniquenessIdGroupUniqArray = 'uniqueness_id_group_uniq_array'
}

/** Logical OR filter group for uniqueness_issues queries. */
export type Uniqueness_IssuesOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Uniqueness_IssuesAndFilter>>;
	/** Equals (FieldName: business_unit) */
	business_unit_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: business_unit) */
	business_unit_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: business_unit) */
	business_unit_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: business_unit) */
	business_unit_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: business_unit) */
	business_unit_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: business_unit) */
	business_unit_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environment) */
	environment_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environment) */
	environment_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environment) */
	environment_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environment) */
	environment_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environment) */
	environment_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environment) */
	environment_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: first_seen) */
	first_seen_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: first_seen) */
	first_seen_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: first_seen) */
	first_seen_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: first_seen) */
	first_seen_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: first_seen) */
	first_seen_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: first_seen) */
	first_seen_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: first_seen) */
	first_seen_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: issue_type) */
	issue_type_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: issue_type) */
	issue_type_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: issue_type) */
	issue_type_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: issue_type) */
	issue_type_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: issue_type) */
	issue_type_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: issue_type) */
	issue_type_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: last_issue_id) */
	last_issue_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: last_issue_id) */
	last_issue_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: last_issue_id) */
	last_issue_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: last_issue_id) */
	last_issue_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: last_issue_id) */
	last_issue_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: last_issue_id) */
	last_issue_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: last_seen) */
	last_seen_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: last_seen) */
	last_seen_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: last_seen) */
	last_seen_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: last_seen) */
	last_seen_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: last_seen) */
	last_seen_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: last_seen) */
	last_seen_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: last_seen) */
	last_seen_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: page_title) */
	page_title_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_title) */
	page_title_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_title) */
	page_title_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_title) */
	page_title_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_title) */
	page_title_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_title) */
	page_title_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: page_url) */
	page_url_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: page_url) */
	page_url_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: page_url) */
	page_url_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: page_url) */
	page_url_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: page_url) */
	page_url_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: page_url) */
	page_url_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: product_name) */
	product_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: product_name) */
	product_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: product_name) */
	product_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: product_name) */
	product_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: product_name) */
	product_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: product_name) */
	product_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: severity) */
	severity_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity) */
	severity_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity) */
	severity_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity) */
	severity_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity) */
	severity_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity) */
	severity_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_ends_with?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_equals?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	text_regex_match?: InputMaybe<Uniqueness_IssuesSearch>;
	text_starts_with?: InputMaybe<Uniqueness_IssuesSearchInsensitive>;
	/** Equals (FieldName: uniqueness_id) */
	uniqueness_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: uniqueness_id) */
	uniqueness_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: uniqueness_id) */
	uniqueness_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: uniqueness_id) */
	uniqueness_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: uniqueness_id) */
	uniqueness_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: uniqueness_id) */
	uniqueness_id_ne?: InputMaybe<ConditionId>;
};

export type Uniqueness_IssuesSearch = {
	searchFields: Array<Uniqueness_IssuesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Uniqueness_IssuesSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Uniqueness_IssuesTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Uniqueness_IssuesSort = {
	fields: Array<Uniqueness_IssuesSortFields>;
	order?: InputMaybe<Uniqueness_IssuesSortOrder>;
};

export enum Uniqueness_IssuesSortFields {
	BusinessUnit = 'business_unit',
	BusinessUnitAny = 'business_unit_any',
	BusinessUnitCount = 'business_unit_count',
	BusinessUnitGroupUniqArray = 'business_unit_group_uniq_array',
	BusinessUnitMax = 'business_unit_max',
	BusinessUnitMin = 'business_unit_min',
	Environment = 'environment',
	EnvironmentAny = 'environment_any',
	EnvironmentCount = 'environment_count',
	EnvironmentGroupUniqArray = 'environment_group_uniq_array',
	EnvironmentMax = 'environment_max',
	EnvironmentMin = 'environment_min',
	FirstSeen = 'first_seen',
	FirstSeenAny = 'first_seen_any',
	FirstSeenCount = 'first_seen_count',
	FirstSeenGroupUniqArray = 'first_seen_group_uniq_array',
	FirstSeenMax = 'first_seen_max',
	FirstSeenMin = 'first_seen_min',
	FirstSeenTruncDay = 'first_seen_truncDay',
	FirstSeenTruncMonth = 'first_seen_truncMonth',
	FirstSeenTruncYear = 'first_seen_truncYear',
	IssueType = 'issue_type',
	IssueTypeAny = 'issue_type_any',
	IssueTypeCount = 'issue_type_count',
	IssueTypeGroupUniqArray = 'issue_type_group_uniq_array',
	IssueTypeMax = 'issue_type_max',
	IssueTypeMin = 'issue_type_min',
	LastIssueId = 'last_issue_id',
	LastIssueIdAny = 'last_issue_id_any',
	LastIssueIdCount = 'last_issue_id_count',
	LastIssueIdGroupUniqArray = 'last_issue_id_group_uniq_array',
	LastSeen = 'last_seen',
	LastSeenAny = 'last_seen_any',
	LastSeenCount = 'last_seen_count',
	LastSeenGroupUniqArray = 'last_seen_group_uniq_array',
	LastSeenMax = 'last_seen_max',
	LastSeenMin = 'last_seen_min',
	LastSeenTruncDay = 'last_seen_truncDay',
	LastSeenTruncMonth = 'last_seen_truncMonth',
	LastSeenTruncYear = 'last_seen_truncYear',
	PageTitle = 'page_title',
	PageTitleAny = 'page_title_any',
	PageTitleCount = 'page_title_count',
	PageTitleGroupUniqArray = 'page_title_group_uniq_array',
	PageTitleMax = 'page_title_max',
	PageTitleMin = 'page_title_min',
	PageUrl = 'page_url',
	PageUrlAny = 'page_url_any',
	PageUrlCount = 'page_url_count',
	PageUrlGroupUniqArray = 'page_url_group_uniq_array',
	PageUrlMax = 'page_url_max',
	PageUrlMin = 'page_url_min',
	ProductName = 'product_name',
	ProductNameAny = 'product_name_any',
	ProductNameCount = 'product_name_count',
	ProductNameGroupUniqArray = 'product_name_group_uniq_array',
	ProductNameMax = 'product_name_max',
	ProductNameMin = 'product_name_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	Severity = 'severity',
	SeverityAny = 'severity_any',
	SeverityCount = 'severity_count',
	SeverityGroupUniqArray = 'severity_group_uniq_array',
	SeverityMax = 'severity_max',
	SeverityMin = 'severity_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	UniquenessId = 'uniqueness_id',
	UniquenessIdAny = 'uniqueness_id_any',
	UniquenessIdCount = 'uniqueness_id_count',
	UniquenessIdGroupUniqArray = 'uniqueness_id_group_uniq_array'
}

/** An example enum type */
export enum Uniqueness_IssuesSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Uniqueness_IssuesTextSearchFields {
	BusinessUnit = 'business_unit',
	Environment = 'environment',
	FirstSeen = 'first_seen',
	IssueType = 'issue_type',
	LastIssueId = 'last_issue_id',
	LastSeen = 'last_seen',
	PageTitle = 'page_title',
	PageUrl = 'page_url',
	ProductName = 'product_name',
	RunId = 'run_id',
	Severity = 'severity',
	TenantId = 'tenant_id',
	UniquenessId = 'uniqueness_id'
}

export type Wfa_Session_Components_Runs = {
	__typename?: 'wfa_session_components_runs';
	component_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	component_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	component_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	component_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	component_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	component_id_min: Scalars['String']['output'];
	conformance: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	conformance_any: Array<Scalars['String']['output']>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_ids: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	severity_ids_any: Array<Scalars['String']['output']>;
	severity_names: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	severity_names_any: Array<Scalars['String']['output']>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_pages: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_pages_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_pages_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_sum: Scalars['Int']['output'];
	type_ids: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	type_ids_any: Array<Scalars['String']['output']>;
	type_names: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	type_names_any: Array<Scalars['String']['output']>;
	urls: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	urls_any: Array<Scalars['String']['output']>;
};

export type Wfa_Session_Components_RunsComponent_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_Components_RunsComponent_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Components_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Session_Components_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Components_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Wfa_Session_Components_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Components_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Session_Components_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Components_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Components_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Components_RunsTotal_Pages_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Components_RunsTotal_Pages_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wfa_session_components_runs queries. */
export type Wfa_Session_Components_RunsAndFilter = {
	/** Equals (FieldName: component_id) */
	component_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: component_id) */
	component_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: component_id) */
	component_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: component_id) */
	component_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: component_id) */
	component_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: component_id) */
	component_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wfa_Session_Components_RunsOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Components_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
};

export enum Wfa_Session_Components_RunsGroup {
	ComponentId = 'component_id',
	ComponentIdAny = 'component_id_any',
	ComponentIdCount = 'component_id_count',
	ComponentIdGroupUniqArray = 'component_id_group_uniq_array',
	ComponentIdMax = 'component_id_max',
	ComponentIdMin = 'component_id_min',
	ConformanceAny = 'conformance_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityIdsAny = 'severity_ids_any',
	SeverityNamesAny = 'severity_names_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum',
	TypeIdsAny = 'type_ids_any',
	TypeNamesAny = 'type_names_any',
	UrlsAny = 'urls_any'
}

/** Logical OR filter group for wfa_session_components_runs queries. */
export type Wfa_Session_Components_RunsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wfa_Session_Components_RunsAndFilter>>;
	/** Equals (FieldName: component_id) */
	component_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: component_id) */
	component_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: component_id) */
	component_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: component_id) */
	component_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: component_id) */
	component_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: component_id) */
	component_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	conformance_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: conformance): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	conformance_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_ids_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	severity_names_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	severity_names_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: severity_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	severity_names_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Components_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Components_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_ids_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_ids_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_ids_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_names): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	type_names_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	type_names_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: type_names): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	type_names_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: urls): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	urls_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	urls_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: urls): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	urls_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
};

export type Wfa_Session_Components_RunsSearch = {
	searchFields: Array<Wfa_Session_Components_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_Components_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wfa_Session_Components_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_Components_RunsSort = {
	fields: Array<Wfa_Session_Components_RunsSortFields>;
	order?: InputMaybe<Wfa_Session_Components_RunsSortOrder>;
};

export enum Wfa_Session_Components_RunsSortFields {
	ComponentId = 'component_id',
	ComponentIdAny = 'component_id_any',
	ComponentIdCount = 'component_id_count',
	ComponentIdGroupUniqArray = 'component_id_group_uniq_array',
	ComponentIdMax = 'component_id_max',
	ComponentIdMin = 'component_id_min',
	ConformanceAny = 'conformance_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityIdsAny = 'severity_ids_any',
	SeverityNamesAny = 'severity_names_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum',
	TypeIdsAny = 'type_ids_any',
	TypeNamesAny = 'type_names_any',
	UrlsAny = 'urls_any'
}

/** An example enum type */
export enum Wfa_Session_Components_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wfa_Session_Components_RunsTextSearchFields {
	ComponentId = 'component_id',
	Conformance = 'conformance',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityIds = 'severity_ids',
	SeverityNames = 'severity_names',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TotalPages = 'total_pages',
	TypeIds = 'type_ids',
	TypeNames = 'type_names',
	Urls = 'urls'
}

export type Wfa_Session_Run_Labels = {
	__typename?: 'wfa_session_run_labels';
	custom_field_key: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	custom_field_key_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	custom_field_key_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	custom_field_key_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	custom_field_key_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	custom_field_key_min: Scalars['String']['output'];
	custom_field_values: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	custom_field_values_any: Array<Scalars['String']['output']>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
};

export type Wfa_Session_Run_LabelsCustom_Field_Key_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_Run_LabelsCustom_Field_Key_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Run_LabelsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Session_Run_LabelsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wfa_session_run_labels queries. */
export type Wfa_Session_Run_LabelsAndFilter = {
	/** Equals (FieldName: custom_field_key) */
	custom_field_key_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_field_key) */
	custom_field_key_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_field_key) */
	custom_field_key_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_field_key) */
	custom_field_key_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_field_key) */
	custom_field_key_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_field_key) */
	custom_field_key_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wfa_Session_Run_LabelsOrFilter>>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Run_LabelsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
};

export enum Wfa_Session_Run_LabelsGroup {
	CustomFieldKey = 'custom_field_key',
	CustomFieldKeyAny = 'custom_field_key_any',
	CustomFieldKeyCount = 'custom_field_key_count',
	CustomFieldKeyGroupUniqArray = 'custom_field_key_group_uniq_array',
	CustomFieldKeyMax = 'custom_field_key_max',
	CustomFieldKeyMin = 'custom_field_key_min',
	CustomFieldValuesAny = 'custom_field_values_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array'
}

/** Logical OR filter group for wfa_session_run_labels queries. */
export type Wfa_Session_Run_LabelsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wfa_Session_Run_LabelsAndFilter>>;
	/** Equals (FieldName: custom_field_key) */
	custom_field_key_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_field_key) */
	custom_field_key_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_field_key) */
	custom_field_key_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_field_key) */
	custom_field_key_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_field_key) */
	custom_field_key_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_field_key) */
	custom_field_key_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_field_values): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_field_values_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_field_values): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_field_values_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Run_LabelsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Run_LabelsSearchInsensitive>;
};

export type Wfa_Session_Run_LabelsSearch = {
	searchFields: Array<Wfa_Session_Run_LabelsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_Run_LabelsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wfa_Session_Run_LabelsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_Run_LabelsSort = {
	fields: Array<Wfa_Session_Run_LabelsSortFields>;
	order?: InputMaybe<Wfa_Session_Run_LabelsSortOrder>;
};

export enum Wfa_Session_Run_LabelsSortFields {
	CustomFieldKey = 'custom_field_key',
	CustomFieldKeyAny = 'custom_field_key_any',
	CustomFieldKeyCount = 'custom_field_key_count',
	CustomFieldKeyGroupUniqArray = 'custom_field_key_group_uniq_array',
	CustomFieldKeyMax = 'custom_field_key_max',
	CustomFieldKeyMin = 'custom_field_key_min',
	CustomFieldValuesAny = 'custom_field_values_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array'
}

/** An example enum type */
export enum Wfa_Session_Run_LabelsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wfa_Session_Run_LabelsTextSearchFields {
	CustomFieldKey = 'custom_field_key',
	CustomFieldValues = 'custom_field_values',
	TenantId = 'tenant_id'
}

export type Wfa_Session_Runs = {
	__typename?: 'wfa_session_runs';
	analysis_root_selector: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	analysis_root_selector_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	analysis_root_selector_min: Scalars['String']['output'];
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	detection_types: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	detection_types_any: Array<Scalars['String']['output']>;
	domain: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	domain_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	domain_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	domain_min: Scalars['String']['output'];
	environments: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	environments_any: Array<Scalars['String']['output']>;
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	flows: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	flows_any: Array<Scalars['String']['output']>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	session_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	session_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	session_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	session_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_pages: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_pages_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_pages_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_sum: Scalars['Int']['output'];
	update_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	update_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	update_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	update_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	update_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	user_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	user_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	user_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	user_name_min: Scalars['String']['output'];
};

export type Wfa_Session_RunsAnalysis_Root_Selector_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_RunsAnalysis_Root_Selector_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsDomain_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_RunsDomain_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_RunsMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Session_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Wfa_Session_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsSession_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_RunsSession_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Session_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsTotal_Pages_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsTotal_Pages_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsUpdate_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Wfa_Session_RunsUpdate_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_RunsUser_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_RunsUser_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wfa_session_runs queries. */
export type Wfa_Session_RunsAndFilter = {
	/** Equals (FieldName: analysis_root_selector) */
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: analysis_root_selector) */
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: analysis_root_selector) */
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: domain) */
	domain_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: domain) */
	domain_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: domain) */
	domain_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: domain) */
	domain_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: domain) */
	domain_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: domain) */
	domain_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wfa_Session_RunsOrFilter>>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: user_name) */
	user_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_name) */
	user_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_name) */
	user_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_name) */
	user_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_name) */
	user_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_name) */
	user_name_ne?: InputMaybe<ConditionString>;
};

export enum Wfa_Session_RunsGroup {
	AnalysisRootSelector = 'analysis_root_selector',
	AnalysisRootSelectorAny = 'analysis_root_selector_any',
	AnalysisRootSelectorCount = 'analysis_root_selector_count',
	AnalysisRootSelectorGroupUniqArray = 'analysis_root_selector_group_uniq_array',
	AnalysisRootSelectorMax = 'analysis_root_selector_max',
	AnalysisRootSelectorMin = 'analysis_root_selector_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DetectionTypesAny = 'detection_types_any',
	Domain = 'domain',
	DomainAny = 'domain_any',
	DomainCount = 'domain_count',
	DomainGroupUniqArray = 'domain_group_uniq_array',
	DomainMax = 'domain_max',
	DomainMin = 'domain_min',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	UserName = 'user_name',
	UserNameAny = 'user_name_any',
	UserNameCount = 'user_name_count',
	UserNameGroupUniqArray = 'user_name_group_uniq_array',
	UserNameMax = 'user_name_max',
	UserNameMin = 'user_name_min'
}

/** Logical OR filter group for wfa_session_runs queries. */
export type Wfa_Session_RunsOrFilter = {
	/** Equals (FieldName: analysis_root_selector) */
	analysis_root_selector_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: analysis_root_selector) */
	analysis_root_selector_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: analysis_root_selector) */
	analysis_root_selector_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: analysis_root_selector) */
	analysis_root_selector_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: analysis_root_selector) */
	analysis_root_selector_ne?: InputMaybe<ConditionString>;
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wfa_Session_RunsAndFilter>>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	detection_types_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: detection_types): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	detection_types_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: domain) */
	domain_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: domain) */
	domain_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: domain) */
	domain_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: domain) */
	domain_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: domain) */
	domain_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: domain) */
	domain_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: session_name) */
	session_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: session_name) */
	session_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: session_name) */
	session_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: session_name) */
	session_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: session_name) */
	session_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: session_name) */
	session_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: update_time) */
	update_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: update_time) */
	update_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: update_time) */
	update_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: update_time) */
	update_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: update_time) */
	update_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: update_time) */
	update_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: update_time) */
	update_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: user_name) */
	user_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: user_name) */
	user_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: user_name) */
	user_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: user_name) */
	user_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: user_name) */
	user_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: user_name) */
	user_name_ne?: InputMaybe<ConditionString>;
};

export type Wfa_Session_RunsSearch = {
	searchFields: Array<Wfa_Session_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wfa_Session_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_RunsSort = {
	fields: Array<Wfa_Session_RunsSortFields>;
	order?: InputMaybe<Wfa_Session_RunsSortOrder>;
};

export enum Wfa_Session_RunsSortFields {
	AnalysisRootSelector = 'analysis_root_selector',
	AnalysisRootSelectorAny = 'analysis_root_selector_any',
	AnalysisRootSelectorCount = 'analysis_root_selector_count',
	AnalysisRootSelectorGroupUniqArray = 'analysis_root_selector_group_uniq_array',
	AnalysisRootSelectorMax = 'analysis_root_selector_max',
	AnalysisRootSelectorMin = 'analysis_root_selector_min',
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	DetectionTypesAny = 'detection_types_any',
	Domain = 'domain',
	DomainAny = 'domain_any',
	DomainCount = 'domain_count',
	DomainGroupUniqArray = 'domain_group_uniq_array',
	DomainMax = 'domain_max',
	DomainMin = 'domain_min',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	SessionName = 'session_name',
	SessionNameAny = 'session_name_any',
	SessionNameCount = 'session_name_count',
	SessionNameGroupUniqArray = 'session_name_group_uniq_array',
	SessionNameMax = 'session_name_max',
	SessionNameMin = 'session_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum',
	UpdateTime = 'update_time',
	UpdateTimeAny = 'update_time_any',
	UpdateTimeCount = 'update_time_count',
	UpdateTimeGroupUniqArray = 'update_time_group_uniq_array',
	UpdateTimeMax = 'update_time_max',
	UpdateTimeMin = 'update_time_min',
	UpdateTimeTruncDay = 'update_time_truncDay',
	UpdateTimeTruncMonth = 'update_time_truncMonth',
	UpdateTimeTruncYear = 'update_time_truncYear',
	UserName = 'user_name',
	UserNameAny = 'user_name_any',
	UserNameCount = 'user_name_count',
	UserNameGroupUniqArray = 'user_name_group_uniq_array',
	UserNameMax = 'user_name_max',
	UserNameMin = 'user_name_min'
}

/** An example enum type */
export enum Wfa_Session_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wfa_Session_RunsTextSearchFields {
	AnalysisRootSelector = 'analysis_root_selector',
	BestPracticeIssues = 'best_practice_issues',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	DetectionTypes = 'detection_types',
	Domain = 'domain',
	Environments = 'environments',
	FilteredCustomFields = 'filtered_custom_fields',
	Flows = 'flows',
	MinorIssues = 'minor_issues',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeriousIssues = 'serious_issues',
	SessionName = 'session_name',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TotalPages = 'total_pages',
	UpdateTime = 'update_time',
	UserName = 'user_name'
}

export type Wfa_Session_Type_Runs = {
	__typename?: 'wfa_session_type_runs';
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	severity_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_id_min: Scalars['String']['output'];
	severity_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	severity_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	severity_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	severity_name_min: Scalars['String']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	type_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_id_min: Scalars['String']['output'];
	type_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	type_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	type_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	type_name_min: Scalars['String']['output'];
};

export type Wfa_Session_Type_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Session_Type_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Wfa_Session_Type_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsSeverity_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_Type_RunsSeverity_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsSeverity_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_Type_RunsSeverity_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Session_Type_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsType_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_Type_RunsType_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Session_Type_RunsType_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Session_Type_RunsType_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wfa_session_type_runs queries. */
export type Wfa_Session_Type_RunsAndFilter = {
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wfa_Session_Type_RunsOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_id) */
	severity_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_id) */
	severity_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_id) */
	severity_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_id) */
	severity_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_id) */
	severity_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_id) */
	severity_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Type_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_id) */
	type_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_id) */
	type_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_id) */
	type_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_id) */
	type_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_id) */
	type_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_id) */
	type_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export enum Wfa_Session_Type_RunsGroup {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityId = 'severity_id',
	SeverityIdAny = 'severity_id_any',
	SeverityIdCount = 'severity_id_count',
	SeverityIdGroupUniqArray = 'severity_id_group_uniq_array',
	SeverityIdMax = 'severity_id_max',
	SeverityIdMin = 'severity_id_min',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeId = 'type_id',
	TypeIdAny = 'type_id_any',
	TypeIdCount = 'type_id_count',
	TypeIdGroupUniqArray = 'type_id_group_uniq_array',
	TypeIdMax = 'type_id_max',
	TypeIdMin = 'type_id_min',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** Logical OR filter group for wfa_session_type_runs queries. */
export type Wfa_Session_Type_RunsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wfa_Session_Type_RunsAndFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: severity_id) */
	severity_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_id) */
	severity_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_id) */
	severity_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_id) */
	severity_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_id) */
	severity_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_id) */
	severity_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: severity_name) */
	severity_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: severity_name) */
	severity_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: severity_name) */
	severity_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: severity_name) */
	severity_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: severity_name) */
	severity_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: severity_name) */
	severity_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Session_Type_RunsSearch>;
	text_starts_with?: InputMaybe<Wfa_Session_Type_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: type_id) */
	type_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_id) */
	type_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_id) */
	type_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_id) */
	type_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_id) */
	type_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_id) */
	type_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: type_name) */
	type_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: type_name) */
	type_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: type_name) */
	type_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: type_name) */
	type_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: type_name) */
	type_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: type_name) */
	type_name_ne?: InputMaybe<ConditionString>;
};

export type Wfa_Session_Type_RunsSearch = {
	searchFields: Array<Wfa_Session_Type_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_Type_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wfa_Session_Type_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Session_Type_RunsSort = {
	fields: Array<Wfa_Session_Type_RunsSortFields>;
	order?: InputMaybe<Wfa_Session_Type_RunsSortOrder>;
};

export enum Wfa_Session_Type_RunsSortFields {
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeverityId = 'severity_id',
	SeverityIdAny = 'severity_id_any',
	SeverityIdCount = 'severity_id_count',
	SeverityIdGroupUniqArray = 'severity_id_group_uniq_array',
	SeverityIdMax = 'severity_id_max',
	SeverityIdMin = 'severity_id_min',
	SeverityName = 'severity_name',
	SeverityNameAny = 'severity_name_any',
	SeverityNameCount = 'severity_name_count',
	SeverityNameGroupUniqArray = 'severity_name_group_uniq_array',
	SeverityNameMax = 'severity_name_max',
	SeverityNameMin = 'severity_name_min',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TypeId = 'type_id',
	TypeIdAny = 'type_id_any',
	TypeIdCount = 'type_id_count',
	TypeIdGroupUniqArray = 'type_id_group_uniq_array',
	TypeIdMax = 'type_id_max',
	TypeIdMin = 'type_id_min',
	TypeName = 'type_name',
	TypeNameAny = 'type_name_any',
	TypeNameCount = 'type_name_count',
	TypeNameGroupUniqArray = 'type_name_group_uniq_array',
	TypeNameMax = 'type_name_max',
	TypeNameMin = 'type_name_min'
}

/** An example enum type */
export enum Wfa_Session_Type_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wfa_Session_Type_RunsTextSearchFields {
	RunId = 'run_id',
	RunTime = 'run_time',
	SeverityId = 'severity_id',
	SeverityName = 'severity_name',
	TenantId = 'tenant_id',
	TotalIssues = 'total_issues',
	TypeId = 'type_id',
	TypeName = 'type_name'
}

export type Wfa_Top_Critical_Components = {
	__typename?: 'wfa_top_critical_components';
	critical_issues_count: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_count_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_count_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count_sum: Scalars['Int']['output'];
	critical_percentage: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_percentage_any: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_percentage_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_percentage_group_uniq_array?: Maybe<Array<Scalars['Float']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_percentage_max: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_percentage_min: Scalars['Float']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_percentage_sum: Scalars['Int']['output'];
	elements__component_id: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	elements__component_id_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	elements__component_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	elements__component_id_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	elements__component_id_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	elements__component_id_min: Scalars['String']['output'];
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
};

export type Wfa_Top_Critical_ComponentsCritical_Issues_Count_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Top_Critical_ComponentsCritical_Issues_Count_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Top_Critical_ComponentsCritical_Percentage_CountArgs = {
	value?: InputMaybe<Scalars['Float']['input']>;
};

export type Wfa_Top_Critical_ComponentsCritical_Percentage_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Top_Critical_ComponentsElements__Component_Id_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wfa_Top_Critical_ComponentsElements__Component_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Top_Critical_ComponentsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Top_Critical_ComponentsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wfa_Top_Critical_ComponentsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wfa_Top_Critical_ComponentsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wfa_top_critical_components queries. */
export type Wfa_Top_Critical_ComponentsAndFilter = {
	/** Equals (FieldName: critical_issues_count) */
	critical_issues_count_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues_count) */
	critical_issues_count_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues_count) */
	critical_issues_count_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues_count) */
	critical_issues_count_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues_count) */
	critical_issues_count_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues_count) */
	critical_issues_count_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_percentage) */
	critical_percentage_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: critical_percentage) */
	critical_percentage_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: critical_percentage) */
	critical_percentage_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: critical_percentage) */
	critical_percentage_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: critical_percentage) */
	critical_percentage_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: critical_percentage) */
	critical_percentage_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__component_id) */
	elements__component_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__component_id) */
	elements__component_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__component_id) */
	elements__component_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__component_id) */
	elements__component_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__component_id) */
	elements__component_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__component_id) */
	elements__component_id_ne?: InputMaybe<ConditionString>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wfa_Top_Critical_ComponentsOrFilter>>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Top_Critical_ComponentsSearch>;
	text_starts_with?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
};

export enum Wfa_Top_Critical_ComponentsGroup {
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesCountAny = 'critical_issues_count_any',
	CriticalIssuesCountCount = 'critical_issues_count_count',
	CriticalIssuesCountGroupUniqArray = 'critical_issues_count_group_uniq_array',
	CriticalIssuesCountMax = 'critical_issues_count_max',
	CriticalIssuesCountMin = 'critical_issues_count_min',
	CriticalIssuesCountSum = 'critical_issues_count_sum',
	CriticalPercentage = 'critical_percentage',
	CriticalPercentageAny = 'critical_percentage_any',
	CriticalPercentageCount = 'critical_percentage_count',
	CriticalPercentageGroupUniqArray = 'critical_percentage_group_uniq_array',
	CriticalPercentageMax = 'critical_percentage_max',
	CriticalPercentageMin = 'critical_percentage_min',
	CriticalPercentageSum = 'critical_percentage_sum',
	ElementsComponentId = 'elements__component_id',
	ElementsComponentIdAny = 'elements__component_id_any',
	ElementsComponentIdCount = 'elements__component_id_count',
	ElementsComponentIdGroupUniqArray = 'elements__component_id_group_uniq_array',
	ElementsComponentIdMax = 'elements__component_id_max',
	ElementsComponentIdMin = 'elements__component_id_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array'
}

/** Logical OR filter group for wfa_top_critical_components queries. */
export type Wfa_Top_Critical_ComponentsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wfa_Top_Critical_ComponentsAndFilter>>;
	/** Equals (FieldName: critical_issues_count) */
	critical_issues_count_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues_count) */
	critical_issues_count_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues_count) */
	critical_issues_count_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues_count) */
	critical_issues_count_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues_count) */
	critical_issues_count_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues_count) */
	critical_issues_count_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_percentage) */
	critical_percentage_eq?: InputMaybe<ConditionFloat>;
	/** Greater than or equals (FieldName: critical_percentage) */
	critical_percentage_ge?: InputMaybe<ConditionFloat>;
	/** Greater than (FieldName: critical_percentage) */
	critical_percentage_gt?: InputMaybe<ConditionFloat>;
	/** Less than or equals (FieldName: critical_percentage) */
	critical_percentage_le?: InputMaybe<ConditionFloat>;
	/** Less than (FieldName: critical_percentage) */
	critical_percentage_lt?: InputMaybe<ConditionFloat>;
	/** Not equals (FieldName: critical_percentage) */
	critical_percentage_ne?: InputMaybe<ConditionFloat>;
	/** Equals (FieldName: elements__component_id) */
	elements__component_id_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: elements__component_id) */
	elements__component_id_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: elements__component_id) */
	elements__component_id_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: elements__component_id) */
	elements__component_id_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: elements__component_id) */
	elements__component_id_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: elements__component_id) */
	elements__component_id_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_equals?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wfa_Top_Critical_ComponentsSearch>;
	text_starts_with?: InputMaybe<Wfa_Top_Critical_ComponentsSearchInsensitive>;
};

export type Wfa_Top_Critical_ComponentsSearch = {
	searchFields: Array<Wfa_Top_Critical_ComponentsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Top_Critical_ComponentsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wfa_Top_Critical_ComponentsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wfa_Top_Critical_ComponentsSort = {
	fields: Array<Wfa_Top_Critical_ComponentsSortFields>;
	order?: InputMaybe<Wfa_Top_Critical_ComponentsSortOrder>;
};

export enum Wfa_Top_Critical_ComponentsSortFields {
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesCountAny = 'critical_issues_count_any',
	CriticalIssuesCountCount = 'critical_issues_count_count',
	CriticalIssuesCountGroupUniqArray = 'critical_issues_count_group_uniq_array',
	CriticalIssuesCountMax = 'critical_issues_count_max',
	CriticalIssuesCountMin = 'critical_issues_count_min',
	CriticalIssuesCountSum = 'critical_issues_count_sum',
	CriticalPercentage = 'critical_percentage',
	CriticalPercentageAny = 'critical_percentage_any',
	CriticalPercentageCount = 'critical_percentage_count',
	CriticalPercentageGroupUniqArray = 'critical_percentage_group_uniq_array',
	CriticalPercentageMax = 'critical_percentage_max',
	CriticalPercentageMin = 'critical_percentage_min',
	CriticalPercentageSum = 'critical_percentage_sum',
	ElementsComponentId = 'elements__component_id',
	ElementsComponentIdAny = 'elements__component_id_any',
	ElementsComponentIdCount = 'elements__component_id_count',
	ElementsComponentIdGroupUniqArray = 'elements__component_id_group_uniq_array',
	ElementsComponentIdMax = 'elements__component_id_max',
	ElementsComponentIdMin = 'elements__component_id_min',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array'
}

/** An example enum type */
export enum Wfa_Top_Critical_ComponentsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wfa_Top_Critical_ComponentsTextSearchFields {
	CriticalIssuesCount = 'critical_issues_count',
	CriticalPercentage = 'critical_percentage',
	ElementsComponentId = 'elements__component_id',
	RunId = 'run_id',
	TenantId = 'tenant_id'
}

export type Wsdk_Latest_Test_Runs = {
	__typename?: 'wsdk_latest_test_runs';
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	environments: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	environments_any: Array<Scalars['String']['output']>;
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	flows: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	flows_any: Array<Scalars['String']['output']>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	test_path: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_path_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_path_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_min: Scalars['String']['output'];
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_pages: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_pages_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_pages_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_sum: Scalars['Int']['output'];
};

export type Wsdk_Latest_Test_RunsBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wsdk_Latest_Test_RunsMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wsdk_Latest_Test_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Wsdk_Latest_Test_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wsdk_Latest_Test_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wsdk_Latest_Test_RunsTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsTest_Path_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wsdk_Latest_Test_RunsTest_Path_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsTotal_Pages_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Latest_Test_RunsTotal_Pages_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wsdk_latest_test_runs queries. */
export type Wsdk_Latest_Test_RunsAndFilter = {
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wsdk_Latest_Test_RunsOrFilter>>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Latest_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
};

export enum Wsdk_Latest_Test_RunsGroup {
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum'
}

/** Logical OR filter group for wsdk_latest_test_runs queries. */
export type Wsdk_Latest_Test_RunsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wsdk_Latest_Test_RunsAndFilter>>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Latest_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Latest_Test_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
};

export type Wsdk_Latest_Test_RunsSearch = {
	searchFields: Array<Wsdk_Latest_Test_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wsdk_Latest_Test_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wsdk_Latest_Test_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wsdk_Latest_Test_RunsSort = {
	fields: Array<Wsdk_Latest_Test_RunsSortFields>;
	order?: InputMaybe<Wsdk_Latest_Test_RunsSortOrder>;
};

export enum Wsdk_Latest_Test_RunsSortFields {
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum'
}

/** An example enum type */
export enum Wsdk_Latest_Test_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wsdk_Latest_Test_RunsTextSearchFields {
	BestPracticeIssues = 'best_practice_issues',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	Environments = 'environments',
	FilteredCustomFields = 'filtered_custom_fields',
	Flows = 'flows',
	MinorIssues = 'minor_issues',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeriousIssues = 'serious_issues',
	TenantId = 'tenant_id',
	TestName = 'test_name',
	TestPath = 'test_path',
	TotalIssues = 'total_issues',
	TotalPages = 'total_pages'
}

export type Wsdk_Test_Labels = {
	__typename?: 'wsdk_test_labels';
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	environments: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	environments_any: Array<Scalars['String']['output']>;
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	flows: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	flows_any: Array<Scalars['String']['output']>;
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
};

export type Wsdk_Test_LabelsFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wsdk_Test_LabelsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wsdk_Test_LabelsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wsdk_test_labels queries. */
export type Wsdk_Test_LabelsAndFilter = {
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wsdk_Test_LabelsOrFilter>>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Test_LabelsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
};

export enum Wsdk_Test_LabelsGroup {
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array'
}

/** Logical OR filter group for wsdk_test_labels queries. */
export type Wsdk_Test_LabelsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wsdk_Test_LabelsAndFilter>>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	text_contains?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Test_LabelsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Test_LabelsSearchInsensitive>;
};

export type Wsdk_Test_LabelsSearch = {
	searchFields: Array<Wsdk_Test_LabelsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wsdk_Test_LabelsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wsdk_Test_LabelsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wsdk_Test_LabelsSort = {
	fields: Array<Wsdk_Test_LabelsSortFields>;
	order?: InputMaybe<Wsdk_Test_LabelsSortOrder>;
};

export enum Wsdk_Test_LabelsSortFields {
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array'
}

/** An example enum type */
export enum Wsdk_Test_LabelsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wsdk_Test_LabelsTextSearchFields {
	CustomFields = 'custom_fields',
	Environments = 'environments',
	FilteredCustomFields = 'filtered_custom_fields',
	Flows = 'flows',
	TenantId = 'tenant_id'
}

export type Wsdk_Test_Runs = {
	__typename?: 'wsdk_test_runs';
	best_practice_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	best_practice_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	best_practice_issues_sum: Scalars['Int']['output'];
	critical_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	critical_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	critical_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	critical_issues_sum: Scalars['Int']['output'];
	custom_fields: Array<Array<Maybe<Scalars['String']['output']>>>;
	/** simple aggregate function which returns a scalar value */
	custom_fields_any: Array<Array<Maybe<Scalars['String']['output']>>>;
	environments: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	environments_any: Array<Scalars['String']['output']>;
	/** Filtered values from custom_fields by key or keys from custom_fields by value */
	filtered_custom_fields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
	flows: Array<Scalars['String']['output']>;
	/** simple aggregate function which returns a scalar value */
	flows_any: Array<Scalars['String']['output']>;
	minor_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	minor_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	minor_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	minor_issues_sum: Scalars['Int']['output'];
	moderate_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	moderate_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	moderate_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	moderate_issues_sum: Scalars['Int']['output'];
	needs_review_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	needs_review_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	needs_review_issues_sum: Scalars['Int']['output'];
	property_ids: Array<Scalars['ID']['output']>;
	/** simple aggregate function which returns a scalar value */
	property_ids_any: Array<Scalars['ID']['output']>;
	run_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	run_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	run_time: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_any: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	run_time_group_uniq_array?: Maybe<Array<Scalars['DateTime']['output']>>;
	/** simple aggregate function which returns a scalar value */
	run_time_max: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_min: Scalars['DateTime']['output'];
	/** simple aggregate function which returns a scalar value */
	run_time_truncDay?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncMonth?: Maybe<Scalars['DateTime']['output']>;
	/** simple aggregate function which returns a scalar value */
	run_time_truncYear?: Maybe<Scalars['DateTime']['output']>;
	serious_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	serious_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	serious_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	serious_issues_sum: Scalars['Int']['output'];
	tenant_id: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_any: Scalars['ID']['output'];
	/** simple aggregate function which returns a scalar value */
	tenant_id_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	tenant_id_group_uniq_array?: Maybe<Array<Scalars['ID']['output']>>;
	test_name: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_name_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_name_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_name_min: Scalars['String']['output'];
	test_path: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_any: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	test_path_group_uniq_array?: Maybe<Array<Scalars['String']['output']>>;
	/** simple aggregate function which returns a scalar value */
	test_path_max: Scalars['String']['output'];
	/** simple aggregate function which returns a scalar value */
	test_path_min: Scalars['String']['output'];
	total_issues: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_issues_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_issues_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_issues_sum: Scalars['Int']['output'];
	total_pages: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_any: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_count: Scalars['Int']['output'];
	/** group unique array aggregate function */
	total_pages_group_uniq_array?: Maybe<Array<Scalars['Int']['output']>>;
	/** simple aggregate function which returns a scalar value */
	total_pages_max: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_min: Scalars['Int']['output'];
	/** simple aggregate function which returns a scalar value */
	total_pages_sum: Scalars['Int']['output'];
};

export type Wsdk_Test_RunsBest_Practice_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsBest_Practice_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsCritical_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsCritical_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsFiltered_Custom_FieldsArgs = {
	key?: InputMaybe<Scalars['String']['input']>;
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wsdk_Test_RunsMinor_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsMinor_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsModerate_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsModerate_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsNeeds_Review_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsNeeds_Review_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsRun_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wsdk_Test_RunsRun_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsRun_Time_CountArgs = {
	value?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Wsdk_Test_RunsRun_Time_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsSerious_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsSerious_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsTenant_Id_CountArgs = {
	value?: InputMaybe<Scalars['ID']['input']>;
};

export type Wsdk_Test_RunsTenant_Id_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsTest_Name_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wsdk_Test_RunsTest_Name_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsTest_Path_CountArgs = {
	value?: InputMaybe<Scalars['String']['input']>;
};

export type Wsdk_Test_RunsTest_Path_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsTotal_Issues_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsTotal_Issues_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsTotal_Pages_CountArgs = {
	value?: InputMaybe<Scalars['Int']['input']>;
};

export type Wsdk_Test_RunsTotal_Pages_Group_Uniq_ArrayArgs = {
	limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Logical AND filter group for wsdk_test_runs queries. */
export type Wsdk_Test_RunsAndFilter = {
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Optional OR group within an AND group. */
	or?: InputMaybe<Array<Wsdk_Test_RunsOrFilter>>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
};

export enum Wsdk_Test_RunsGroup {
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum'
}

/** Logical OR filter group for wsdk_test_runs queries. */
export type Wsdk_Test_RunsOrFilter = {
	/** Optional AND group within an OR group. */
	and?: InputMaybe<Array<Wsdk_Test_RunsAndFilter>>;
	/** Equals (FieldName: best_practice_issues) */
	best_practice_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: best_practice_issues) */
	best_practice_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: best_practice_issues) */
	best_practice_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: best_practice_issues) */
	best_practice_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: best_practice_issues) */
	best_practice_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: best_practice_issues) */
	best_practice_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: critical_issues) */
	critical_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: critical_issues) */
	critical_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: critical_issues) */
	critical_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: critical_issues) */
	critical_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: critical_issues) */
	critical_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: critical_issues) */
	critical_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_key?: InputMaybe<SingleConditionString>;
	/** Tuple value equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_eq_tuple_value?: InputMaybe<SingleConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: custom_fields): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	custom_fields_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Tuple key not equals (case-insensitive) (FieldName: custom_fields): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	custom_fields_ne_tuple_key?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	environments_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: environments): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	environments_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_eq_any_item?: InputMaybe<ConditionString>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_eq_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ge_any_item?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ge_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_gt_any_item?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Greater than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_gt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_le_any_item?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than or equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_le_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_lt_any_item?: InputMaybe<ConditionString>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Less than (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_lt_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	flows_ne_any_item?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_all_values?: InputMaybe<ConditionStringArray>;
	/** Not equals (FieldName: flows): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	flows_ne_any_item_for_any_value?: InputMaybe<ConditionStringArray>;
	/** Equals (FieldName: minor_issues) */
	minor_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: minor_issues) */
	minor_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: minor_issues) */
	minor_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: minor_issues) */
	minor_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: minor_issues) */
	minor_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: minor_issues) */
	minor_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: moderate_issues) */
	moderate_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: moderate_issues) */
	moderate_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: moderate_issues) */
	moderate_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: moderate_issues) */
	moderate_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: moderate_issues) */
	moderate_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: moderate_issues) */
	moderate_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: needs_review_issues) */
	needs_review_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: needs_review_issues) */
	needs_review_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: needs_review_issues) */
	needs_review_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: needs_review_issues) */
	needs_review_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: needs_review_issues) */
	needs_review_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: needs_review_issues) */
	needs_review_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_eq_any_item?: InputMaybe<ConditionId>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_eq_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ge_any_item?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ge_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_gt_any_item?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Greater than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_gt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_le_any_item?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than or equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_le_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_lt_any_item?: InputMaybe<ConditionId>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Less than (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_lt_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field, if the values matches the condition on any of the items in the array, it will be considered a match */
	property_ids_ne_any_item?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If all of these values match the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_all_values?: InputMaybe<ConditionIdArray>;
	/** Not equals (FieldName: property_ids): This is an array type field. This condition accepts multiple values. If any of these values matches the condition on any of the items in the field, it will be considered a match. */
	property_ids_ne_any_item_for_any_value?: InputMaybe<ConditionIdArray>;
	/** Equals (FieldName: run_id) */
	run_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: run_id) */
	run_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: run_id) */
	run_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: run_id) */
	run_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: run_id) */
	run_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: run_id) */
	run_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: run_time) */
	run_time_eq?: InputMaybe<ConditionDateTime>;
	/** Greater than or equals (FieldName: run_time) */
	run_time_ge?: InputMaybe<ConditionDateTime>;
	/** Greater than (FieldName: run_time) */
	run_time_gt?: InputMaybe<ConditionDateTime>;
	/** Last n number of days filter (FieldName: run_time) */
	run_time_last_n_days?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: run_time) */
	run_time_le?: InputMaybe<ConditionDateTime>;
	/** Less than (FieldName: run_time) */
	run_time_lt?: InputMaybe<ConditionDateTime>;
	/** Not equals (FieldName: run_time) */
	run_time_ne?: InputMaybe<ConditionDateTime>;
	/** Equals (FieldName: serious_issues) */
	serious_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: serious_issues) */
	serious_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: serious_issues) */
	serious_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: serious_issues) */
	serious_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: serious_issues) */
	serious_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: serious_issues) */
	serious_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: tenant_id) */
	tenant_id_eq?: InputMaybe<ConditionId>;
	/** Greater than or equals (FieldName: tenant_id) */
	tenant_id_ge?: InputMaybe<ConditionId>;
	/** Greater than (FieldName: tenant_id) */
	tenant_id_gt?: InputMaybe<ConditionId>;
	/** Less than or equals (FieldName: tenant_id) */
	tenant_id_le?: InputMaybe<ConditionId>;
	/** Less than (FieldName: tenant_id) */
	tenant_id_lt?: InputMaybe<ConditionId>;
	/** Not equals (FieldName: tenant_id) */
	tenant_id_ne?: InputMaybe<ConditionId>;
	/** Equals (FieldName: test_name) */
	test_name_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_name) */
	test_name_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_name) */
	test_name_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_name) */
	test_name_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_name) */
	test_name_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_name) */
	test_name_ne?: InputMaybe<ConditionString>;
	/** Equals (FieldName: test_path) */
	test_path_eq?: InputMaybe<ConditionString>;
	/** Greater than or equals (FieldName: test_path) */
	test_path_ge?: InputMaybe<ConditionString>;
	/** Greater than (FieldName: test_path) */
	test_path_gt?: InputMaybe<ConditionString>;
	/** Less than or equals (FieldName: test_path) */
	test_path_le?: InputMaybe<ConditionString>;
	/** Less than (FieldName: test_path) */
	test_path_lt?: InputMaybe<ConditionString>;
	/** Not equals (FieldName: test_path) */
	test_path_ne?: InputMaybe<ConditionString>;
	text_contains?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_ends_with?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_equals?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	text_regex_match?: InputMaybe<Wsdk_Test_RunsSearch>;
	text_starts_with?: InputMaybe<Wsdk_Test_RunsSearchInsensitive>;
	/** Equals (FieldName: total_issues) */
	total_issues_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_issues) */
	total_issues_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_issues) */
	total_issues_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_issues) */
	total_issues_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_issues) */
	total_issues_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_issues) */
	total_issues_ne?: InputMaybe<ConditionInt>;
	/** Equals (FieldName: total_pages) */
	total_pages_eq?: InputMaybe<ConditionInt>;
	/** Greater than or equals (FieldName: total_pages) */
	total_pages_ge?: InputMaybe<ConditionInt>;
	/** Greater than (FieldName: total_pages) */
	total_pages_gt?: InputMaybe<ConditionInt>;
	/** Less than or equals (FieldName: total_pages) */
	total_pages_le?: InputMaybe<ConditionInt>;
	/** Less than (FieldName: total_pages) */
	total_pages_lt?: InputMaybe<ConditionInt>;
	/** Not equals (FieldName: total_pages) */
	total_pages_ne?: InputMaybe<ConditionInt>;
};

export type Wsdk_Test_RunsSearch = {
	searchFields: Array<Wsdk_Test_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wsdk_Test_RunsSearchInsensitive = {
	insensitive?: InputMaybe<Scalars['Boolean']['input']>;
	searchFields: Array<Wsdk_Test_RunsTextSearchFields>;
	searchValues: Array<Scalars['String']['input']>;
};

export type Wsdk_Test_RunsSort = {
	fields: Array<Wsdk_Test_RunsSortFields>;
	order?: InputMaybe<Wsdk_Test_RunsSortOrder>;
};

export enum Wsdk_Test_RunsSortFields {
	BestPracticeIssues = 'best_practice_issues',
	BestPracticeIssuesAny = 'best_practice_issues_any',
	BestPracticeIssuesCount = 'best_practice_issues_count',
	BestPracticeIssuesGroupUniqArray = 'best_practice_issues_group_uniq_array',
	BestPracticeIssuesMax = 'best_practice_issues_max',
	BestPracticeIssuesMin = 'best_practice_issues_min',
	BestPracticeIssuesSum = 'best_practice_issues_sum',
	CriticalIssues = 'critical_issues',
	CriticalIssuesAny = 'critical_issues_any',
	CriticalIssuesCount = 'critical_issues_count',
	CriticalIssuesGroupUniqArray = 'critical_issues_group_uniq_array',
	CriticalIssuesMax = 'critical_issues_max',
	CriticalIssuesMin = 'critical_issues_min',
	CriticalIssuesSum = 'critical_issues_sum',
	CustomFields = 'custom_fields',
	CustomFieldsAny = 'custom_fields_any',
	EnvironmentsAny = 'environments_any',
	FilteredCustomFields = 'filtered_custom_fields',
	FlowsAny = 'flows_any',
	MinorIssues = 'minor_issues',
	MinorIssuesAny = 'minor_issues_any',
	MinorIssuesCount = 'minor_issues_count',
	MinorIssuesGroupUniqArray = 'minor_issues_group_uniq_array',
	MinorIssuesMax = 'minor_issues_max',
	MinorIssuesMin = 'minor_issues_min',
	MinorIssuesSum = 'minor_issues_sum',
	ModerateIssues = 'moderate_issues',
	ModerateIssuesAny = 'moderate_issues_any',
	ModerateIssuesCount = 'moderate_issues_count',
	ModerateIssuesGroupUniqArray = 'moderate_issues_group_uniq_array',
	ModerateIssuesMax = 'moderate_issues_max',
	ModerateIssuesMin = 'moderate_issues_min',
	ModerateIssuesSum = 'moderate_issues_sum',
	NeedsReviewIssues = 'needs_review_issues',
	NeedsReviewIssuesAny = 'needs_review_issues_any',
	NeedsReviewIssuesCount = 'needs_review_issues_count',
	NeedsReviewIssuesGroupUniqArray = 'needs_review_issues_group_uniq_array',
	NeedsReviewIssuesMax = 'needs_review_issues_max',
	NeedsReviewIssuesMin = 'needs_review_issues_min',
	NeedsReviewIssuesSum = 'needs_review_issues_sum',
	PropertyIdsAny = 'property_ids_any',
	RunId = 'run_id',
	RunIdAny = 'run_id_any',
	RunIdCount = 'run_id_count',
	RunIdGroupUniqArray = 'run_id_group_uniq_array',
	RunTime = 'run_time',
	RunTimeAny = 'run_time_any',
	RunTimeCount = 'run_time_count',
	RunTimeGroupUniqArray = 'run_time_group_uniq_array',
	RunTimeMax = 'run_time_max',
	RunTimeMin = 'run_time_min',
	RunTimeTruncDay = 'run_time_truncDay',
	RunTimeTruncMonth = 'run_time_truncMonth',
	RunTimeTruncYear = 'run_time_truncYear',
	SeriousIssues = 'serious_issues',
	SeriousIssuesAny = 'serious_issues_any',
	SeriousIssuesCount = 'serious_issues_count',
	SeriousIssuesGroupUniqArray = 'serious_issues_group_uniq_array',
	SeriousIssuesMax = 'serious_issues_max',
	SeriousIssuesMin = 'serious_issues_min',
	SeriousIssuesSum = 'serious_issues_sum',
	TenantId = 'tenant_id',
	TenantIdAny = 'tenant_id_any',
	TenantIdCount = 'tenant_id_count',
	TenantIdGroupUniqArray = 'tenant_id_group_uniq_array',
	TestName = 'test_name',
	TestNameAny = 'test_name_any',
	TestNameCount = 'test_name_count',
	TestNameGroupUniqArray = 'test_name_group_uniq_array',
	TestNameMax = 'test_name_max',
	TestNameMin = 'test_name_min',
	TestPath = 'test_path',
	TestPathAny = 'test_path_any',
	TestPathCount = 'test_path_count',
	TestPathGroupUniqArray = 'test_path_group_uniq_array',
	TestPathMax = 'test_path_max',
	TestPathMin = 'test_path_min',
	TotalIssues = 'total_issues',
	TotalIssuesAny = 'total_issues_any',
	TotalIssuesCount = 'total_issues_count',
	TotalIssuesGroupUniqArray = 'total_issues_group_uniq_array',
	TotalIssuesMax = 'total_issues_max',
	TotalIssuesMin = 'total_issues_min',
	TotalIssuesSum = 'total_issues_sum',
	TotalPages = 'total_pages',
	TotalPagesAny = 'total_pages_any',
	TotalPagesCount = 'total_pages_count',
	TotalPagesGroupUniqArray = 'total_pages_group_uniq_array',
	TotalPagesMax = 'total_pages_max',
	TotalPagesMin = 'total_pages_min',
	TotalPagesSum = 'total_pages_sum'
}

/** An example enum type */
export enum Wsdk_Test_RunsSortOrder {
	Ascending = 'Ascending',
	Descending = 'Descending'
}

export enum Wsdk_Test_RunsTextSearchFields {
	BestPracticeIssues = 'best_practice_issues',
	CriticalIssues = 'critical_issues',
	CustomFields = 'custom_fields',
	Environments = 'environments',
	FilteredCustomFields = 'filtered_custom_fields',
	Flows = 'flows',
	MinorIssues = 'minor_issues',
	ModerateIssues = 'moderate_issues',
	NeedsReviewIssues = 'needs_review_issues',
	PropertyIds = 'property_ids',
	RunId = 'run_id',
	RunTime = 'run_time',
	SeriousIssues = 'serious_issues',
	TenantId = 'tenant_id',
	TestName = 'test_name',
	TestPath = 'test_path',
	TotalIssues = 'total_issues',
	TotalPages = 'total_pages'
}
